// ------------------------------------ 埋点事件
(function initReportEvent() {
	function initImpressionProduct() {
		document.addEventListener('impress:productItem', (event) => {
			const product_option = event.detail
			const uid = window.ogl_uid || '';

			Shopify.analytics.publish('impression', {
				platform_product_id: product_option.id,
				uid: uid,
				path: window.location.pathname
			});
		});
	}

	initImpressionProduct()

	// option select event
	document.addEventListener('click', function (event) {
		if (event.target.closest('.t4s-swatch__list .t4s-swatch__item')) {
			const productForm = document.querySelector('form[data-product-id]');
			const productId = productForm.getAttribute('data-product-id');
			const uid = window.ogl_uid || '';
			const variantId = window.getUrlParam('variant');

			Shopify.analytics.publish('click_option', {
				platform_product_id: productId,
				uid: uid,
				variant_id: variantId
			});
		}
	})

	// 使用事件委托处理动态加载的商品
	document.addEventListener(
		'click',
		function (event) {
			const productLink = event.target.closest('a[href*="/products/"]');
			const isWishListBtn =
				productLink?.classList.contains('t4s-pr-wishlist');
			if (productLink && !isWishListBtn) {
				// 阻止默认跳转以便完成数据发送（可选）
				//event.preventDefault();

				// 从附近元素获取商品信息
				const productCard = productLink.closest('.t4s-product');
				if (!productCard?.dataset.productOptions) return;
				const productId = JSON.parse(
					productCard?.dataset.productOptions
				).id;
				const uid = window.ogl_uid || '';
				// 发布点击事件
				Shopify.analytics.publish('product_clicked', {
					platform_product_id: productId,
					uid: uid,
					path: productLink.href
				});
				// 跳转到目标商品页面
				window.location.href = productLink.href;
			}
		},
		{ passive: true }
	);
})()

// Floating UI Core：计算浮层位置，并提供 offset、flip、shift、arrow 等定位中间件。
!function (e, t) {
	"object" == typeof exports && "undefined" != typeof module ? t(exports) : "function" == typeof define && define.amd ? define(["exports"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).FloatingUIT4sCore = {})
}(this, function (e) {
	"use strict";
	function t(e) {
		return e.split("-")[0]
	}
	function n(e) {
		return e.split("-")[1]
	}
	function i(e) {
		return ["top", "bottom"].includes(t(e)) ? "x" : "y"
	}
	function o(e) {
		return "y" === e ? "height" : "width"
	}
	function a(e, a, r) {
		let { reference: s, floating: l } = e;
		const c = s.x + s.width / 2 - l.width / 2
			, d = s.y + s.height / 2 - l.height / 2
			, u = i(a)
			, p = o(u)
			, m = s[p] / 2 - l[p] / 2
			, f = "x" === u;
		let h;
		switch (t(a)) {
			case "top":
				h = {
					x: c,
					y: s.y - l.height
				};
				break;
			case "bottom":
				h = {
					x: c,
					y: s.y + s.height
				};
				break;
			case "right":
				h = {
					x: s.x + s.width,
					y: d
				};
				break;
			case "left":
				h = {
					x: s.x - l.width,
					y: d
				};
				break;
			default:
				h = {
					x: s.x,
					y: s.y
				}
		}
		switch (n(a)) {
			case "start":
				h[u] -= m * (r && f ? -1 : 1);
				break;
			case "end":
				h[u] += m * (r && f ? -1 : 1)
		}
		return h
	}
	function r(e) {
		return "number" != typeof e ? function (e) {
			return {
				top: 0,
				right: 0,
				bottom: 0,
				left: 0,
				...e
			}
		}(e) : {
			top: e,
			right: e,
			bottom: e,
			left: e
		}
	}
	function s(e) {
		return {
			...e,
			top: e.y,
			left: e.x,
			right: e.x + e.width,
			bottom: e.y + e.height
		}
	}
	async function l(e, t) {
		var n;
		void 0 === t && (t = {});
		const { x: i, y: o, platform: a, rects: l, elements: c, strategy: d } = e
			, { boundary: u = "clippingAncestors", rootBoundary: p = "viewport", elementContext: m = "floating", altBoundary: f = !1, padding: h = 0 } = t
			, g = r(h)
			, v = c[f ? "floating" === m ? "reference" : "floating" : m]
			, y = s(await a.getClippingRect({
				element: null == (n = await (null == a.isElement ? void 0 : a.isElement(v))) || n ? v : v.contextElement || await (null == a.getDocumentElement ? void 0 : a.getDocumentElement(c.floating)),
				boundary: u,
				rootBoundary: p
			}))
			, w = s(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
				rect: "floating" === m ? {
					...l.floating,
					x: i,
					y: o
				} : l.reference,
				offsetParent: await (null == a.getOffsetParent ? void 0 : a.getOffsetParent(c.floating)),
				strategy: d
			}) : l[m]);
		return {
			top: y.top - w.top + g.top,
			bottom: w.bottom - y.bottom + g.bottom,
			left: y.left - w.left + g.left,
			right: w.right - y.right + g.right
		}
	}
	function c(e, t, n) {
		return v(e, g(t, n))
	}
	function d(e) {
		return e.replace(/left|right|bottom|top/g, e => y[e])
	}
	function u(e, t, a) {
		void 0 === a && (a = !1);
		const r = n(e)
			, s = i(e)
			, l = o(s);
		let c = "x" === s ? r === (a ? "end" : "start") ? "right" : "left" : "start" === r ? "bottom" : "top";
		return t.reference[l] > t.floating[l] && (c = d(c)),
		{
			main: c,
			cross: d(c)
		}
	}
	function p(e) {
		return e.replace(/start|end/g, e => w[e])
	}
	function m(e, t) {
		return {
			top: e.top - t.height,
			right: e.right - t.width,
			bottom: e.bottom - t.height,
			left: e.left - t.width
		}
	}
	function f(e) {
		return T.some(t => e[t] >= 0)
	}
	function h(e) {
		return "x" === e ? "y" : "x"
	}
	const g = Math.min
		, v = Math.max
		, y = {
			left: "right",
			right: "left",
			bottom: "top",
			top: "bottom"
		}
		, w = {
			start: "end",
			end: "start"
		}
		, T = ["top", "right", "bottom", "left"]
		, S = T.reduce((e, t) => e.concat(t, t + "-start", t + "-end"), []);
	e.arrow = (e => ({
		name: "arrow",
		options: e,
		async fn(t) {
			const { element: n, padding: a = 0 } = null != e ? e : {}
				, { x: s, y: l, placement: d, rects: u, platform: p } = t;
			if (null == n)
				return {};
			const m = r(a)
				, f = {
					x: s,
					y: l
				}
				, h = i(d)
				, g = o(h)
				, v = await p.getDimensions(n)
				, y = "y" === h ? "top" : "left"
				, w = "y" === h ? "bottom" : "right"
				, T = u.reference[g] + u.reference[h] - f[h] - u.floating[g]
				, S = f[h] - u.reference[h]
				, b = await (null == p.getOffsetParent ? void 0 : p.getOffsetParent(n))
				, x = b ? "y" === h ? b.clientHeight || 0 : b.clientWidth || 0 : 0
				, _ = T / 2 - S / 2
				, C = m[y]
				, P = x - v[g] - m[w]
				, k = x / 2 - v[g] / 2 + _
				, I = c(C, k, P);
			return {
				data: {
					[h]: I,
					centerOffset: k - I
				}
			}
		}
	})),
		e.autoPlacement = function (e) {
			return void 0 === e && (e = {}),
			{
				name: "autoPlacement",
				options: e,
				async fn(i) {
					var o, a, r, s, c;
					const { x: d, y: m, rects: f, middlewareData: h, placement: g, platform: v, elements: y } = i
						, { alignment: w = null, allowedPlacements: T = S, autoAlignment: b = !0, ...x } = e
						, _ = function (e, i, o) {
							return (e ? [...o.filter(t => n(t) === e), ...o.filter(t => n(t) !== e)] : o.filter(e => t(e) === e)).filter(t => !e || n(t) === e || !!i && p(t) !== t)
						}(w, b, T)
						, C = await l(i, x)
						, P = null != (o = null == (a = h.autoPlacement) ? void 0 : a.index) ? o : 0
						, k = _[P]
						, { main: I, cross: D } = u(k, f, await (null == v.isRTL ? void 0 : v.isRTL(y.floating)));
					if (g !== k)
						return {
							x: d,
							y: m,
							reset: {
								skip: !1,
								placement: _[0]
							}
						};
					const A = [C[t(k)], C[I], C[D]]
						, M = [...null != (r = null == (s = h.autoPlacement) ? void 0 : s.overflows) ? r : [], {
							placement: k,
							overflows: A
						}]
						, O = _[P + 1];
					if (O)
						return {
							data: {
								index: P + 1,
								overflows: M
							},
							reset: {
								skip: !1,
								placement: O
							}
						};
					const E = M.slice().sort((e, t) => e.overflows[0] - t.overflows[0])
						, $ = null == (c = E.find(e => {
							let { overflows: t } = e;
							return t.every(e => e <= 0)
						}
						)) ? void 0 : c.placement;
					return {
						reset: {
							placement: null != $ ? $ : E[0].placement
						}
					}
				}
			}
		}
		,
		e.computePosition = (async (e, t, n) => {
			const { placement: i = "bottom", strategy: o = "absolute", middleware: r = [], platform: s } = n
				, l = await (null == s.isRTL ? void 0 : s.isRTL(t));
			let c = await s.getElementRects({
				reference: e,
				floating: t,
				strategy: o
			})
				, { x: d, y: u } = a(c, i, l)
				, p = i
				, m = {};
			const f = new Set;
			for (let n = 0; n < r.length; n++) {
				const { name: h, fn: g } = r[n];
				if (f.has(h))
					continue;
				const { x: v, y: y, data: w, reset: T } = await g({
					x: d,
					y: u,
					initialPlacement: i,
					placement: p,
					strategy: o,
					middlewareData: m,
					rects: c,
					platform: s,
					elements: {
						reference: e,
						floating: t
					}
				});
				d = null != v ? v : d,
					u = null != y ? y : u,
					m = {
						...m,
						[h]: {
							...m[h],
							...w
						}
					},
					T && ("object" == typeof T && (T.placement && (p = T.placement),
						T.rects && (c = !0 === T.rects ? await s.getElementRects({
							reference: e,
							floating: t,
							strategy: o
						}) : T.rects),
						({ x: d, y: u } = a(c, p, l)),
						!1 !== T.skip && f.add(h)),
						n = -1)
			}
			return {
				x: d,
				y: u,
				placement: p,
				strategy: o,
				middlewareData: m
			}
		}
		),
		e.detectOverflow = l,
		e.flip = function (e) {
			return void 0 === e && (e = {}),
			{
				name: "flip",
				options: e,
				async fn(n) {
					var i;
					const { placement: o, middlewareData: a, rects: r, initialPlacement: s, platform: c, elements: m } = n
						, { mainAxis: f = !0, crossAxis: h = !0, fallbackPlacements: g, fallbackStrategy: v = "bestFit", flipAlignment: y = !0, ...w } = e
						, T = t(o)
						, S = [s, ...g || (T !== s && y ? function (e) {
							const t = d(e);
							return [p(e), t, p(t)]
						}(s) : [d(s)])]
						, b = await l(n, w)
						, x = [];
					let _ = (null == (i = a.flip) ? void 0 : i.overflows) || [];
					if (f && x.push(b[T]),
						h) {
						const { main: e, cross: t } = u(o, r, await (null == c.isRTL ? void 0 : c.isRTL(m.floating)));
						x.push(b[e], b[t])
					}
					if (_ = [..._, {
						placement: o,
						overflows: x
					}],
						!x.every(e => e <= 0)) {
						var C, P;
						const e = (null != (C = null == (P = a.flip) ? void 0 : P.index) ? C : 0) + 1
							, t = S[e];
						if (t)
							return {
								data: {
									index: e,
									overflows: _
								},
								reset: {
									skip: !1,
									placement: t
								}
							};
						let n = "bottom";
						switch (v) {
							case "bestFit":
								{
									var k;
									const e = null == (k = _.slice().sort((e, t) => e.overflows.filter(e => e > 0).reduce((e, t) => e + t, 0) - t.overflows.filter(e => e > 0).reduce((e, t) => e + t, 0))[0]) ? void 0 : k.placement;
									e && (n = e);
									break
								}
							case "initialPlacement":
								n = s
						}
						return {
							reset: {
								placement: n
							}
						}
					}
					return {}
				}
			}
		}
		,
		e.hide = function (e) {
			let { strategy: t = "referenceHidden", ...n } = void 0 === e ? {} : e;
			return {
				name: "hide",
				async fn(e) {
					const { rects: i } = e;
					switch (t) {
						case "referenceHidden":
							{
								const t = m(await l(e, {
									...n,
									elementContext: "reference"
								}), i.reference);
								return {
									data: {
										referenceHiddenOffsets: t,
										referenceHidden: f(t)
									}
								}
							}
						case "escaped":
							{
								const t = m(await l(e, {
									...n,
									altBoundary: !0
								}), i.floating);
								return {
									data: {
										escapedOffsets: t,
										escaped: f(t)
									}
								}
							}
						default:
							return {}
					}
				}
			}
		}
		,
		e.inline = function (e) {
			return void 0 === e && (e = {}),
			{
				name: "inline",
				options: e,
				async fn(n) {
					var o;
					const { placement: a, elements: l, rects: c, platform: d, strategy: u } = n
						, { padding: p = 2, x: m, y: f } = e
						, h = s(d.convertOffsetParentRelativeRectToViewportRelativeRect ? await d.convertOffsetParentRelativeRectToViewportRelativeRect({
							rect: c.reference,
							offsetParent: await (null == d.getOffsetParent ? void 0 : d.getOffsetParent(l.floating)),
							strategy: u
						}) : c.reference)
						, y = null != (o = await (null == d.getClientRects ? void 0 : d.getClientRects(l.reference))) ? o : []
						, w = r(p);
					return {
						reset: {
							rects: await d.getElementRects({
								reference: {
									getBoundingClientRect: function () {
										var e;
										if (2 === y.length && y[0].left > y[1].right && null != m && null != f)
											return null != (e = y.find(e => m > e.left - w.left && m < e.right + w.right && f > e.top - w.top && f < e.bottom + w.bottom)) ? e : h;
										if (y.length >= 2) {
											if ("x" === i(a)) {
												const e = y[0]
													, n = y[y.length - 1]
													, i = "top" === t(a)
													, o = e.top
													, r = n.bottom
													, s = i ? e.left : n.left
													, l = i ? e.right : n.right;
												return {
													top: o,
													bottom: r,
													left: s,
													right: l,
													width: l - s,
													height: r - o,
													x: s,
													y: o
												}
											}
											const e = "left" === t(a)
												, n = v(...y.map(e => e.right))
												, o = g(...y.map(e => e.left))
												, r = y.filter(t => e ? t.left === o : t.right === n)
												, s = r[0].top
												, l = r[r.length - 1].bottom;
											return {
												top: s,
												bottom: l,
												left: o,
												right: n,
												width: n - o,
												height: l - s,
												x: o,
												y: s
											}
										}
										return h
									}
								},
								floating: l.floating,
								strategy: u
							})
						}
					}
				}
			}
		}
		,
		e.limitShift = function (e) {
			return void 0 === e && (e = {}),
			{
				options: e,
				fn(n) {
					const { x: o, y: a, placement: r, rects: s, middlewareData: l } = n
						, { offset: c = 0, mainAxis: d = !0, crossAxis: u = !0 } = e
						, p = {
							x: o,
							y: a
						}
						, m = i(r)
						, f = h(m);
					let g = p[m]
						, v = p[f];
					const y = "function" == typeof c ? c({
						...s,
						placement: r
					}) : c
						, w = "number" == typeof y ? {
							mainAxis: y,
							crossAxis: 0
						} : {
							mainAxis: 0,
							crossAxis: 0,
							...y
						};
					if (d) {
						const e = "y" === m ? "height" : "width"
							, t = s.reference[m] - s.floating[e] + w.mainAxis
							, n = s.reference[m] + s.reference[e] - w.mainAxis;
						g < t ? g = t : g > n && (g = n)
					}
					if (u) {
						var T, S, b, x;
						const e = "y" === m ? "width" : "height"
							, n = ["top", "left"].includes(t(r))
							, i = s.reference[f] - s.floating[e] + (n && null != (T = null == (S = l.offset) ? void 0 : S[f]) ? T : 0) + (n ? 0 : w.crossAxis)
							, o = s.reference[f] + s.reference[e] + (n ? 0 : null != (b = null == (x = l.offset) ? void 0 : x[f]) ? b : 0) - (n ? w.crossAxis : 0);
						v < i ? v = i : v > o && (v = o)
					}
					return {
						[m]: g,
						[f]: v
					}
				}
			}
		}
		,
		e.offset = function (e) {
			return void 0 === e && (e = 0),
			{
				name: "offset",
				options: e,
				async fn(o) {
					const { x: a, y: r, placement: s, rects: l, platform: c, elements: d } = o
						, u = function (e, o, a, r) {
							void 0 === r && (r = !1);
							const s = t(e)
								, l = n(e)
								, c = "x" === i(e)
								, d = ["left", "top"].includes(s) ? -1 : 1;
							let u = 1;
							"end" === l && (u = -1),
								r && c && (u *= -1);
							const p = "function" == typeof a ? a({
								...o,
								placement: e
							}) : a
								, { mainAxis: m, crossAxis: f } = "number" == typeof p ? {
									mainAxis: p,
									crossAxis: 0
								} : {
									mainAxis: 0,
									crossAxis: 0,
									...p
								};
							return c ? {
								x: f * u,
								y: m * d
							} : {
								x: m * d,
								y: f * u
							}
						}(s, l, e, await (null == c.isRTL ? void 0 : c.isRTL(d.floating)));
					return {
						x: a + u.x,
						y: r + u.y,
						data: u
					}
				}
			}
		}
		,
		e.rectToClientRect = s,
		e.shift = function (e) {
			return void 0 === e && (e = {}),
			{
				name: "shift",
				options: e,
				async fn(n) {
					const { x: o, y: a, placement: r } = n
						, { mainAxis: s = !0, crossAxis: d = !1, limiter: u = {
							fn: e => {
								let { x: t, y: n } = e;
								return {
									x: t,
									y: n
								}
							}
						}, ...p } = e
						, m = {
							x: o,
							y: a
						}
						, f = await l(n, p)
						, g = i(t(r))
						, v = h(g);
					let y = m[g]
						, w = m[v];
					if (s) {
						const e = "y" === g ? "bottom" : "right";
						y = c(y + f["y" === g ? "top" : "left"], y, y - f[e])
					}
					if (d) {
						const e = "y" === v ? "bottom" : "right";
						w = c(w + f["y" === v ? "top" : "left"], w, w - f[e])
					}
					const T = u.fn({
						...n,
						[g]: y,
						[v]: w
					});
					return {
						...T,
						data: {
							x: T.x - o,
							y: T.y - a
						}
					}
				}
			}
		}
		,
		e.size = function (e) {
			return void 0 === e && (e = {}),
			{
				name: "size",
				options: e,
				async fn(i) {
					const { placement: o, rects: a, platform: r, elements: s } = i
						, { apply: c, ...d } = e
						, u = await l(i, d)
						, p = t(o)
						, m = n(o);
					let f, h;
					"top" === p || "bottom" === p ? (f = p,
						h = m === (await (null == r.isRTL ? void 0 : r.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (h = p,
							f = "end" === m ? "top" : "bottom");
					const g = v(u.left, 0)
						, y = v(u.right, 0)
						, w = v(u.top, 0)
						, T = v(u.bottom, 0)
						, S = {
							height: a.floating.height - (["left", "right"].includes(o) ? 2 * (0 !== w || 0 !== T ? w + T : v(u.top, u.bottom)) : u[f]),
							width: a.floating.width - (["top", "bottom"].includes(o) ? 2 * (0 !== g || 0 !== y ? g + y : v(u.left, u.right)) : u[h])
						};
					return null == c || c({
						...S,
						...a
					}),
					{
						reset: {
							rects: !0
						}
					}
				}
			}
		}
		,
		Object.defineProperty(e, "__esModule", {
			value: !0
		})
}),
	// Floating UI DOM：连接 Floating UI Core 与浏览器 DOM，负责元素测量和位置更新。
	function (e, t) {
		"object" == typeof exports && "undefined" != typeof module ? t(exports, require("@floating-ui/core")) : "function" == typeof define && define.amd ? define(["exports", "@floating-ui/core"], t) : t((e = "undefined" != typeof globalThis ? globalThis : e || self).FloatingUIT4sDOM = {}, e.FloatingUIT4sCore)
	}(this, function (e, t) {
		"use strict";
		function n(e) {
			return "[object Window]" === (null == e ? void 0 : e.toString())
		}
		function i(e) {
			if (null == e)
				return window;
			if (!n(e)) {
				const t = e.ownerDocument;
				return t && t.defaultView || window
			}
			return e
		}
		function o(e) {
			return i(e).getComputedStyle(e)
		}
		function a(e) {
			return n(e) ? "" : e ? (e.nodeName || "").toLowerCase() : ""
		}
		function r(e) {
			return e instanceof i(e).HTMLElement
		}
		function s(e) {
			return e instanceof i(e).Element
		}
		function l(e) {
			return e instanceof i(e).ShadowRoot || e instanceof ShadowRoot
		}
		function c(e) {
			const { overflow: t, overflowX: n, overflowY: i } = o(e);
			return /auto|scroll|overlay|hidden/.test(t + i + n)
		}
		function d(e) {
			return ["table", "td", "th"].includes(a(e))
		}
		function u(e) {
			const t = navigator.userAgent.toLowerCase().includes("firefox")
				, n = o(e);
			return "none" !== n.transform || "none" !== n.perspective || "paint" === n.contain || ["transform", "perspective"].includes(n.willChange) || t && "filter" === n.willChange || t && !!n.filter && "none" !== n.filter
		}
		function p(e, t) {
			void 0 === t && (t = !1);
			const n = e.getBoundingClientRect();
			let i = 1
				, o = 1;
			return t && r(e) && (i = e.offsetWidth > 0 && C(n.width) / e.offsetWidth || 1,
				o = e.offsetHeight > 0 && C(n.height) / e.offsetHeight || 1),
			{
				width: n.width / i,
				height: n.height / o,
				top: n.top / o,
				right: n.right / i,
				bottom: n.bottom / o,
				left: n.left / i,
				x: n.left / i,
				y: n.top / o
			}
		}
		function m(e) {
			return (t = e,
				(t instanceof i(t).Node ? e.ownerDocument : e.document) || window.document).documentElement;
			var t
		}
		function f(e) {
			return n(e) ? {
				scrollLeft: e.pageXOffset,
				scrollTop: e.pageYOffset
			} : {
				scrollLeft: e.scrollLeft,
				scrollTop: e.scrollTop
			}
		}
		function h(e) {
			return p(m(e)).left + f(e).scrollLeft
		}
		function g(e) {
			return "html" === a(e) ? e : e.assignedSlot || e.parentNode || (l(e) ? e.host : null) || m(e)
		}
		function v(e) {
			return r(e) && "fixed" !== getComputedStyle(e).position ? e.offsetParent : null
		}
		function y(e) {
			const t = i(e);
			let n = v(e);
			for (; n && d(n) && "static" === getComputedStyle(n).position;)
				n = v(n);
			return n && ("html" === a(n) || "body" === a(n) && "static" === getComputedStyle(n).position && !u(n)) ? t : n || function (e) {
				let t = g(e);
				for (l(t) && (t = t.host); r(t) && !["html", "body"].includes(a(t));) {
					if (u(t))
						return t;
					t = t.parentNode
				}
				return null
			}(e) || t
		}
		function w(e) {
			if (r(e))
				return {
					width: e.offsetWidth,
					height: e.offsetHeight
				};
			const t = p(e);
			return {
				width: t.width,
				height: t.height
			}
		}
		function T(e, t) {
			var n;
			void 0 === t && (t = []);
			const o = function e(t) {
				return ["html", "body", "#document"].includes(a(t)) ? t.ownerDocument.body : r(t) && c(t) ? t : e(g(t))
			}(e)
				, s = o === (null == (n = e.ownerDocument) ? void 0 : n.body)
				, l = i(o)
				, d = s ? [l].concat(l.visualViewport || [], c(o) ? o : []) : o
				, u = t.concat(d);
			return s ? u : u.concat(T(g(d)))
		}
		function S(e, n) {
			return "viewport" === n ? t.rectToClientRect(function (e) {
				const t = i(e)
					, n = m(e)
					, o = t.visualViewport;
				let a = n.clientWidth
					, r = n.clientHeight
					, s = 0
					, l = 0;
				return o && (a = o.width,
					r = o.height,
					Math.abs(t.innerWidth / o.scale - o.width) < .01 && (s = o.offsetLeft,
						l = o.offsetTop)),
				{
					width: a,
					height: r,
					x: s,
					y: l
				}
			}(e)) : s(n) ? function (e) {
				const t = p(e)
					, n = t.top + e.clientTop
					, i = t.left + e.clientLeft;
				return {
					top: n,
					left: i,
					x: i,
					y: n,
					right: i + e.clientWidth,
					bottom: n + e.clientHeight,
					width: e.clientWidth,
					height: e.clientHeight
				}
			}(n) : t.rectToClientRect(function (e) {
				var t;
				const n = m(e)
					, i = f(e)
					, a = null == (t = e.ownerDocument) ? void 0 : t.body
					, r = _(n.scrollWidth, n.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0)
					, s = _(n.scrollHeight, n.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0);
				let l = -i.scrollLeft + h(e);
				const c = -i.scrollTop;
				return "rtl" === o(a || n).direction && (l += _(n.clientWidth, a ? a.clientWidth : 0) - r),
				{
					width: r,
					height: s,
					x: l,
					y: c
				}
			}(m(e)))
		}
		function b(e) {
			const t = T(g(e))
				, n = ["absolute", "fixed"].includes(o(e).position) && r(e) ? y(e) : e;
			return s(n) ? t.filter(e => s(e) && function (e, t) {
				const n = null == t.getRootNode ? void 0 : t.getRootNode();
				if (e.contains(t))
					return !0;
				if (n && l(n)) {
					let n = t;
					do {
						if (n && e === n)
							return !0;
						n = n.parentNode || n.host
					} while (n)
				}
				return !1
			}(e, n) && "body" !== a(e)) : []
		}
		const x = Math.min
			, _ = Math.max
			, C = Math.round
			, P = {
				getClippingRect: function (e) {
					let { element: t, boundary: n, rootBoundary: i } = e;
					const o = [..."clippingAncestors" === n ? b(t) : [].concat(n), i]
						, a = o[0]
						, r = o.reduce((e, n) => {
							const i = S(t, n);
							return e.top = _(i.top, e.top),
								e.right = x(i.right, e.right),
								e.bottom = x(i.bottom, e.bottom),
								e.left = _(i.left, e.left),
								e
						}
							, S(t, a));
					return {
						width: r.right - r.left,
						height: r.bottom - r.top,
						x: r.left,
						y: r.top
					}
				},
				convertOffsetParentRelativeRectToViewportRelativeRect: function (e) {
					let { rect: t, offsetParent: n, strategy: i } = e;
					const o = r(n)
						, s = m(n);
					if (n === s)
						return t;
					let l = {
						scrollLeft: 0,
						scrollTop: 0
					};
					const d = {
						x: 0,
						y: 0
					};
					if ((o || !o && "fixed" !== i) && (("body" !== a(n) || c(s)) && (l = f(n)),
						r(n))) {
						const e = p(n, !0);
						d.x = e.x + n.clientLeft,
							d.y = e.y + n.clientTop
					}
					return {
						...t,
						x: t.x - l.scrollLeft + d.x,
						y: t.y - l.scrollTop + d.y
					}
				},
				isElement: s,
				getDimensions: w,
				getOffsetParent: y,
				getDocumentElement: m,
				getElementRects: e => {
					let { reference: t, floating: n, strategy: i } = e;
					return {
						reference: function (e, t, n) {
							const i = r(t)
								, o = m(t)
								, s = p(e, i && function (e) {
									const t = p(e);
									return C(t.width) !== e.offsetWidth || C(t.height) !== e.offsetHeight
								}(t));
							let l = {
								scrollLeft: 0,
								scrollTop: 0
							};
							const d = {
								x: 0,
								y: 0
							};
							if (i || !i && "fixed" !== n)
								if (("body" !== a(t) || c(o)) && (l = f(t)),
									r(t)) {
									const e = p(t, !0);
									d.x = e.x + t.clientLeft,
										d.y = e.y + t.clientTop
								} else
									o && (d.x = h(o));
							return {
								x: s.left + l.scrollLeft - d.x,
								y: s.top + l.scrollTop - d.y,
								width: s.width,
								height: s.height
							}
						}(t, y(n), i),
						floating: {
							...w(n),
							x: 0,
							y: 0
						}
					}
				}
				,
				getClientRects: e => Array.from(e.getClientRects()),
				isRTL: e => "rtl" === o(e).direction
			};
		Object.defineProperty(e, "arrow", {
			enumerable: !0,
			get: function () {
				return t.arrow
			}
		}),
			Object.defineProperty(e, "autoPlacement", {
				enumerable: !0,
				get: function () {
					return t.autoPlacement
				}
			}),
			Object.defineProperty(e, "detectOverflow", {
				enumerable: !0,
				get: function () {
					return t.detectOverflow
				}
			}),
			Object.defineProperty(e, "flip", {
				enumerable: !0,
				get: function () {
					return t.flip
				}
			}),
			Object.defineProperty(e, "hide", {
				enumerable: !0,
				get: function () {
					return t.hide
				}
			}),
			Object.defineProperty(e, "inline", {
				enumerable: !0,
				get: function () {
					return t.inline
				}
			}),
			Object.defineProperty(e, "limitShift", {
				enumerable: !0,
				get: function () {
					return t.limitShift
				}
			}),
			Object.defineProperty(e, "offset", {
				enumerable: !0,
				get: function () {
					return t.offset
				}
			}),
			Object.defineProperty(e, "shift", {
				enumerable: !0,
				get: function () {
					return t.shift
				}
			}),
			Object.defineProperty(e, "size", {
				enumerable: !0,
				get: function () {
					return t.size
				}
			}),
			e.autoUpdate = function (e, t, n, i) {
				void 0 === i && (i = {});
				const { ancestorScroll: o = !0, ancestorResize: a = !0, elementResize: r = !0, animationFrame: l = !1 } = i;
				let c = !1;
				const d = o && !l
					, u = a && !l
					, m = r && !l
					, f = d || u ? [...s(e) ? T(e) : [], ...T(t)] : [];
				f.forEach(e => {
					d && e.addEventListener("scroll", n, {
						passive: !0
					}),
						u && e.addEventListener("resize", n)
				}
				);
				let h, g = null;
				m && (g = new ResizeObserver(n),
					s(e) && g.observe(e),
					g.observe(t));
				let v = l ? p(e) : null;
				return l && function t() {
					if (c)
						return;
					const i = p(e);
					!v || i.x === v.x && i.y === v.y && i.width === v.width && i.height === v.height || n(),
						v = i,
						h = requestAnimationFrame(t)
				}(),
					() => {
						var e;
						c = !0,
							f.forEach(e => {
								d && e.removeEventListener("scroll", n),
									u && e.removeEventListener("resize", n)
							}
							),
							null == (e = g) || e.disconnect(),
							g = null,
							l && cancelAnimationFrame(h)
					}
			}
			,
			e.computePosition = ((e, n, i) => t.computePosition(e, n, {
				platform: P,
				...i
			})),
			e.getOverflowAncestors = T,
			Object.defineProperty(e, "__esModule", {
				value: !0
			})
	}),
	// jQuery hoverIntent：识别用户的有效悬停，避免鼠标短暂经过时误触发交互。
	function (e) {
		"use strict";
		"function" == typeof define && define.amd ? define(["jQuery_T4NT"], e) : "object" == typeof module && module.exports ? module.exports = e(require("jQuery_T4NT")) : jQuery_T4NT && !jQuery_T4NT.fn.hoverIntent && e(jQuery_T4NT)
	}(function (e) {
		"use strict";
		function t(e) {
			i = e.pageX,
				o = e.pageY
		}
		function n(e) {
			return "function" == typeof e
		}
		var i, o, a = {
			interval: 100,
			sensitivity: 6,
			timeout: 0
		}, r = 0, s = function (e, n, a, r) {
			if (Math.sqrt((a.pX - i) * (a.pX - i) + (a.pY - o) * (a.pY - o)) < r.sensitivity)
				return n.off(a.event, t),
					delete a.timeoutId,
					a.isActive = !0,
					e.pageX = i,
					e.pageY = o,
					delete a.pX,
					delete a.pY,
					r.over.apply(n[0], [e]);
			a.pX = i,
				a.pY = o,
				a.timeoutId = setTimeout(function () {
					s(e, n, a, r)
				}, r.interval)
		};
		e.fn.hoverIntent = function (i, o, l) {
			function c(n) {
				var i = e.extend({}, n)
					, o = e(this)
					, a = o.data("hoverIntent");
				a || o.data("hoverIntent", a = {});
				var r = a[d];
				r || (a[d] = r = {
					id: d
				}),
					r.timeoutId && (r.timeoutId = clearTimeout(r.timeoutId));
				var l = r.event = "mousemove.hoverIntent.hoverIntent" + d;
				if ("mouseenter" === n.type) {
					if (r.isActive)
						return;
					r.pX = i.pageX,
						r.pY = i.pageY,
						o.off(l, t).on(l, t),
						r.timeoutId = setTimeout(function () {
							s(i, o, r, u)
						}, u.interval)
				} else {
					if (!r.isActive)
						return;
					o.off(l, t),
						r.timeoutId = setTimeout(function () {
							!function (e, t, n, i) {
								var o = t.data("hoverIntent");
								o && delete o[n.id],
									i.apply(t[0], [e])
							}(i, o, r, u.out)
						}, u.timeout)
				}
			}
			var d = r++
				, u = e.extend({}, a);
			return e.isPlainObject(i) ? n((u = e.extend(u, i)).out) || (u.out = u.over) : u = n(o) ? e.extend(u, {
				over: i,
				out: o,
				selector: l
			}) : e.extend(u, {
				over: i,
				out: i,
				selector: o
			}),
				this.on({
					"mouseenter.hoverIntent": c,
					"mouseleave.hoverIntent": c
				}, u.selector)
		}
	}),
	// PhotoSwipe：提供图片画廊的切换、缩放、拖拽及全屏浏览能力。
	function (e, t) {
		"function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? module.exports = t() : e.PhotoSwipe = t()
	}(this, function () {
		"use strict";
		return function (e, t, n, i) {
			var o = {
				features: null,
				bind: function (e, t, n, i) {
					var o = (i ? "remove" : "add") + "EventListener";
					t = t.split(" ");
					for (var a = 0; a < t.length; a++)
						t[a] && e[o](t[a], n, !1)
				},
				isArray: function (e) {
					return e instanceof Array
				},
				createEl: function (e, t) {
					var n = document.createElement(t || "div");
					return e && (n.className = e),
						n
				},
				getScrollY: function () {
					var e = window.pageYOffset;
					return void 0 !== e ? e : document.documentElement.scrollTop
				},
				unbind: function (e, t, n) {
					o.bind(e, t, n, !0)
				},
				removeClass: function (e, t) {
					var n = new RegExp("(\\s|^)" + t + "(\\s|$)");
					e.className = e.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
				},
				addClass: function (e, t) {
					o.hasClass(e, t) || (e.className += (e.className ? " " : "") + t)
				},
				hasClass: function (e, t) {
					return e.className && new RegExp("(^|\\s)" + t + "(\\s|$)").test(e.className)
				},
				getChildByClass: function (e, t) {
					for (var n = e.firstChild; n;) {
						if (o.hasClass(n, t))
							return n;
						n = n.nextSibling
					}
				},
				arraySearch: function (e, t, n) {
					for (var i = e.length; i--;)
						if (e[i][n] === t)
							return i;
					return -1
				},
				extend: function (e, t, n) {
					for (var i in t)
						if (t.hasOwnProperty(i)) {
							if (n && e.hasOwnProperty(i))
								continue;
							e[i] = t[i]
						}
				},
				easing: {
					sine: {
						out: function (e) {
							return Math.sin(e * (Math.PI / 2))
						},
						inOut: function (e) {
							return -(Math.cos(Math.PI * e) - 1) / 2
						}
					},
					cubic: {
						out: function (e) {
							return --e * e * e + 1
						}
					}
				},
				detectFeatures: function () {
					if (o.features)
						return o.features;
					var e = o.createEl().style
						, t = ""
						, n = {};
					if (n.oldIE = document.all && !document.addEventListener,
						n.touch = "ontouchstart" in window,
						window.requestAnimationFrame && (n.raf = window.requestAnimationFrame,
							n.caf = window.cancelAnimationFrame),
						n.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled,
						!n.pointerEvent) {
						var i = navigator.userAgent;
						if (/iP(hone|od)/.test(navigator.platform)) {
							var a = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
							a && a.length > 0 && (a = parseInt(a[1], 10)) >= 1 && a < 8 && (n.isOldIOSPhone = !0)
						}
						var r = i.match(/Android\s([0-9\.]*)/)
							, s = r ? r[1] : 0;
						(s = parseFloat(s)) >= 1 && (s < 4.4 && (n.isOldAndroid = !0),
							n.androidVersion = s),
							n.isMobileOpera = /opera mini|opera mobi/i.test(i)
					}
					for (var l, c, d = ["transform", "perspective", "animationName"], u = ["", "webkit", "Moz", "ms", "O"], p = 0; p < 4; p++) {
						t = u[p];
						for (var m = 0; m < 3; m++)
							l = d[m],
								c = t + (t ? l.charAt(0).toUpperCase() + l.slice(1) : l),
								!n[l] && c in e && (n[l] = c);
						t && !n.raf && (t = t.toLowerCase(),
							n.raf = window[t + "RequestAnimationFrame"],
							n.raf && (n.caf = window[t + "CancelAnimationFrame"] || window[t + "CancelRequestAnimationFrame"]))
					}
					if (!n.raf) {
						var f = 0;
						n.raf = function (e) {
							var t = (new Date).getTime()
								, n = Math.max(0, 16 - (t - f))
								, i = window.setTimeout(function () {
									e(t + n)
								}, n);
							return f = t + n,
								i
						}
							,
							n.caf = function (e) {
								clearTimeout(e)
							}
					}
					return n.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect,
						o.features = n,
						n
				}
			};
			o.detectFeatures(),
				o.features.oldIE && (o.bind = function (e, t, n, i) {
					t = t.split(" ");
					for (var o, a = (i ? "detach" : "attach") + "Event", r = function () {
						n.handleEvent.call(n)
					}, s = 0; s < t.length; s++)
						if (o = t[s])
							if ("object" == typeof n && n.handleEvent) {
								if (i) {
									if (!n["oldIE" + o])
										return !1
								} else
									n["oldIE" + o] = r;
								e[a]("on" + o, n["oldIE" + o])
							} else
								e[a]("on" + o, n)
				}
				);
			var a = this
				, r = {
					allowPanToNext: !0,
					spacing: .12,
					bgOpacity: 1,
					mouseUsed: !1,
					loop: !0,
					pinchToClose: !0,
					closeOnScroll: !0,
					closeOnVerticalDrag: !0,
					verticalDragRange: .75,
					hideAnimationDuration: 333,
					showAnimationDuration: 333,
					showHideOpacity: !1,
					focus: !0,
					escKey: !0,
					arrowKeys: !0,
					mainScrollEndFriction: .35,
					panEndFriction: .35,
					isClickableElement: function (e) {
						return "A" === e.tagName
					},
					getDoubleTapZoom: function (e, t) {
						return e ? 1 : t.initialZoomLevel < .7 ? 1 : 1.33
					},
					maxSpreadZoom: 1.33,
					modal: !0,
					scaleMode: "fit"
				};
			o.extend(r, i);
			var s, l, c, d, u, p, m, f, h, g, v, y, w, T, S, b, x, _, C, P, k, I, D, A, M, O, E, $, R, L, F, N, z, U, W, j, q, H, B, Z, V, G, K, Y, X, Q, J, ee, te, ne, ie, oe, ae, re, se, le, ce = {
				x: 0,
				y: 0
			}, de = {
				x: 0,
				y: 0
			}, ue = {
				x: 0,
				y: 0
			}, pe = {}, me = 0, fe = {}, he = {
				x: 0,
				y: 0
			}, ge = 0, ve = !0, ye = [], we = {}, Te = !1, Se = function (e, t) {
				o.extend(a, t.publicMethods),
					ye.push(e)
			}, be = function (e) {
				var t = Wt();
				return e > t - 1 ? e - t : e < 0 ? t + e : e
			}, xe = {}, _e = function (e, t) {
				return xe[e] || (xe[e] = []),
					xe[e].push(t)
			}, Ce = function (e) {
				var t = xe[e];
				if (t) {
					var n = Array.prototype.slice.call(arguments);
					n.shift();
					for (var i = 0; i < t.length; i++)
						t[i].apply(a, n)
				}
			}, Pe = function () {
				return (new Date).getTime()
			}, ke = function (e) {
				re = e,
					a.bg.style.opacity = e * r.bgOpacity
			}, Ie = function (e, t, n, i, o) {
				(!Te || o && o !== a.currItem) && (i /= o ? o.fitRatio : a.currItem.fitRatio),
					e[I] = y + t + "px, " + n + "px" + w + " scale(" + i + ")"
			}, De = function (e) {
				te && (e && (g > a.currItem.fitRatio ? Te || (Yt(a.currItem, !1, !0),
					Te = !0) : Te && (Yt(a.currItem),
						Te = !1)),
					Ie(te, ue.x, ue.y, g))
			}, Ae = function (e) {
				e.container && Ie(e.container.style, e.initialPosition.x, e.initialPosition.y, e.initialZoomLevel, e)
			}, Me = function (e, t) {
				t[I] = y + e + "px, 0px" + w
			}, Oe = function (e, t) {
				if (!r.loop && t) {
					var n = d + (he.x * me - e) / he.x
						, i = Math.round(e - dt.x);
					(n < 0 && i > 0 || n >= Wt() - 1 && i < 0) && (e = dt.x + i * r.mainScrollEndFriction)
				}
				dt.x = e,
					Me(e, u)
			}, Ee = function (e, t) {
				var n = ut[e] - fe[e];
				return de[e] + ce[e] + n - n * (t / v)
			}, $e = function (e, t) {
				e.x = t.x,
					e.y = t.y,
					t.id && (e.id = t.id)
			}, Re = function (e) {
				e.x = Math.round(e.x),
					e.y = Math.round(e.y)
			}, Le = null, Fe = function () {
				Le && (o.unbind(document, "mousemove", Fe),
					o.addClass(e, "pswp--has_mouse"),
					r.mouseUsed = !0,
					Ce("mouseUsed")),
					Le = setTimeout(function () {
						Le = null
					}, 100)
			}, Ne = function (e, t) {
				var n = Zt(a.currItem, pe, e);
				return t && (ee = n),
					n
			}, ze = function (e) {
				return e || (e = a.currItem),
					e.initialZoomLevel
			}, Ue = function (e) {
				return e || (e = a.currItem),
					e.w > 0 ? r.maxSpreadZoom : 1
			}, We = function (e, t, n, i) {
				return i === a.currItem.initialZoomLevel ? (n[e] = a.currItem.initialPosition[e],
					!0) : (n[e] = Ee(e, i),
						n[e] > t.min[e] ? (n[e] = t.min[e],
							!0) : n[e] < t.max[e] && (n[e] = t.max[e],
								!0))
			}, je = function (e) {
				var t = "";
				r.escKey && 27 === e.keyCode ? t = "close" : r.arrowKeys && (37 === e.keyCode ? t = "prev" : 39 === e.keyCode && (t = "next")),
					t && (e.ctrlKey || e.altKey || e.shiftKey || e.metaKey || (e.preventDefault ? e.preventDefault() : e.returnValue = !1,
						a[t]()))
			}, qe = function (e) {
				e && (G || V || ne || q) && (e.preventDefault(),
					e.stopPropagation())
			}, He = function () {
				a.setScrollOffset(0, o.getScrollY())
			}, Be = {}, Ze = 0, Ve = function (e) {
				Be[e] && (Be[e].raf && O(Be[e].raf),
					Ze--,
					delete Be[e])
			}, Ge = function (e) {
				Be[e] && Ve(e),
					Be[e] || (Ze++,
						Be[e] = {})
			}, Ke = function () {
				for (var e in Be)
					Be.hasOwnProperty(e) && Ve(e)
			}, Ye = function (e, t, n, i, o, a, r) {
				var s, l = Pe();
				Ge(e);
				var c = function () {
					if (Be[e]) {
						if ((s = Pe() - l) >= i)
							return Ve(e),
								a(n),
								void (r && r());
						a((n - t) * o(s / i) + t),
							Be[e].raf = M(c)
					}
				};
				c()
			}, Xe = {
				shout: Ce,
				listen: _e,
				viewportSize: pe,
				options: r,
				isMainScrollAnimating: function () {
					return ne
				},
				getZoomLevel: function () {
					return g
				},
				getCurrentIndex: function () {
					return d
				},
				isDragging: function () {
					return B
				},
				isZooming: function () {
					return Q
				},
				setScrollOffset: function (e, t) {
					fe.x = e,
						L = fe.y = t,
						Ce("updateScrollOffset", fe)
				},
				applyZoomPan: function (e, t, n, i) {
					ue.x = t,
						ue.y = n,
						g = e,
						De(i)
				},
				init: function () {
					if (!s && !l) {
						var n;
						a.framework = o,
							a.template = e,
							a.bg = o.getChildByClass(e, "pswp__bg"),
							E = e.className,
							s = !0,
							F = o.detectFeatures(),
							M = F.raf,
							O = F.caf,
							I = F.transform,
							R = F.oldIE,
							a.scrollWrap = o.getChildByClass(e, "pswp__scroll-wrap"),
							a.container = o.getChildByClass(a.scrollWrap, "pswp__container"),
							u = a.container.style,
							a.itemHolders = b = [{
								el: a.container.children[0],
								wrap: 0,
								index: -1
							}, {
								el: a.container.children[1],
								wrap: 0,
								index: -1
							}, {
								el: a.container.children[2],
								wrap: 0,
								index: -1
							}],
							b[0].el.style.display = b[2].el.style.display = "none",
							function () {
								if (I) {
									var t = F.perspective && !A;
									return y = "translate" + (t ? "3d(" : "("),
										void (w = F.perspective ? ", 0px)" : ")")
								}
								I = "left",
									o.addClass(e, "pswp--ie"),
									Me = function (e, t) {
										t.left = e + "px"
									}
									,
									Ae = function (e) {
										var t = e.fitRatio > 1 ? 1 : e.fitRatio
											, n = e.container.style
											, i = t * e.w
											, o = t * e.h;
										n.width = i + "px",
											n.height = o + "px",
											n.left = e.initialPosition.x + "px",
											n.top = e.initialPosition.y + "px"
									}
									,
									De = function () {
										if (te) {
											var e = te
												, t = a.currItem
												, n = t.fitRatio > 1 ? 1 : t.fitRatio
												, i = n * t.w
												, o = n * t.h;
											e.width = i + "px",
												e.height = o + "px",
												e.left = ue.x + "px",
												e.top = ue.y + "px"
										}
									}
							}(),
							h = {
								resize: a.updateSize,
								orientationchange: function () {
									clearTimeout(N),
										N = setTimeout(function () {
											pe.x !== a.scrollWrap.clientWidth && a.updateSize()
										}, 500)
								},
								scroll: He,
								keydown: je,
								click: qe
							};
						var i = F.isOldIOSPhone || F.isOldAndroid || F.isMobileOpera;
						for (F.animationName && F.transform && !i || (r.showAnimationDuration = r.hideAnimationDuration = 0),
							n = 0; n < ye.length; n++)
							a["init" + ye[n]]();
						t && (a.ui = new t(a, o)).init(),
							Ce("firstUpdate"),
							d = d || r.index || 0,
							(isNaN(d) || d < 0 || d >= Wt()) && (d = 0),
							a.currItem = Ut(d),
							(F.isOldIOSPhone || F.isOldAndroid) && (ve = !1),
							e.setAttribute("aria-hidden", "false"),
							r.modal && (ve ? e.style.position = "fixed" : (e.style.position = "absolute",
								e.style.top = o.getScrollY() + "px")),
							void 0 === L && (Ce("initialLayout"),
								L = $ = o.getScrollY());
						var c = "pswp--open ";
						for (r.mainClass && (c += r.mainClass + " "),
							r.showHideOpacity && (c += "pswp--animate_opacity "),
							c += A ? "pswp--touch" : "pswp--notouch",
							c += F.animationName ? " pswp--css_animation" : "",
							c += F.svg ? " pswp--svg" : "",
							o.addClass(e, c),
							a.updateSize(),
							p = -1,
							ge = null,
							n = 0; n < 3; n++)
							Me((n + p) * he.x, b[n].el.style);
						R || o.bind(a.scrollWrap, f, a),
							_e("initialZoomInEnd", function () {
								a.setContent(b[0], d - 1),
									a.setContent(b[2], d + 1),
									b[0].el.style.display = b[2].el.style.display = "block",
									r.focus && e.focus(),
									o.bind(document, "keydown", a),
									F.transform && o.bind(a.scrollWrap, "click", a),
									r.mouseUsed || o.bind(document, "mousemove", Fe),
									o.bind(window, "resize scroll orientationchange", a),
									Ce("bindEvents")
							}),
							a.setContent(b[1], d),
							a.updateCurrItem(),
							Ce("afterInit"),
							ve || (T = setInterval(function () {
								Ze || B || Q || g !== a.currItem.initialZoomLevel || a.updateSize()
							}, 1e3)),
							o.addClass(e, "pswp--visible")
					}
				},
				close: function () {
					s && (s = !1,
						l = !0,
						Ce("close"),
						o.unbind(window, "resize scroll orientationchange", a),
						o.unbind(window, "scroll", h.scroll),
						o.unbind(document, "keydown", a),
						o.unbind(document, "mousemove", Fe),
						F.transform && o.unbind(a.scrollWrap, "click", a),
						B && o.unbind(window, m, a),
						clearTimeout(N),
						Ce("unbindEvents"),
						jt(a.currItem, null, !0, a.destroy))
				},
				destroy: function () {
					Ce("destroy"),
						Lt && clearTimeout(Lt),
						e.setAttribute("aria-hidden", "true"),
						e.className = E,
						T && clearInterval(T),
						o.unbind(a.scrollWrap, f, a),
						o.unbind(window, "scroll", a),
						ft(),
						Ke(),
						xe = null
				},
				panTo: function (e, t, n) {
					n || (e > ee.min.x ? e = ee.min.x : e < ee.max.x && (e = ee.max.x),
						t > ee.min.y ? t = ee.min.y : t < ee.max.y && (t = ee.max.y)),
						ue.x = e,
						ue.y = t,
						De()
				},
				handleEvent: function (e) {
					e = e || window.event,
						h[e.type] && h[e.type](e)
				},
				goTo: function (e) {
					var t = (e = be(e)) - d;
					ge = t,
						d = e,
						a.currItem = Ut(d),
						me -= t,
						Oe(he.x * me),
						Ke(),
						ne = !1,
						a.updateCurrItem()
				},
				next: function () {
					a.goTo(d + 1)
				},
				prev: function () {
					a.goTo(d - 1)
				},
				updateCurrZoomItem: function (e) {
					if (e && Ce("beforeChange", 0),
						b[1].el.children.length) {
						var t = b[1].el.children[0];
						te = o.hasClass(t, "pswp__zoom-wrap") ? t.style : null
					} else
						te = null;
					ee = a.currItem.bounds,
						v = g = a.currItem.initialZoomLevel,
						ue.x = ee.center.x,
						ue.y = ee.center.y,
						e && Ce("afterChange")
				},
				invalidateCurrItems: function () {
					S = !0;
					for (var e = 0; e < 3; e++)
						b[e].item && (b[e].item.needsUpdate = !0)
				},
				updateCurrItem: function (e) {
					if (0 !== ge) {
						var t, n = Math.abs(ge);
						if (!(e && n < 2)) {
							a.currItem = Ut(d),
								Te = !1,
								Ce("beforeChange", ge),
								n >= 3 && (p += ge + (ge > 0 ? -3 : 3),
									n = 3);
							for (var i = 0; i < n; i++)
								ge > 0 ? (t = b.shift(),
									b[2] = t,
									Me((++p + 2) * he.x, t.el.style),
									a.setContent(t, d - n + i + 1 + 1)) : (t = b.pop(),
										b.unshift(t),
										Me(--p * he.x, t.el.style),
										a.setContent(t, d + n - i - 1 - 1));
							if (te && 1 === Math.abs(ge)) {
								var o = Ut(x);
								o.initialZoomLevel !== g && (Zt(o, pe),
									Yt(o),
									Ae(o))
							}
							ge = 0,
								a.updateCurrZoomItem(),
								x = d,
								Ce("afterChange")
						}
					}
				},
				updateSize: function (t) {
					if (!ve && r.modal) {
						var n = o.getScrollY();
						if (L !== n && (e.style.top = n + "px",
							L = n),
							!t && we.x === window.innerWidth && we.y === window.innerHeight)
							return;
						we.x = window.innerWidth,
							we.y = window.innerHeight,
							e.style.height = we.y + "px"
					}
					if (pe.x = a.scrollWrap.clientWidth,
						pe.y = a.scrollWrap.clientHeight,
						He(),
						he.x = pe.x + Math.round(pe.x * r.spacing),
						he.y = pe.y,
						Oe(he.x * me),
						Ce("beforeResize"),
						void 0 !== p) {
						for (var i, s, l, c = 0; c < 3; c++)
							i = b[c],
								Me((c + p) * he.x, i.el.style),
								l = d + c - 1,
								r.loop && Wt() > 2 && (l = be(l)),
								(s = Ut(l)) && (S || s.needsUpdate || !s.bounds) ? (a.cleanSlide(s),
									a.setContent(i, l),
									1 === c && (a.currItem = s,
										a.updateCurrZoomItem(!0)),
									s.needsUpdate = !1) : -1 === i.index && l >= 0 && a.setContent(i, l),
								s && s.container && (Zt(s, pe),
									Yt(s),
									Ae(s));
						S = !1
					}
					v = g = a.currItem.initialZoomLevel,
						(ee = a.currItem.bounds) && (ue.x = ee.center.x,
							ue.y = ee.center.y,
							De(!0)),
						Ce("resize")
				},
				zoomTo: function (e, t, n, i, a) {
					t && (v = g,
						ut.x = Math.abs(t.x) - ue.x,
						ut.y = Math.abs(t.y) - ue.y,
						$e(de, ue));
					var r = Ne(e, !1)
						, s = {};
					We("x", r, s, e),
						We("y", r, s, e);
					var l = g
						, c = ue.x
						, d = ue.y;
					Re(s);
					var u = function (t) {
						1 === t ? (g = e,
							ue.x = s.x,
							ue.y = s.y) : (g = (e - l) * t + l,
								ue.x = (s.x - c) * t + c,
								ue.y = (s.y - d) * t + d),
							a && a(t),
							De(1 === t)
					};
					n ? Ye("customZoomTo", 0, 1, n, i || o.easing.sine.inOut, u) : u(1)
				}
			}, Qe = {}, Je = {}, et = {}, tt = {}, nt = {}, it = [], ot = {}, at = [], rt = {}, st = 0, lt = {
				x: 0,
				y: 0
			}, ct = 0, dt = {
				x: 0,
				y: 0
			}, ut = {
				x: 0,
				y: 0
			}, pt = {
				x: 0,
				y: 0
			}, mt = function (e, t) {
				return rt.x = Math.abs(e.x - t.x),
					rt.y = Math.abs(e.y - t.y),
					Math.sqrt(rt.x * rt.x + rt.y * rt.y)
			}, ft = function () {
				K && (O(K),
					K = null)
			}, ht = function () {
				B && (K = M(ht),
					Dt())
			}, gt = function (e, t) {
				return !(!e || e === document) && !(e.getAttribute("class") && e.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (t(e) ? e : gt(e.parentNode, t))
			}, vt = {}, yt = function (e, t) {
				return vt.prevent = !gt(e.target, r.isClickableElement),
					Ce("preventDragEvent", e, t, vt),
					vt.prevent
			}, wt = function (e, t) {
				return t.x = e.pageX,
					t.y = e.pageY,
					t.id = e.identifier,
					t
			}, Tt = function (e, t, n) {
				n.x = .5 * (e.x + t.x),
					n.y = .5 * (e.y + t.y)
			}, St = function () {
				var e = ue.y - a.currItem.initialPosition.y;
				return 1 - Math.abs(e / (pe.y / 2))
			}, bt = {}, xt = {}, _t = [], Ct = function (e) {
				for (; _t.length > 0;)
					_t.pop();
				return D ? (le = 0,
					it.forEach(function (e) {
						0 === le ? _t[0] = e : 1 === le && (_t[1] = e),
							le++
					})) : e.type.indexOf("touch") > -1 ? e.touches && e.touches.length > 0 && (_t[0] = wt(e.touches[0], bt),
						e.touches.length > 1 && (_t[1] = wt(e.touches[1], xt))) : (bt.x = e.pageX,
							bt.y = e.pageY,
							bt.id = "",
							_t[0] = bt),
					_t
			}, Pt = function (e, t) {
				var n, i, o, s, l = ue[e] + t[e], c = t[e] > 0, d = dt.x + t.x, u = dt.x - ot.x;
				return n = l > ee.min[e] || l < ee.max[e] ? r.panEndFriction : 1,
					l = ue[e] + t[e] * n,
					!r.allowPanToNext && g !== a.currItem.initialZoomLevel || (te ? "h" !== ie || "x" !== e || V || (c ? (l > ee.min[e] && (n = r.panEndFriction,
						ee.min[e],
						i = ee.min[e] - de[e]),
						(i <= 0 || u < 0) && Wt() > 1 ? (s = d,
							u < 0 && d > ot.x && (s = ot.x)) : ee.min.x !== ee.max.x && (o = l)) : (l < ee.max[e] && (n = r.panEndFriction,
								ee.max[e],
								i = de[e] - ee.max[e]),
								(i <= 0 || u > 0) && Wt() > 1 ? (s = d,
									u > 0 && d < ot.x && (s = ot.x)) : ee.min.x !== ee.max.x && (o = l))) : s = d,
						"x" !== e) ? void (ne || Y || g > a.currItem.fitRatio && (ue[e] += t[e] * n)) : (void 0 !== s && (Oe(s, !0),
							Y = s !== ot.x),
							ee.min.x !== ee.max.x && (void 0 !== o ? ue.x = o : Y || (ue.x += t.x * n)),
							void 0 !== s)
			}, kt = function (e) {
				if (!("mousedown" === e.type && e.button > 0)) {
					if (zt)
						return void e.preventDefault();
					if (!H || "mousedown" !== e.type) {
						if (yt(e, !0) && e.preventDefault(),
							Ce("pointerDown"),
							D) {
							var t = o.arraySearch(it, e.pointerId, "id");
							t < 0 && (t = it.length),
								it[t] = {
									x: e.pageX,
									y: e.pageY,
									id: e.pointerId
								}
						}
						var n = Ct(e)
							, i = n.length;
						X = null,
							Ke(),
							B && 1 !== i || (B = oe = !0,
								o.bind(window, m, a),
								j = se = ae = q = Y = G = Z = V = !1,
								ie = null,
								Ce("firstTouchStart", n),
								$e(de, ue),
								ce.x = ce.y = 0,
								$e(tt, n[0]),
								$e(nt, tt),
								ot.x = he.x * me,
								at = [{
									x: tt.x,
									y: tt.y
								}],
								U = z = Pe(),
								Ne(g, !0),
								ft(),
								ht()),
							!Q && i > 1 && !ne && !Y && (v = g,
								V = !1,
								Q = Z = !0,
								ce.y = ce.x = 0,
								$e(de, ue),
								$e(Qe, n[0]),
								$e(Je, n[1]),
								Tt(Qe, Je, pt),
								ut.x = Math.abs(pt.x) - ue.x,
								ut.y = Math.abs(pt.y) - ue.y,
								J = mt(Qe, Je))
					}
				}
			}, It = function (e) {
				if (e.preventDefault(),
					D) {
					var t = o.arraySearch(it, e.pointerId, "id");
					if (t > -1) {
						var n = it[t];
						n.x = e.pageX,
							n.y = e.pageY
					}
				}
				if (B) {
					var i = Ct(e);
					if (ie || G || Q)
						X = i;
					else if (dt.x !== he.x * me)
						ie = "h";
					else {
						var a = Math.abs(i[0].x - tt.x) - Math.abs(i[0].y - tt.y);
						Math.abs(a) >= 10 && (ie = a > 0 ? "h" : "v",
							X = i)
					}
				}
			}, Dt = function () {
				if (X) {
					var e = X.length;
					if (0 !== e)
						if ($e(Qe, X[0]),
							et.x = Qe.x - tt.x,
							et.y = Qe.y - tt.y,
							Q && e > 1) {
							if (tt.x = Qe.x,
								tt.y = Qe.y,
								!et.x && !et.y && function (e, t) {
									return e.x === t.x && e.y === t.y
								}(X[1], Je))
								return;
							$e(Je, X[1]),
								V || (V = !0,
									Ce("zoomGestureStarted"));
							var t = mt(Qe, Je)
								, n = $t(t);
							n > a.currItem.initialZoomLevel + a.currItem.initialZoomLevel / 15 && (se = !0);
							var i = 1
								, o = ze()
								, s = Ue();
							if (n < o)
								if (r.pinchToClose && !se && v <= a.currItem.initialZoomLevel) {
									var l = 1 - (o - n) / (o / 1.2);
									ke(l),
										Ce("onPinchClose", l),
										ae = !0
								} else
									(i = (o - n) / o) > 1 && (i = 1),
										n = o - i * (o / 3);
							else
								n > s && ((i = (n - s) / (6 * o)) > 1 && (i = 1),
									n = s + i * o);
							i < 0 && (i = 0),
								Tt(Qe, Je, lt),
								ce.x += lt.x - pt.x,
								ce.y += lt.y - pt.y,
								$e(pt, lt),
								ue.x = Ee("x", n),
								ue.y = Ee("y", n),
								j = n > g,
								g = n,
								De()
						} else {
							if (!ie)
								return;
							if (oe && (oe = !1,
								Math.abs(et.x) >= 10 && (et.x -= X[0].x - nt.x),
								Math.abs(et.y) >= 10 && (et.y -= X[0].y - nt.y)),
								tt.x = Qe.x,
								tt.y = Qe.y,
								0 === et.x && 0 === et.y)
								return;
							if ("v" === ie && r.closeOnVerticalDrag && "fit" === r.scaleMode && g === a.currItem.initialZoomLevel) {
								ce.y += et.y,
									ue.y += et.y;
								var c = St();
								return q = !0,
									Ce("onVerticalDrag", c),
									ke(c),
									void De()
							}
							(function (e, t, n) {
								if (e - U > 50) {
									var i = at.length > 2 ? at.shift() : {};
									i.x = t,
										i.y = n,
										at.push(i),
										U = e
								}
							}
							)(Pe(), Qe.x, Qe.y),
								G = !0,
								ee = a.currItem.bounds,
								Pt("x", et) || (Pt("y", et),
									Re(ue),
									De())
						}
				}
			}, At = function (e) {
				if (F.isOldAndroid) {
					if (H && "mouseup" === e.type)
						return;
					e.type.indexOf("touch") > -1 && (clearTimeout(H),
						H = setTimeout(function () {
							H = 0
						}, 600))
				}
				var t;
				if (Ce("pointerUp"),
					yt(e, !1) && e.preventDefault(),
					D) {
					var n = o.arraySearch(it, e.pointerId, "id");
					n > -1 && (t = it.splice(n, 1)[0],
						navigator.msPointerEnabled ? (t.type = {
							4: "mouse",
							2: "touch",
							3: "pen"
						}[e.pointerType],
							t.type || (t.type = e.pointerType || "mouse")) : t.type = e.pointerType || "mouse")
				}
				var i, s = Ct(e), l = s.length;
				if ("mouseup" === e.type && (l = 0),
					2 === l)
					return X = null,
						!0;
				1 === l && $e(nt, s[0]),
					0 !== l || ie || ne || (t || ("mouseup" === e.type ? t = {
						x: e.pageX,
						y: e.pageY,
						type: "mouse"
					} : e.changedTouches && e.changedTouches[0] && (t = {
						x: e.changedTouches[0].pageX,
						y: e.changedTouches[0].pageY,
						type: "touch"
					})),
						Ce("touchRelease", e, t));
				var c = -1;
				if (0 === l && (B = !1,
					o.unbind(window, m, a),
					ft(),
					Q ? c = 0 : -1 !== ct && (c = Pe() - ct)),
					ct = 1 === l ? Pe() : -1,
					i = -1 !== c && c < 150 ? "zoom" : "swipe",
					Q && l < 2 && (Q = !1,
						1 === l && (i = "zoomPointerUp"),
						Ce("zoomGestureEnded")),
					X = null,
					G || V || ne || q)
					if (Ke(),
						W || (W = Mt()),
						W.calculateSwipeSpeed("x"),
						q)
						if (St() < r.verticalDragRange)
							a.close();
						else {
							var d = ue.y
								, u = re;
							Ye("verticalDrag", 0, 1, 300, o.easing.cubic.out, function (e) {
								ue.y = (a.currItem.initialPosition.y - d) * e + d,
									ke((1 - u) * e + u),
									De()
							}),
								Ce("onVerticalDrag", 1)
						}
					else {
						if ((Y || ne) && 0 === l) {
							if (Et(i, W))
								return;
							i = "zoomPointerUp"
						}
						if (!ne)
							return "swipe" !== i ? void Rt() : void (!Y && g > a.currItem.fitRatio && Ot(W))
					}
			}, Mt = function () {
				var e, t, n = {
					lastFlickOffset: {},
					lastFlickDist: {},
					lastFlickSpeed: {},
					slowDownRatio: {},
					slowDownRatioReverse: {},
					speedDecelerationRatio: {},
					speedDecelerationRatioAbs: {},
					distanceOffset: {},
					backAnimDestination: {},
					backAnimStarted: {},
					calculateSwipeSpeed: function (i) {
						at.length > 1 ? (e = Pe() - U + 50,
							t = at[at.length - 2][i]) : (e = Pe() - z,
								t = nt[i]),
							n.lastFlickOffset[i] = tt[i] - t,
							n.lastFlickDist[i] = Math.abs(n.lastFlickOffset[i]),
							n.lastFlickDist[i] > 20 ? n.lastFlickSpeed[i] = n.lastFlickOffset[i] / e : n.lastFlickSpeed[i] = 0,
							Math.abs(n.lastFlickSpeed[i]) < .1 && (n.lastFlickSpeed[i] = 0),
							n.slowDownRatio[i] = .95,
							n.slowDownRatioReverse[i] = 1 - n.slowDownRatio[i],
							n.speedDecelerationRatio[i] = 1
					},
					calculateOverBoundsAnimOffset: function (e, t) {
						n.backAnimStarted[e] || (ue[e] > ee.min[e] ? n.backAnimDestination[e] = ee.min[e] : ue[e] < ee.max[e] && (n.backAnimDestination[e] = ee.max[e]),
							void 0 !== n.backAnimDestination[e] && (n.slowDownRatio[e] = .7,
								n.slowDownRatioReverse[e] = 1 - n.slowDownRatio[e],
								n.speedDecelerationRatioAbs[e] < .05 && (n.lastFlickSpeed[e] = 0,
									n.backAnimStarted[e] = !0,
									Ye("bounceZoomPan" + e, ue[e], n.backAnimDestination[e], t || 300, o.easing.sine.out, function (t) {
										ue[e] = t,
											De()
									}))))
					},
					calculateAnimOffset: function (e) {
						n.backAnimStarted[e] || (n.speedDecelerationRatio[e] = n.speedDecelerationRatio[e] * (n.slowDownRatio[e] + n.slowDownRatioReverse[e] - n.slowDownRatioReverse[e] * n.timeDiff / 10),
							n.speedDecelerationRatioAbs[e] = Math.abs(n.lastFlickSpeed[e] * n.speedDecelerationRatio[e]),
							n.distanceOffset[e] = n.lastFlickSpeed[e] * n.speedDecelerationRatio[e] * n.timeDiff,
							ue[e] += n.distanceOffset[e])
					},
					panAnimLoop: function () {
						if (Be.zoomPan && (Be.zoomPan.raf = M(n.panAnimLoop),
							n.now = Pe(),
							n.timeDiff = n.now - n.lastNow,
							n.lastNow = n.now,
							n.calculateAnimOffset("x"),
							n.calculateAnimOffset("y"),
							De(),
							n.calculateOverBoundsAnimOffset("x"),
							n.calculateOverBoundsAnimOffset("y"),
							n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05))
							return ue.x = Math.round(ue.x),
								ue.y = Math.round(ue.y),
								De(),
								void Ve("zoomPan")
					}
				};
				return n
			}, Ot = function (e) {
				return e.calculateSwipeSpeed("y"),
					ee = a.currItem.bounds,
					e.backAnimDestination = {},
					e.backAnimStarted = {},
					Math.abs(e.lastFlickSpeed.x) <= .05 && Math.abs(e.lastFlickSpeed.y) <= .05 ? (e.speedDecelerationRatioAbs.x = e.speedDecelerationRatioAbs.y = 0,
						e.calculateOverBoundsAnimOffset("x"),
						e.calculateOverBoundsAnimOffset("y"),
						!0) : (Ge("zoomPan"),
							e.lastNow = Pe(),
							void e.panAnimLoop())
			}, Et = function (e, t) {
				var n, i, s;
				if (ne || (st = d),
					"swipe" === e) {
					var l = tt.x - nt.x
						, c = t.lastFlickDist.x < 10;
					l > 30 && (c || t.lastFlickOffset.x > 20) ? i = -1 : l < -30 && (c || t.lastFlickOffset.x < -20) && (i = 1)
				}
				i && ((d += i) < 0 ? (d = r.loop ? Wt() - 1 : 0,
					s = !0) : d >= Wt() && (d = r.loop ? 0 : Wt() - 1,
						s = !0),
					s && !r.loop || (ge += i,
						me -= i,
						n = !0));
				var u, p = he.x * me, m = Math.abs(p - dt.x);
				return n || p > dt.x == t.lastFlickSpeed.x > 0 ? (u = Math.abs(t.lastFlickSpeed.x) > 0 ? m / Math.abs(t.lastFlickSpeed.x) : 333,
					u = Math.min(u, 400),
					u = Math.max(u, 250)) : u = 333,
					st === d && (n = !1),
					ne = !0,
					Ce("mainScrollAnimStart"),
					Ye("mainScroll", dt.x, p, u, o.easing.cubic.out, Oe, function () {
						Ke(),
							ne = !1,
							st = -1,
							(n || st !== d) && a.updateCurrItem(),
							Ce("mainScrollAnimComplete")
					}),
					n && a.updateCurrItem(!0),
					n
			}, $t = function (e) {
				return 1 / J * e * v
			}, Rt = function () {
				var e = g
					, t = ze()
					, n = Ue();
				g < t ? e = t : g > n && (e = n);
				var i, r = re;
				return ae && !j && !se && g < t ? (a.close(),
					!0) : (ae && (i = function (e) {
						ke((1 - r) * e + r)
					}
					),
						a.zoomTo(e, 0, 200, o.easing.cubic.out, i),
						!0)
			};
			Se("Gestures", {
				publicMethods: {
					initGestures: function () {
						var e = function (e, t, n, i, o) {
							_ = e + t,
								C = e + n,
								P = e + i,
								k = o ? e + o : ""
						};
						(D = F.pointerEvent) && F.touch && (F.touch = !1),
							D ? navigator.msPointerEnabled ? e("MSPointer", "Down", "Move", "Up", "Cancel") : e("pointer", "down", "move", "up", "cancel") : F.touch ? (e("touch", "start", "move", "end", "cancel"),
								A = !0) : e("mouse", "down", "move", "up"),
							m = C + " " + P + " " + k,
							f = _,
							D && !A && (A = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1),
							a.likelyTouchDevice = A,
							h[_] = kt,
							h[C] = It,
							h[P] = At,
							k && (h[k] = h[P]),
							F.touch && (f += " mousedown",
								m += " mousemove mouseup",
								h.mousedown = h[_],
								h.mousemove = h[C],
								h.mouseup = h[P]),
							A || (r.allowPanToNext = !1)
					}
				}
			});
			var Lt, Ft, Nt, zt, Ut, Wt, jt = function (t, n, i, s) {
				var l;
				Lt && clearTimeout(Lt),
					zt = !0,
					Nt = !0,
					t.initialLayout ? (l = t.initialLayout,
						t.initialLayout = null) : l = r.getThumbBoundsFn && r.getThumbBoundsFn(d);
				var u = i ? r.hideAnimationDuration : r.showAnimationDuration
					, p = function () {
						Ve("initialZoom"),
							i ? (a.template.removeAttribute("style"),
								a.bg.removeAttribute("style")) : (ke(1),
									n && (n.style.display = "block"),
									o.addClass(e, "pswp--animated-in"),
									Ce("initialZoom" + (i ? "OutEnd" : "InEnd"))),
							s && s(),
							zt = !1
					};
				if (!u || !l || void 0 === l.x)
					return Ce("initialZoom" + (i ? "Out" : "In")),
						g = t.initialZoomLevel,
						$e(ue, t.initialPosition),
						De(),
						e.style.opacity = i ? 0 : 1,
						ke(1),
						void (u ? setTimeout(function () {
							p()
						}, u) : p());
				!function () {
					var n = c
						, s = !a.currItem.src || a.currItem.loadError || r.showHideOpacity;
					t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"),
						i || (g = l.w / t.w,
							ue.x = l.x,
							ue.y = l.y - $,
							a[s ? "template" : "bg"].style.opacity = .001,
							De()),
						Ge("initialZoom"),
						i && !n && o.removeClass(e, "pswp--animated-in"),
						s && (i ? o[(n ? "remove" : "add") + "Class"](e, "pswp--animate_opacity") : setTimeout(function () {
							o.addClass(e, "pswp--animate_opacity")
						}, 30)),
						Lt = setTimeout(function () {
							if (Ce("initialZoom" + (i ? "Out" : "In")),
								i) {
								var a = l.w / t.w
									, r = {
										x: ue.x,
										y: ue.y
									}
									, c = g
									, d = re
									, m = function (t) {
										1 === t ? (g = a,
											ue.x = l.x,
											ue.y = l.y - L) : (g = (a - c) * t + c,
												ue.x = (l.x - r.x) * t + r.x,
												ue.y = (l.y - L - r.y) * t + r.y),
											De(),
											s ? e.style.opacity = 1 - t : ke(d - t * d)
									};
								n ? Ye("initialZoom", 0, 1, u, o.easing.cubic.out, m, p) : (m(1),
									Lt = setTimeout(p, u + 20))
							} else
								g = t.initialZoomLevel,
									$e(ue, t.initialPosition),
									De(),
									ke(1),
									s ? e.style.opacity = 1 : ke(1),
									Lt = setTimeout(p, u + 20)
						}, i ? 25 : 90)
				}()
			}, qt = {}, Ht = [], Bt = {
				index: 0,
				errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
				forceProgressiveLoading: !1,
				preload: [1, 1],
				getNumItemsFn: function () {
					return Ft.length
				}
			}, Zt = function (e, t, n) {
				if (e.src && !e.loadError) {
					var i = !n;
					if (i && (e.vGap || (e.vGap = {
						top: 0,
						bottom: 0
					}),
						Ce("parseVerticalMargin", e)),
						qt.x = t.x,
						qt.y = t.y - e.vGap.top - e.vGap.bottom,
						i) {
						var o = qt.x / e.w
							, a = qt.y / e.h;
						e.fitRatio = o < a ? o : a;
						var s = r.scaleMode;
						"orig" === s ? n = 1 : "fit" === s && (n = e.fitRatio),
							n > 1 && (n = 1),
							e.initialZoomLevel = n,
							e.bounds || (e.bounds = {
								center: {
									x: 0,
									y: 0
								},
								max: {
									x: 0,
									y: 0
								},
								min: {
									x: 0,
									y: 0
								}
							})
					}
					if (!n)
						return;
					return function (e, t, n) {
						var i = e.bounds;
						i.center.x = Math.round((qt.x - t) / 2),
							i.center.y = Math.round((qt.y - n) / 2) + e.vGap.top,
							i.max.x = t > qt.x ? Math.round(qt.x - t) : i.center.x,
							i.max.y = n > qt.y ? Math.round(qt.y - n) + e.vGap.top : i.center.y,
							i.min.x = t > qt.x ? 0 : i.center.x,
							i.min.y = n > qt.y ? e.vGap.top : i.center.y
					}(e, e.w * n, e.h * n),
						i && n === e.initialZoomLevel && (e.initialPosition = e.bounds.center),
						e.bounds
				}
				return e.w = e.h = 0,
					e.initialZoomLevel = e.fitRatio = 1,
					e.bounds = {
						center: {
							x: 0,
							y: 0
						},
						max: {
							x: 0,
							y: 0
						},
						min: {
							x: 0,
							y: 0
						}
					},
					e.initialPosition = e.bounds.center,
					e.bounds
			}, Vt = function (e, t, n, i, o, r) {
				t.loadError || i && (t.imageAppended = !0,
					Yt(t, i, t === a.currItem && Te),
					n.appendChild(i),
					r && setTimeout(function () {
						t && t.loaded && t.placeholder && (t.placeholder.style.display = "none",
							t.placeholder = null)
					}, 500))
			}, Gt = function (e) {
				e.loading = !0,
					e.loaded = !1;
				var t = e.img = o.createEl("pswp__img", "img")
					, n = function () {
						e.loading = !1,
							e.loaded = !0,
							e.loadComplete ? e.loadComplete(e) : e.img = null,
							t.onload = t.onerror = null,
							t = null
					};
				return t.onload = n,
					t.onerror = function () {
						e.loadError = !0,
							n()
					}
					,
					t.src = e.src,
					t
			}, Kt = function (e, t) {
				if (e.src && e.loadError && e.container)
					return t && (e.container.innerHTML = ""),
						e.container.innerHTML = r.errorMsg.replace("%url%", e.src),
						!0
			}, Yt = function (e, t, n) {
				if (e.src) {
					t || (t = e.container.lastChild);
					var i = n ? e.w : Math.round(e.w * e.fitRatio)
						, o = n ? e.h : Math.round(e.h * e.fitRatio);
					e.placeholder && !e.loaded && (e.placeholder.style.width = i + "px",
						e.placeholder.style.height = o + "px"),
						t.style.width = i + "px",
						t.style.height = o + "px"
				}
			}, Xt = function () {
				if (Ht.length) {
					for (var e, t = 0; t < Ht.length; t++)
						(e = Ht[t]).holder.index === e.index && Vt(e.index, e.item, e.baseDiv, e.img, 0, e.clearPlaceholder);
					Ht = []
				}
			};
			Se("Controller", {
				publicMethods: {
					lazyLoadItem: function (e) {
						e = be(e);
						var t = Ut(e);
						t && (!t.loaded && !t.loading || S) && (Ce("gettingData", e, t),
							t.src && Gt(t))
					},
					initController: function () {
						o.extend(r, Bt, !0),
							a.items = Ft = n,
							Ut = a.getItemAt,
							Wt = r.getNumItemsFn,
							r.loop,
							Wt() < 3 && (r.loop = !1),
							_e("beforeChange", function (e) {
								var t, n = r.preload, i = null === e || e >= 0, o = Math.min(n[0], Wt()), s = Math.min(n[1], Wt());
								for (t = 1; t <= (i ? s : o); t++)
									a.lazyLoadItem(d + t);
								for (t = 1; t <= (i ? o : s); t++)
									a.lazyLoadItem(d - t)
							}),
							_e("initialLayout", function () {
								a.currItem.initialLayout = r.getThumbBoundsFn && r.getThumbBoundsFn(d)
							}),
							_e("mainScrollAnimComplete", Xt),
							_e("initialZoomInEnd", Xt),
							_e("destroy", function () {
								for (var e, t = 0; t < Ft.length; t++)
									(e = Ft[t]).container && (e.container = null),
										e.placeholder && (e.placeholder = null),
										e.img && (e.img = null),
										e.preloader && (e.preloader = null),
										e.loadError && (e.loaded = e.loadError = !1);
								Ht = null
							})
					},
					getItemAt: function (e) {
						return e >= 0 && void 0 !== Ft[e] && Ft[e]
					},
					allowProgressiveImg: function () {
						return r.forceProgressiveLoading || !A || r.mouseUsed || screen.width > 1200
					},
					setContent: function (e, t) {
						r.loop && (t = be(t));
						var n = a.getItemAt(e.index);
						n && (n.container = null);
						var i, l = a.getItemAt(t);
						if (l) {
							Ce("gettingData", t, l),
								e.index = t,
								e.item = l;
							var c = l.container = o.createEl("pswp__zoom-wrap");
							if (!l.src && l.html && (l.html.tagName ? c.appendChild(l.html) : c.innerHTML = l.html),
								Kt(l),
								Zt(l, pe),
								!l.src || l.loadError || l.loaded)
								l.src && !l.loadError && ((i = o.createEl("pswp__img", "img")).style.opacity = 1,
									i.src = l.src,
									Yt(l, i),
									Vt(0, l, c, i));
							else {
								if (l.loadComplete = function (n) {
									if (s) {
										if (e && e.index === t) {
											if (Kt(n, !0))
												return n.loadComplete = n.img = null,
													Zt(n, pe),
													Ae(n),
													void (e.index === d && a.updateCurrZoomItem());
											n.imageAppended ? !zt && n.placeholder && (n.placeholder.style.display = "none",
												n.placeholder = null) : F.transform && (ne || zt) ? Ht.push({
													item: n,
													baseDiv: c,
													img: n.img,
													index: t,
													holder: e,
													clearPlaceholder: !0
												}) : Vt(0, n, c, n.img, 0, !0)
										}
										n.loadComplete = null,
											n.img = null,
											Ce("imageLoadComplete", t, n)
									}
								}
									,
									o.features.transform) {
									var u = "pswp__img pswp__img--placeholder";
									u += l.msrc ? "" : " pswp__img--placeholder--blank";
									var p = o.createEl(u, l.msrc ? "img" : "");
									l.msrc && (p.src = l.msrc),
										Yt(l, p),
										c.appendChild(p),
										l.placeholder = p
								}
								l.loading || Gt(l),
									a.allowProgressiveImg() && (!Nt && F.transform ? Ht.push({
										item: l,
										baseDiv: c,
										img: l.img,
										index: t,
										holder: e
									}) : Vt(0, l, c, l.img, 0, !0))
							}
							Nt || t !== d ? Ae(l) : (te = c.style,
								jt(l, i || l.img)),
								e.el.innerHTML = "",
								e.el.appendChild(c)
						} else
							e.el.innerHTML = ""
					},
					cleanSlide: function (e) {
						e.img && (e.img.onload = e.img.onerror = null),
							e.loaded = e.loading = e.img = e.imageAppended = !1
					}
				}
			});
			var Qt, Jt, en = {}, tn = function (e, t, n) {
				var i = document.createEvent("CustomEvent")
					, o = {
						origEvent: e,
						target: e.target,
						releasePoint: t,
						pointerType: n || "touch"
					};
				i.initCustomEvent("pswpTap", !0, !0, o),
					e.target.dispatchEvent(i)
			};
			Se("Tap", {
				publicMethods: {
					initTap: function () {
						_e("firstTouchStart", a.onTapStart),
							_e("touchRelease", a.onTapRelease),
							_e("destroy", function () {
								en = {},
									Qt = null
							})
					},
					onTapStart: function (e) {
						e.length > 1 && (clearTimeout(Qt),
							Qt = null)
					},
					onTapRelease: function (e, t) {
						if (t && !G && !Z && !Ze) {
							var n = t;
							if (Qt && (clearTimeout(Qt),
								Qt = null,
								function (e, t) {
									return Math.abs(e.x - t.x) < 25 && Math.abs(e.y - t.y) < 25
								}(n, en)))
								return void Ce("doubleTap", n);
							if ("mouse" === t.type)
								return void tn(e, t, "mouse");
							if ("BUTTON" === e.target.tagName.toUpperCase() || o.hasClass(e.target, "pswp__single-tap"))
								return void tn(e, t);
							$e(en, n),
								Qt = setTimeout(function () {
									tn(e, t),
										Qt = null
								}, 300)
						}
					}
				}
			}),
				Se("DesktopZoom", {
					publicMethods: {
						initDesktopZoom: function () {
							R || (A ? _e("mouseUsed", function () {
								a.setupDesktopZoom()
							}) : a.setupDesktopZoom(!0))
						},
						setupDesktopZoom: function (t) {
							Jt = {};
							var n = "wheel mousewheel DOMMouseScroll";
							_e("bindEvents", function () {
								o.bind(e, n, a.handleMouseWheel)
							}),
								_e("unbindEvents", function () {
									Jt && o.unbind(e, n, a.handleMouseWheel)
								}),
								a.mouseZoomedIn = !1;
							var i, r = function () {
								a.mouseZoomedIn && (o.removeClass(e, "pswp--zoomed-in"),
									a.mouseZoomedIn = !1),
									g < 1 ? o.addClass(e, "pswp--zoom-allowed") : o.removeClass(e, "pswp--zoom-allowed"),
									s()
							}, s = function () {
								i && (o.removeClass(e, "pswp--dragging"),
									i = !1)
							};
							_e("resize", r),
								_e("afterChange", r),
								_e("pointerDown", function () {
									a.mouseZoomedIn && (i = !0,
										o.addClass(e, "pswp--dragging"))
								}),
								_e("pointerUp", s),
								t || r()
						},
						handleMouseWheel: function (e) {
							if (g <= a.currItem.fitRatio)
								return r.modal && (!r.closeOnScroll || Ze || B ? e.preventDefault() : I && Math.abs(e.deltaY) > 2 && (c = !0,
									a.close())),
									!0;
							if (e.stopPropagation(),
								Jt.x = 0,
								"deltaX" in e)
								1 === e.deltaMode ? (Jt.x = 18 * e.deltaX,
									Jt.y = 18 * e.deltaY) : (Jt.x = e.deltaX,
										Jt.y = e.deltaY);
							else if ("wheelDelta" in e)
								e.wheelDeltaX && (Jt.x = -.16 * e.wheelDeltaX),
									e.wheelDeltaY ? Jt.y = -.16 * e.wheelDeltaY : Jt.y = -.16 * e.wheelDelta;
							else {
								if (!("detail" in e))
									return;
								Jt.y = e.detail
							}
							Ne(g, !0);
							var t = ue.x - Jt.x
								, n = ue.y - Jt.y;
							(r.modal || t <= ee.min.x && t >= ee.max.x && n <= ee.min.y && n >= ee.max.y) && e.preventDefault(),
								a.panTo(t, n)
						},
						toggleDesktopZoom: function (t) {
							t = t || {
								x: pe.x / 2 + fe.x,
								y: pe.y / 2 + fe.y
							};
							var n = r.getDoubleTapZoom(!0, a.currItem)
								, i = g === n;
							a.mouseZoomedIn = !i,
								a.zoomTo(i ? a.currItem.initialZoomLevel : n, t, 333),
								o[(i ? "remove" : "add") + "Class"](e, "pswp--zoomed-in")
						}
					}
				});
			var nn, on, an, rn, sn, ln, cn, dn, un, pn, mn, fn, hn = {
				history: !0,
				galleryUID: 1
			}, gn = function () {
				return mn.hash.substring(1)
			}, vn = function () {
				nn && clearTimeout(nn),
					an && clearTimeout(an)
			}, yn = function () {
				var e = gn()
					, t = {};
				if (e.length < 5)
					return t;
				var n, i = e.split("&");
				for (n = 0; n < i.length; n++)
					if (i[n]) {
						var o = i[n].split("=");
						o.length < 2 || (t[o[0]] = o[1])
					}
				if (r.galleryPIDs) {
					var a = t.pid;
					for (t.pid = 0,
						n = 0; n < Ft.length; n++)
						if (Ft[n].pid === a) {
							t.pid = n;
							break
						}
				} else
					t.pid = parseInt(t.pid, 10) - 1;
				return t.pid < 0 && (t.pid = 0),
					t
			}, wn = function () {
				if (an && clearTimeout(an),
					Ze || B)
					an = setTimeout(wn, 500);
				else {
					rn ? clearTimeout(on) : rn = !0;
					var e = d + 1
						, t = Ut(d);
					t.hasOwnProperty("pid") && (e = t.pid);
					var n = cn + "&gid=" + r.galleryUID + "&pid=" + e;
					dn || -1 === mn.hash.indexOf(n) && (pn = !0);
					var i = mn.href.split("#")[0] + "#" + n;
					fn ? "#" + n !== window.location.hash && history[dn ? "replaceState" : "pushState"]("", document.title, i) : dn ? mn.replace(i) : mn.hash = n,
						dn = !0,
						on = setTimeout(function () {
							rn = !1
						}, 60)
				}
			};
			Se("History", {
				publicMethods: {
					initHistory: function () {
						if (o.extend(r, hn, !0),
							r.history) {
							mn = window.location,
								pn = !1,
								un = !1,
								dn = !1,
								cn = gn(),
								fn = "pushState" in history,
								cn.indexOf("gid=") > -1 && (cn = (cn = cn.split("&gid=")[0]).split("?gid=")[0]),
								_e("afterChange", a.updateURL),
								_e("unbindEvents", function () {
									o.unbind(window, "hashchange", a.onHashChange)
								});
							var e = function () {
								ln = !0,
									un || (pn ? history.back() : cn ? mn.hash = cn : fn ? history.pushState("", document.title, mn.pathname + mn.search) : mn.hash = ""),
									vn()
							};
							_e("unbindEvents", function () {
								c && e()
							}),
								_e("destroy", function () {
									ln || e()
								}),
								_e("firstUpdate", function () {
									d = yn().pid
								});
							var t = cn.indexOf("pid=");
							t > -1 && "&" === (cn = cn.substring(0, t)).slice(-1) && (cn = cn.slice(0, -1)),
								setTimeout(function () {
									s && o.bind(window, "hashchange", a.onHashChange)
								}, 40)
						}
					},
					onHashChange: function () {
						return gn() === cn ? (un = !0,
							void a.close()) : void (rn || (sn = !0,
								a.goTo(yn().pid),
								sn = !1))
					},
					updateURL: function () {
						vn(),
							sn || (dn ? nn = setTimeout(wn, 800) : wn())
					}
				}
			}),
				o.extend(a, Xe)
		}
	}),
	// PhotoSwipe 默认 UI：提供关闭、翻页、计数器、分享和全屏等画廊界面控件。
	function (e, t) {
		"function" == typeof define && define.amd ? define(t) : "object" == typeof exports ? module.exports = t() : e.PhotoSwipeUI_Default = t()
	}(this, function () {
		"use strict";
		return function (e, t) {
			var n, i, o, a, r, s, l, c, d, u, p, m, f, h, g, v, y, w, T = this, S = !1, b = !0, x = !0, _ = {
				barsSize: {
					top: 44,
					bottom: "auto"
				},
				closeElClasses: ["item", "caption", "zoom-wrap", "ui", "top-bar"],
				timeToIdle: 4e3,
				timeToIdleOutside: 1e3,
				loadingIndicatorDelay: 1e3,
				addCaptionHTMLFn: function (e, t) {
					return e.title ? (t.children[0].innerHTML = e.title,
						!0) : (t.children[0].innerHTML = "",
							!1)
				},
				closeEl: !0,
				captionEl: !0,
				fullscreenEl: !0,
				zoomEl: !0,
				shareEl: !0,
				counterEl: !0,
				arrowEl: !0,
				preloaderEl: !0,
				tapToClose: !1,
				tapToToggleControls: !0,
				clickToCloseNonZoomable: !0,
				shareButtons: [{
					id: "facebook",
					label: "Share on Facebook",
					url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
				}, {
					id: "twitter",
					label: "Tweet",
					url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
				}, {
					id: "pinterest",
					label: "Pin it",
					url: "http://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
				}, {
					id: "download",
					label: "Download image",
					url: "{{raw_image_url}}",
					download: !0
				}],
				getImageURLForShare: function () {
					return e.currItem.src || ""
				},
				getPageURLForShare: function () {
					return window.location.href
				},
				getTextForShare: function () {
					return e.currItem.title || ""
				},
				indexIndicatorSep: " / ",
				fitControlsWidth: 1200
			}, C = function (e) {
				if (v)
					return !0;
				e = e || window.event,
					g.timeToIdle && g.mouseUsed && !d && R();
				for (var n, i, o = (e.target || e.srcElement).getAttribute("class") || "", a = 0; a < z.length; a++)
					(n = z[a]).onTap && o.indexOf("pswp__" + n.name) > -1 && (n.onTap(),
						i = !0);
				if (i) {
					e.stopPropagation && e.stopPropagation(),
						v = !0;
					var r = t.features.isOldAndroid ? 600 : 30;
					setTimeout(function () {
						v = !1
					}, r)
				}
			}, P = function () {
				return !e.likelyTouchDevice || g.mouseUsed || screen.width > g.fitControlsWidth
			}, k = function (e, n, i) {
				t[(i ? "add" : "remove") + "Class"](e, "pswp__" + n)
			}, I = function () {
				var e = 1 === g.getNumItemsFn();
				e !== h && (k(i, "ui--one-slide", e),
					h = e)
			}, D = function () {
				k(l, "share-modal--hidden", x)
			}, A = function () {
				return (x = !x) ? (t.removeClass(l, "pswp__share-modal--fade-in"),
					setTimeout(function () {
						x && D()
					}, 300)) : (D(),
						setTimeout(function () {
							x || t.addClass(l, "pswp__share-modal--fade-in")
						}, 30)),
					x || O(),
					!1
			}, M = function (t) {
				var n = (t = t || window.event).target || t.srcElement;
				return e.shout("shareLinkClick", t, n),
					!(!n.href || !n.hasAttribute("download") && (window.open(n.href, "pswp_share", "scrollbars=yes,resizable=yes,toolbar=no,location=yes,width=550,height=420,top=100,left=" + (window.screen ? Math.round(screen.width / 2 - 275) : 100)),
						x || A(),
						1))
			}, O = function () {
				for (var e, t, n, i, o = "", a = 0; a < g.shareButtons.length; a++)
					e = g.shareButtons[a],
						t = g.getImageURLForShare(e),
						n = g.getPageURLForShare(e),
						i = g.getTextForShare(e),
						o += '<a href="' + e.url.replace("{{url}}", encodeURIComponent(n)).replace("{{image_url}}", encodeURIComponent(t)).replace("{{raw_image_url}}", t).replace("{{text}}", encodeURIComponent(i)) + '" target="_blank" class="pswp__share--' + e.id + '"' + (e.download ? "download" : "") + ">" + e.label + "</a>",
						g.parseShareButtonOut && (o = g.parseShareButtonOut(e, o));
				l.children[0].innerHTML = o,
					l.children[0].onclick = M
			}, E = function (e) {
				for (var n = 0; n < g.closeElClasses.length; n++)
					if (t.hasClass(e, "pswp__" + g.closeElClasses[n]))
						return !0
			}, $ = 0, R = function () {
				clearTimeout(w),
					$ = 0,
					d && T.setIdle(!1)
			}, L = function (e) {
				var t = (e = e || window.event).relatedTarget || e.toElement;
				t && "HTML" !== t.nodeName || (clearTimeout(w),
					w = setTimeout(function () {
						T.setIdle(!0)
					}, g.timeToIdleOutside))
			}, F = function (e) {
				m !== e && (k(p, "preloader--active", !e),
					m = e)
			}, N = function (e) {
				var n = e.vGap;
				if (P()) {
					var r = g.barsSize;
					if (g.captionEl && "auto" === r.bottom)
						if (a || ((a = t.createEl("pswp__caption pswp__caption--fake")).appendChild(t.createEl("pswp__caption__center")),
							i.insertBefore(a, o),
							t.addClass(i, "pswp__ui--fit")),
							g.addCaptionHTMLFn(e, a, !0)) {
							var s = a.clientHeight;
							n.bottom = parseInt(s, 10) || 44
						} else
							n.bottom = r.top;
					else
						n.bottom = "auto" === r.bottom ? 0 : r.bottom;
					n.top = r.top
				} else
					n.top = n.bottom = 0
			}, z = [{
				name: "caption",
				option: "captionEl",
				onInit: function (e) {
					o = e
				}
			}, {
				name: "share-modal",
				option: "shareEl",
				onInit: function (e) {
					l = e
				},
				onTap: function () {
					A()
				}
			}, {
				name: "button--share",
				option: "shareEl",
				onInit: function (e) {
					s = e
				},
				onTap: function () {
					A()
				}
			}, {
				name: "button--zoom",
				option: "zoomEl",
				onTap: e.toggleDesktopZoom
			}, {
				name: "counter",
				option: "counterEl",
				onInit: function (e) {
					r = e
				}
			}, {
				name: "button--close",
				option: "closeEl",
				onTap: e.close
			}, {
				name: "button--arrow--left",
				option: "arrowEl",
				onTap: e.prev
			}, {
				name: "button--arrow--right",
				option: "arrowEl",
				onTap: e.next
			}, {
				name: "button--fs",
				option: "fullscreenEl",
				onTap: function () {
					n.isFullscreen() ? n.exit() : n.enter()
				}
			}, {
				name: "preloader",
				option: "preloaderEl",
				onInit: function (e) {
					p = e
				}
			}];
			T.init = function () {
				t.extend(e.options, _, !0),
					g = e.options,
					i = t.getChildByClass(e.scrollWrap, "pswp__ui"),
					u = e.listen,
					function () {
						var e;
						u("onVerticalDrag", function (e) {
							b && e < .95 ? T.hideControls() : !b && e >= .95 && T.showControls()
						}),
							u("onPinchClose", function (t) {
								b && t < .9 ? (T.hideControls(),
									e = !0) : e && !b && t > .9 && T.showControls()
							}),
							u("zoomGestureEnded", function () {
								(e = !1) && !b && T.showControls()
							})
					}(),
					u("beforeChange", T.update),
					u("doubleTap", function (t) {
						var n = e.currItem.initialZoomLevel;
						e.getZoomLevel() !== n ? e.zoomTo(n, t, 333) : e.zoomTo(g.getDoubleTapZoom(!1, e.currItem), t, 333)
					}),
					u("preventDragEvent", function (e, t, n) {
						var i = e.target || e.srcElement;
						i && i.getAttribute("class") && e.type.indexOf("mouse") > -1 && (i.getAttribute("class").indexOf("__caption") > 0 || /(SMALL|STRONG|EM)/i.test(i.tagName)) && (n.prevent = !1)
					}),
					u("bindEvents", function () {
						t.bind(i, "pswpTap click", C),
							t.bind(e.scrollWrap, "pswpTap", T.onGlobalTap),
							e.likelyTouchDevice || t.bind(e.scrollWrap, "mouseover", T.onMouseOver)
					}),
					u("unbindEvents", function () {
						x || A(),
							y && clearInterval(y),
							t.unbind(document, "mouseout", L),
							t.unbind(document, "mousemove", R),
							t.unbind(i, "pswpTap click", C),
							t.unbind(e.scrollWrap, "pswpTap", T.onGlobalTap),
							t.unbind(e.scrollWrap, "mouseover", T.onMouseOver),
							n && (t.unbind(document, n.eventK, T.updateFullscreen),
								n.isFullscreen() && (g.hideAnimationDuration = 0,
									n.exit()),
								n = null)
					}),
					u("destroy", function () {
						g.captionEl && (a && i.removeChild(a),
							t.removeClass(o, "pswp__caption--empty")),
							l && (l.children[0].onclick = null),
							t.removeClass(i, "pswp__ui--over-close"),
							t.addClass(i, "pswp__ui--hidden"),
							T.setIdle(!1)
					}),
					g.showAnimationDuration || t.removeClass(i, "pswp__ui--hidden"),
					u("initialZoomIn", function () {
						g.showAnimationDuration && t.removeClass(i, "pswp__ui--hidden")
					}),
					u("initialZoomOut", function () {
						t.addClass(i, "pswp__ui--hidden")
					}),
					u("parseVerticalMargin", N),
					function () {
						var e, n, o, a = function (i) {
							if (i)
								for (var a = i.length, r = 0; r < a; r++) {
									e = i[r],
										n = e.className;
									for (var s = 0; s < z.length; s++)
										o = z[s],
											n.indexOf("pswp__" + o.name) > -1 && (g[o.option] ? (t.removeClass(e, "pswp__element--disabled"),
												o.onInit && o.onInit(e)) : t.addClass(e, "pswp__element--disabled"))
								}
						};
						a(i.children);
						var r = t.getChildByClass(i, "pswp__top-bar");
						r && a(r.children)
					}(),
					g.shareEl && s && l && (x = !0),
					I(),
					g.timeToIdle && u("mouseUsed", function () {
						t.bind(document, "mousemove", R),
							t.bind(document, "mouseout", L),
							y = setInterval(function () {
								2 == ++$ && T.setIdle(!0)
							}, g.timeToIdle / 2)
					}),
					g.fullscreenEl && !t.features.isOldAndroid && (n || (n = T.getFullscreenAPI()),
						n ? (t.bind(document, n.eventK, T.updateFullscreen),
							T.updateFullscreen(),
							t.addClass(e.template, "pswp--supports-fs")) : t.removeClass(e.template, "pswp--supports-fs")),
					g.preloaderEl && (F(!0),
						u("beforeChange", function () {
							clearTimeout(f),
								f = setTimeout(function () {
									e.currItem && e.currItem.loading ? (!e.allowProgressiveImg() || e.currItem.img && !e.currItem.img.naturalWidth) && F(!1) : F(!0)
								}, g.loadingIndicatorDelay)
						}),
						u("imageLoadComplete", function (t, n) {
							e.currItem === n && F(!0)
						}))
			}
				,
				T.setIdle = function (e) {
					d = e,
						k(i, "ui--idle", e)
				}
				,
				T.update = function () {
					b && e.currItem ? (T.updateIndexIndicator(),
						g.captionEl && (g.addCaptionHTMLFn(e.currItem, o),
							k(o, "caption--empty", !e.currItem.title)),
						S = !0) : S = !1,
						x || A(),
						I()
				}
				,
				T.updateFullscreen = function (i) {
					i && setTimeout(function () {
						e.setScrollOffset(0, t.getScrollY())
					}, 50),
						t[(n.isFullscreen() ? "add" : "remove") + "Class"](e.template, "pswp--fs")
				}
				,
				T.updateIndexIndicator = function () {
					g.counterEl && (r.innerHTML = e.getCurrentIndex() + 1 + g.indexIndicatorSep + g.getNumItemsFn())
				}
				,
				T.onGlobalTap = function (n) {
					var i = (n = n || window.event).target || n.srcElement;
					if (!v)
						if (n.detail && "mouse" === n.detail.pointerType) {
							if (E(i))
								return void e.close();
							t.hasClass(i, "pswp__img") && (1 === e.getZoomLevel() && e.getZoomLevel() <= e.currItem.fitRatio ? g.clickToCloseNonZoomable && e.close() : e.toggleDesktopZoom(n.detail.releasePoint))
						} else if (g.tapToToggleControls && (b ? T.hideControls() : T.showControls()),
							g.tapToClose && (t.hasClass(i, "pswp__img") || E(i)))
							return void e.close()
				}
				,
				T.onMouseOver = function (e) {
					var t = (e = e || window.event).target || e.srcElement;
					k(i, "ui--over-close", E(t))
				}
				,
				T.hideControls = function () {
					t.addClass(i, "pswp__ui--hidden"),
						b = !1
				}
				,
				T.showControls = function () {
					b = !0,
						S || T.update(),
						t.removeClass(i, "pswp__ui--hidden")
				}
				,
				T.supportsFullscreen = function () {
					var e = document;
					return !!(e.exitFullscreen || e.mozCancelFullScreen || e.webkitExitFullscreen || e.msExitFullscreen)
				}
				,
				T.getFullscreenAPI = function () {
					var t, n = document.documentElement, i = "fullscreenchange";
					return n.requestFullscreen ? t = {
						enterK: "requestFullscreen",
						exitK: "exitFullscreen",
						elementK: "fullscreenElement",
						eventK: i
					} : n.mozRequestFullScreen ? t = {
						enterK: "mozRequestFullScreen",
						exitK: "mozCancelFullScreen",
						elementK: "mozFullScreenElement",
						eventK: "moz" + i
					} : n.webkitRequestFullscreen ? t = {
						enterK: "webkitRequestFullscreen",
						exitK: "webkitExitFullscreen",
						elementK: "webkitFullscreenElement",
						eventK: "webkit" + i
					} : n.msRequestFullscreen && (t = {
						enterK: "msRequestFullscreen",
						exitK: "msExitFullscreen",
						elementK: "msFullscreenElement",
						eventK: "MSFullscreenChange"
					}),
						t && (t.enter = function () {
							return c = g.closeOnScroll,
								g.closeOnScroll = !1,
								"webkitRequestFullscreen" !== this.enterK ? e.template[this.enterK]() : void e.template[this.enterK](Element.ALLOW_KEYBOARD_INPUT)
						}
							,
							t.exit = function () {
								return g.closeOnScroll = c,
									document[this.exitK]()
							}
							,
							t.isFullscreen = function () {
								return document[this.elementK]
							}
						),
						t
				}
		}
	}),
	// 真正开始操作业务dom
	function (e) {
		"use strict";
		function t(e, t) {
			return JSON.parse(e || t || "{}")
		}
		var n = e(window)
			, i = e(document)
			, o = e("html")
			, a = e("body")
			, r = n.width()
			, s = r < 768
			, l = window.T4Sstrings
			, c = e(".t4s-close-overlay")
			, d = "t4s-lock-scroll"
			, u = "[data-t4s-scroll-me]"
			, p = window.T4Sconfigs
			, m = T4Srequest.page_type
			, f = T4Sroutes.search_url
			, h = p.platform_email
			, g = p.enableConfetti
			, v = "top-start, top, top-end, left-start, left, left-end, right-start, right, right-end, bottom-start, bottom, bottom-end".split(", ")
			, y = {
				left: "right",
				"left-start": "right-start",
				"left-end": "right-end",
				right: "left",
				"right-start": "left-start",
				"right-end": "left-end"
			}
			, w = function (e) {
				return isThemeRTL && y[e] || e
			};
		T4SThemeSP.ProductItemObserver = new IntersectionObserver((entries, observer) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return

				const data_productOptions = entry.target.dataset['productOptions']
				const product_options = JSON.parse(data_productOptions || '{}')
				const impress_event = new CustomEvent('impress:productItem', {
					detail: product_options
				})
				document.dispatchEvent(impress_event)

				// 如果只需要触发一次，及时取消观察
				observer.unobserve(entry.target)
			})
		}, {
			threshold: 0.8,
		});
		T4SThemeSP.ProductMediaObserver = new IntersectionObserver((entries, observer) => {
			const pauseThreshold = 2 / 3

			entries.forEach((entry) => {
				const videoBox = entry.target
				const video = videoBox.querySelector('video')

				if (!video) {
					observer.unobserve(videoBox)
					return
				}

				if (!videoBox.isConnected) {
					video.pause()
					observer.unobserve(videoBox)
					return
				}

				const isVideoGroupVisible = window.getComputedStyle(videoBox).display !== 'none'

				if (!isVideoGroupVisible || !entry.isIntersecting || entry.intersectionRatio < pauseThreshold) {
					video.pause()
					return
				}

				if (entry.intersectionRatio >= 1) {
					video.play().catch(() => { })
				}
			})
		}, {
			threshold: [0, 2 / 3, 1],
		});
		T4SThemeSP.Tooltip = function () {
			function t(t, o, a) {
				var r = e(t)
					, s = function (e) {
						do {
							e += ~~(1e6 * Math.random())
						} while (document.getElementById(e));
						return e
					}("tooltipt4s");
				r.attr("aria-describedby", s),
					function (e, t) {
						T4SThemeSP.$appendComponent.after(n.replace("nt_txt_tt", e).replace("id_nt_tt", t))
					}(a, s);
				var l = e("#" + s);
				!function (e, t, n, i) {
					fastdomT4s.mutate(function () {
						FloatingUIT4sDOM.computePosition(e, t, {
							placement: i,
							middleware: [FloatingUIT4sDOM.offset(6), FloatingUIT4sDOM.flip({
								fallbackPlacements: ["top", "bottom"]
							}), FloatingUIT4sDOM.shift({
								padding: 5
							}), FloatingUIT4sDOM.arrow({
								element: n
							})]
						}).then(({ x: e, y: i, placement: o, middlewareData: a }) => {
							Object.assign(t.style, {
								top: "0",
								left: "0",
								transform: `translate3d(${Math.round(e)}px,${Math.round(i)}px,0)`
							});
							const { x: r, y: s } = a.arrow
								, l = {
									top: "bottom",
									right: "left",
									bottom: "top",
									left: "right"
								}[o.split("-")[0]];
							Object.assign(n.style, {
								left: null != r ? `${r}px` : "",
								top: null != s ? `${s}px` : "",
								right: "",
								bottom: "",
								[l]: "-4px"
							})
						}
						)
					})
				}(t, l[0], l.find(".t4s-tt-arrow")[0], o),
					l.addClass(i)
			}
			var n = '<div class="tooltip t4s-tooltip" id="id_nt_tt" role="tooltip"><div class="t4s-tt-arrow"></div><div class="tooltip-inner">nt_txt_tt</div></div>'
				, i = "is--show"
				, o = function (e) {
					var t = e.text();
					return e.attr("title") && "string" != typeof e.attr("data-original-title") && (t = e.attr("title"),
						e.attr("data-original-title", e.attr("title") || "").attr("title", "")),
						e.attr("data-t4s-tooltip") ? t = e.attr("data-t4s-tooltip") : e.attr("data-original-title") && (t = e.attr("data-original-title")),
						t
				};
			return a.on("t4s:hideTooltip", function () {
				e(".tooltip.t4s-tooltip.is--show").remove()
			}),
				function (n) {
					if (!T4SThemeSP.isTouch) {
						var a = e("[data-tooltip]:not(.t4s-tooltip-actived)");
						0 != a.length && a.hoverIntent({
							sensitivity: 6,
							interval: 80,
							timeout: 100,
							over: function (n) {
								var i = e(this).attr("data-tooltip") || "nt94";
								v.indexOf(i) < 0 || t(this, w(i), o(e(this)))
							},
							out: function (t) {
								var n, o, a = e(this).attr("data-tooltip") || "nt94";
								v.indexOf(a) < 0 || ((o = e("#" + e(n = this).attr("aria-describedby"))).removeClass(i),
									o.remove(),
									e(n).attr("aria-describedby", ""))
							}
						}).addClass("t4s-tooltip-actived")
					}
				}
		}(),
			T4SThemeSP.LookBook = function () {
				function t(t, n, i = !1) {
					if (t.hasClass(f.loaded))
						i && r(t, n);
					else {
						var o = t.data("sid")
							, a = h[n + o];
						if (!t.is("[data-is-pr]"))
							return t.addClass(f.loaded),
								a = e("#tem" + n).html(),
								T4SThemeSP.$appendComponent.after(a.replace('id=""', 'id="' + n + '"')),
								void (i && r(t, n));
						a ? (T4SThemeSP.$appendComponent.after(a),
							t.addClass(f.loaded),
							T4SThemeSP.ProductItem.init(),
							T4SThemeSP.Tooltip(),
							i && r(t, n)) : (t.addClass(f.loading),
								fetch(t.data("href") + "/?section_id=" + o).then(function (e) {
									return e.text()
								}).then(function (e) {
									e = (e = e.split("[t4splitlz]")[1]).replace("id_nt_t4s", n),
										T4SThemeSP.$appendComponent.after(e),
										t.removeClass(f.loading).addClass(f.loaded),
										T4SThemeSP.ProductItem.init(),
										T4SThemeSP.Tooltip(),
										i && r(t, n),
										g && (h[n + o] = e)
								}).catch(function (e) {
									t.removeClass(f.loading)
								}))
					}
				}
				function a() {
					s && (o.removeClass(d),
						T4SThemeSP.Helpers.disableBodyScroll(!1, u)),
						e("[data-pin-close],[data-pin-popup]." + f.clicked).off("click.closelb"),
						i.off("click.closelb").off("keyup.closelb"),
						e("[data-pin-wrapper]." + f.opened).removeClass(f.opened),
						e("[data-pin-popup]." + f.clicked).removeClass(f.clicked),
						c.removeClass(f.visible)
				}
				function r(t, r, l = "lb") {
					!function (t) {
						s && (o.addClass(d),
							T4SThemeSP.Helpers.disableBodyScroll(!0, u)),
							e("#" + t).addClass(f.opened),
							c.addClass(f.visible)
					}(r);
					var m = e("#" + r)
						, h = m[0]
						, g = m.find(".t4s-" + l + "-arrow")
						, v = t.data("position") || "top";
					n.width() > 767 && function (e, t, n, i) {
						fastdomT4s.mutate(function () {
							FloatingUIT4sDOM.computePosition(e, t, {
								placement: i,
								middleware: [FloatingUIT4sDOM.offset(12), FloatingUIT4sDOM.flip({
									fallbackPlacements: ["top", "bottom"]
								}), FloatingUIT4sDOM.shift({
									padding: 0
								}), FloatingUIT4sDOM.arrow({
									element: n
								})]
							}).then(({ x: e, y: i, placement: o, middlewareData: a }) => {
								Object.assign(t.style, {
									top: "0",
									left: "0",
									transform: `translate3d(${Math.round(e)}px,${Math.round(i)}px,0)`
								});
								const { x: r, y: s } = a.arrow
									, l = {
										top: "bottom",
										right: "left",
										bottom: "top",
										left: "right"
									}[o.split("-")[0]];
								Object.assign(n.style, {
									left: null != r ? `${r}px` : "",
									top: null != s ? `${s}px` : "",
									right: "",
									bottom: "",
									[l]: "-6px"
								})
							}
							)
						})
					}(t[0], h, g[0], w(v)),
						"lb" == l ? (i.on("click.closelb", function (t) {
							var n = e(t.target);
							n.closest("[data-pin-wrapper]").length > 0 || n.is("[data-pin-popup]") || a()
						}),
							e(`#${r} [data-pin-close], [data-pin-popup].${f.clicked}`).on("click.closelb", function (e) {
								e.preventDefault(),
									e.stopPropagation(),
									a()
							}),
							i.on("keyup.closelb", function (e) {
								27 === e.keyCode && a()
							})) : (i.on("click.closeDrop", function (t) {
								var n = e(t.target);
								n.closest("[data-dropdown-wrapper]").length > 0 || n.is("[data-dropdown-open]") || p()
							}),
								e(`#${r} [data-dropdown-close], [data-dropdown-open].${f.clicked}`).on("click.closeDrop", function (e) {
									e.preventDefault(),
										e.stopPropagation(),
										p()
								}),
								i.on("keyup.closeDrop", function (e) {
									27 === e.keyCode && p()
								}))
				}
				function l() {
					i.on("click", "[data-pin-popup]:not(." + f.clicked + ")", function (n) {
						n.preventDefault();
						var i = e(this)
							, o = i.data("bid");
						a(),
							i.addClass(f.clicked),
							t(i, o, !0)
					}),
						e("[data-pin-popup][data-is-pr]:not(." + f.clicked + "):not(." + f.opened + ")").on("mouseenter.pin", function (n) {
							var i = e(this)
								, o = i.data("bid");
							i.addClass(f.preload),
								t(i, o),
								i.off("touchstart.pin mouseenter.pin")
						})
				}
				function p() {
					o.removeClass(d),
						T4SThemeSP.Helpers.disableBodyScroll(!1, u),
						e("[data-dropdown-close],[data-dropdown-open]." + f.clicked).off("click.closeDrop"),
						i.off("click.closeDrop").off("keyup.closeDrop"),
						e("[data-dropdown-wrapper]." + f.opened).removeClass(f.opened),
						e("[data-dropdown-open]." + f.clicked).removeClass(f.clicked),
						c.removeClass(f.visible)
				}
				function m() {
					i.on("click", "[data-dropdown-open]:not(." + f.clicked + ")", function (t) {
						t.preventDefault();
						var n = e(this)
							, i = n.data("id");
						p(),
							n.addClass(f.clicked),
							r(n, i, "drop"),
							function (t) {
								e("#" + t).on("click.dopText", "[data-dropdown-item]", function (n) {
									n.preventDefault();
									var i = e(this);
									i.parents().find("." + f.selected).removeClass(f.selected),
										i.addClass(f.selected),
										e('[data-dropdown-open][data-id="' + t + '"]>span').text(i.text()),
										e("#" + t).off("click.dopText"),
										p()
								})
							}(i)
					}),
						i.on("click", "[data-dropdown-off]", function (t) {
							var n = e(this);
							e(this).closest("[data-dropdown-wrapper]").find("[data-dropdown-open]>span").text(n.text()),
								p()
						}),
						i.on("dropdown:t4s:close", function (e) {
							p()
						})
				}
				var f = {
					loading: "is--loading",
					loaded: "is--loaded",
					clicked: "is--clicked",
					selected: "is--selected",
					opened: "is--opened",
					preload: "is--preLoaded",
					visible: "is--visible is--pindop"
				}
					, h = []
					, g = !1;
				return function () {
					l(),
						m()
				}
			}(),
			T4SThemeSP.ProductItem = (function () {
				var settings = p;
				var strings = T4SProductStrings;

				var buttonTemplate = e("#btns_pr_temp").html();

				var COLOR_OPTIONS_ATTR = "data-color-options";
				var COLOR_OPTIONS_SELECTOR = "[" + COLOR_OPTIONS_ATTR + "]";
				var PRODUCT_OPTIONS_SELECTOR = "[data-product-options]";
				var PRODUCT_LINK_SELECTOR = "[data-pr-href]";
				var PRODUCT_IMAGE_SELECTOR = "[data-pr-img]";

				var CLASS_CREATED = "is-t4s-pr-created";
				var CLASS_SWATCH_CALCED = "is-t4s--calced";
				var CLASS_SWATCH_LIMIT = "is-t4s--limit";
				var CLASS_SWATCH_OPENED = "is-t4s--opended";
				var CLASS_LOADING = "is--loading";
				var CLASS_HREF_REPLACED = "is--href-replaced";

				var swatchMoreText = strings.swatch_limit;
				var swatchLessText = strings.swatch_limit_less;

				var quickShopCache = [];

				var reviewApp = String(settings.app_review);
				var enableQuickshop = settings.enable_quickshop;
				var showQuantity = settings.show_qty;
				var showHoverImage = String(settings.show_img);
				var swatchClickMode = String(settings.swatch_click);
				var swatchItemStyle = settings.sw_item_style;
				var currentVariantMode = settings.pr_curent;

				var badgeText = {
					sale: strings.badgeSale,
					new: strings.badgeNew,
					preOrder: strings.badgepreOrder,
					soldout: strings.badgeSoldout,
					SavePercent: strings.badgeSavePercent
				};

				var sort_by_colors_map = {}

				// 返回 handle 和颜色handle
				function getSortByMapColors() {
					const colorStr = getUrlParam('sort_by_color') || ''
					const sortByStr = getUrlParam('sort_by') || ''

					const colors = colorStr.split(',').map((colorName) => {
						const color = colorName.trim().toLowerCase()
						return !color || color === '_x' ? '' : T4SThemeSP.handle(color)
					})

					const sortByHandles = sortByStr.split(',')

					// colors 一定按顺序对应商品 handle
					return sortByHandles.reduce((result, handle, index) => {
						handle = handle.trim()

						if (handle) {
							result[handle] = colors[index] || ''
						}

						return result
					}, {})
				}

				sort_by_colors_map = getSortByMapColors()

				function checkIsTopAndgetOptDOM($product, productData) {
					if (!sort_by_colors_map || !Object.keys(sort_by_colors_map).length) {
						return
					}

					if (!$product || !$product.length || !$product.is("[data-is-top]")) {
						return
					}

					var productHandle = productData && productData.handle
					var colorHandle = productHandle && sort_by_colors_map[productHandle]

					if (!colorHandle) {
						return
					}

					var $colorItem = $product
						.find(".t4s-pr-color__item[data-color-handle]")
						.filter(function () {
							return e(this).attr("data-color-handle") === colorHandle
						})
						.first()

					return $colorItem.length ? $colorItem : undefined
				}

				function refreshSortByColorSelection() {
					sort_by_colors_map = getSortByMapColors()
					var selectedCount = 0

					e(PRODUCT_OPTIONS_SELECTOR).each(function () {
						var $product = e(this)
						var productOptions = $product.attr("data-product-options")

						if (!productOptions) {
							return
						}

						var productData = t(productOptions)
						var $colorItem = checkIsTopAndgetOptDOM($product, productData)

						if ($colorItem && $colorItem.length) {
							selectSwatch($colorItem)
							selectedCount += 1
						}
					})

					return selectedCount
				}

				function recalculateSwatches(force) {
					if (!swatchMoreText) return;

					var selector = force
						? COLOR_OPTIONS_SELECTOR
						: COLOR_OPTIONS_SELECTOR + ":not(." + CLASS_SWATCH_CALCED + ")";

					fastdomT4s.measure(function () {
						e(selector).each(function () {
							var $colorList = e(this);
							var $items = $colorList.find(".t4s-pr-color__item");

							var itemWidth = $items.outerWidth(true);
							var itemCount = $items.length - 1;
							var visibleCount = Math.floor($colorList.outerWidth() / itemWidth);
							var hiddenCount = itemCount - visibleCount;

							fastdomT4s.mutate(function () {
								$colorList
									.addClass(CLASS_SWATCH_CALCED)
									.removeClass(CLASS_SWATCH_LIMIT);

								$colorList.find(".is-color--limit").removeClass("is-color--limit");

								if (hiddenCount > 0 && hiddenCount !== itemCount) {
									hiddenCount += 1;

									$colorList
										.addClass(CLASS_SWATCH_LIMIT)
										.attr("data-limit", visibleCount)
										.attr(
											"style",
											'--text : "+' + hiddenCount + '";--text2 : "-' + hiddenCount + '"'
										);

									$items.eq(visibleCount - 2).addClass("is-color--limit");
								}
							});
						});
					});
				}

				function getSizedImageUrl(image, width) {
					if (!image) return "";

					if (/([?&])width=\d+/.test(image)) {
						return image.replace(/([?&])width=\d+/, "$1width=" + width);
					}

					return image + (image.indexOf("?") > -1 ? "&" : "?") + "width=" + width;
				}

				function getImageSrcset(image, widths) {
					return widths
						.map(function (width) {
							return getSizedImageUrl(image, width) + " " + width + "w";
						})
						.join(", ");
				}

				function selectSwatch($swatch) {
					var image = $swatch.attr("data-img");
					var variantId = $swatch.attr("data-vid");

					var $product = $swatch.closest(PRODUCT_OPTIONS_SELECTOR);
					var $image = $product.find(PRODUCT_IMAGE_SELECTOR);
					var $image_wrapper = $product.find('.t4s-product-img-wrapper')
					var $video_wrapper = $product.find('.t4s-product-video-wrapper')

					var $link = $product.find(PRODUCT_LINK_SELECTOR);

					var href = $link.attr("href");

					$image_wrapper.show()
					$video_wrapper.hide()
					$swatch
						.closest(COLOR_OPTIONS_SELECTOR)
						.find(".is-swatch--selected")
						.removeClass("is-swatch--selected");

					$swatch.addClass("is-swatch--selected");
					$product.addClass("t4s-colors-selected");

					if (image && image !== "none") {
						var imageWidths = [400, 600, 800, 1000, 1200];
						var imageSrc = getSizedImageUrl(image, 600);
						var imageSrcset = getImageSrcset(image, imageWidths);

						$image.attr({
							src: imageSrc,
							srcset: imageSrcset,
							"data-src": imageSrc,
							"data-srcset": imageSrcset,
						});
					}

					if (currentVariantMode !== "1" && variantId) {
						if (/variant=/.test(href)) {
							href = href.replace(/(variant=)[^&]+/, "$1" + variantId);
						} else if (/\?/.test(href)) {
							href += "&variant=" + variantId;
						} else {
							href += "?variant=" + variantId;
						}

						$link.attr("href", href);
					}
				}

				function replaceCollectionProductLinks() {
					if (!settings.within_cat) return;

					var linkSelector = "[data-pr-href]:not(." + CLASS_HREF_REPLACED + ")";

					if (!e(linkSelector).length) return;

					e("[data-collection-url]").each(function () {
						var collectionUrl = e(this).attr("data-collection-url");

						e(this).find(linkSelector).each(function () {
							var href = e(this).attr("href");
							var productPath = "/products/" + href.split("/products/")[1];

							e(this)
								.attr("href", collectionUrl + productPath)
								.addClass(CLASS_HREF_REPLACED);
						});
					});
				}

				function renderHoverImage($product, image2, alt) {
					var html = "";

					if (showHoverImage === "2" && image2) {
						html =
							'<img data-src="' + image2 + '"' +
							' data-pr-img2' +
							' class="t4s-product-hover-img lazyloadt4s"' +
							' loading="lazy"' +
							' src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="' +
							' data-widths="[100,200,400,600,700,800,900]"' +
							' data-optimumx="1.5"' +
							' data-sizes="auto"' +
							' alt="' + (alt || "") + '">';

						$product.find(".t4s-product-img").addClass("is-show-img2");
					}

					$product.find("[data-replace-img2]").replaceWith(html);
				}

				function renderButtons($product, productData, productUrl) {
					var tooltipAttr = "data-tooltip";
					var tooltipPrefix = tooltipAttr + '="';
					var templateProductIdAttr = 'data-pr-id="';
					var realProductIdAttr = 'data-id="';

					var $quickview = $product.find("[data-replace-quickview]");
					var $compare = $product.find("[data-replace-compare]");
					var $wishlist = $product.find("[data-replace-wishlist]");
					var $atc = $product.find("[data-replace-atc]");

					var atcHasQuantity = $atc.is("[data-has-qty]");

					var parts = buttonTemplate
						.replace(/t4s_pr_url/g, productUrl)
						.split("[split_t4nt]");

					$quickview.replaceWith(
						parts[0]
							.replace(tooltipPrefix, tooltipPrefix + ($quickview.attr(tooltipAttr) || ""))
							.replace(templateProductIdAttr, realProductIdAttr + productData.id)
					);

					$compare.replaceWith(
						parts[1]
							.replace(tooltipPrefix, tooltipPrefix + ($compare.attr(tooltipAttr) || ""))
							.replace(templateProductIdAttr, realProductIdAttr + productData.id)
					);

					$wishlist.replaceWith(
						parts[2]
							.replace(tooltipPrefix, tooltipPrefix + ($wishlist.attr(tooltipAttr) || ""))
							.replace(templateProductIdAttr, realProductIdAttr + productData.id)
					);

					$atc.replaceWith(
						parts[3]
							.replace(tooltipPrefix, tooltipPrefix + ($atc.attr(tooltipAttr) || ""))
							.replace(templateProductIdAttr, realProductIdAttr + productData.id)
					);

					var $atcButton = $product.find("[data-atc-selector]");
					var $text = $atcButton.find(".t4s-text-pr");
					var $icon = $atcButton.find(".t4s-svg-pr-icon use");

					if (productData.isExternal) {
						$atcButton.attr("href", productData.external_link).attr("target", "_blank");
						$text.text(productData.external_title);
						$icon.attr("xlink:href", "#t4s-icon-external");
						return;
					}

					if (!productData.available) {
						$text.text(strings.readMore);
						$icon.attr("xlink:href", "#t4s-icon-link");
						return;
					}

					if (productData.isGrouped) {
						$text.text(strings.preView);
						return;
					}

					if (productData.isDefault) {
						if (productData.isPreoder) {
							$text.text(strings.preOrder);
						}

						$atcButton.attr({
							"data-action-atc": "",
							"data-variant-id": productData.VariantFirstID
						});

						if (showQuantity && atcHasQuantity && $atcButton[0]) {
							var buttonHtml = $atcButton[0].outerHTML;
							var quantityHtml = parts[4].replace(
								'max="9999"',
								'max="' + productData.maxQuantity + '"'
							);

							$atcButton.replaceWith(
								'<div class="t4s-product-atc-qty">' + quantityHtml + buttonHtml + "</div>"
							);
						}

						return;
					}

					if (enableQuickshop) {
						$atcButton.attr("data-action-quickshop", "");
						$text.text(strings.quickShop);
					} else {
						$text.text(strings.selectOption);
					}
				}

				function renderBadges($product, productData) {
					var $badge = $product.find("[data-product-badge]");
					if (!$badge.length) return;

					var sort = $badge.attr("data-sort").replace(/ /g, "").split(",");
					var html = "";

					sort.forEach(function (type) {
						if (type === "sale") {
							var compareAtPrice = productData.compare_at_price;
							var price = productData.price;

							if (compareAtPrice <= price || !settings.use_sale_badge) return;

							var saleText;

							if (settings.label_sale_style === "2") {
								var percent = 100 * (compareAtPrice - price) / compareAtPrice;
								saleText = badgeText.SavePercent.replace("[sale]", Math.round(percent));
							} else if (settings.label_sale_style === "3") {
								saleText = T4SThemeSP.Currency.formatMoney(compareAtPrice - price);
							} else {
								saleText = badgeText.sale;
							}

							html += '<span class="t4s-badge-item t4s-badge-sale">' + saleText + "</span>";
						}

						if (type === "preOrder" && productData.isPreoder && settings.use_preorder_badge) {
							html += '<span class="t4s-badge-item t4s-badge-preorder">' + badgeText.preOrder + "</span>";
						}

						if (type === "new" && settings.use_new_badge) {
							var ageSeconds = settings.nowTimestamp - productData.dateStart;
							var ageDays = Math.floor(Math.floor(ageSeconds / 3600) / 24);

							if (ageDays < settings.new_day_int) {
								html += '<span class="t4s-badge-item t4s-badge-new">' + badgeText.new + "</span>";
							}
						}

						if (type === "soldout" && !productData.available && settings.use_soldout_badge) {
							html += '<span class="t4s-badge-item t4s-badge-soldout">' + badgeText.soldout + "</span>";
						}

						if (
							!["sale", "preOrder", "new", "soldout"].includes(type) &&
							productData.customBadge &&
							settings.use_custom_badge
						) {
							productData.customBadge.forEach(function (badge, index) {
								html +=
									'<span class="t4s-badge-item t4s-badge-custom t4s-badge-' +
									productData.customBadgeHandle[index] +
									'">' +
									badge +
									"</span>";
							});
						}
					});

					$badge.html(html);
				}

				function renderColorSwatches($product, productUrl) {
					var $colorOptions = $product.find(COLOR_OPTIONS_SELECTOR);
					if (!$colorOptions.length) return;

					var colorData = t($colorOptions.attr(COLOR_OPTIONS_ATTR));

					var colorNames = colorData.color_variants;
					var colorHandles = colorData.color_variants_handle;
					var imageOptions = colorData.img_options;
					var variantImages = colorData.img_variants;
					var variantIds = colorData.id_variants;
					var imageRatios = colorData.img_ratios;
					var colorFabricMap = colorData.color_fabric_map || {};

					var html = "";
					var hasVariantImages = variantImages.length > 0;

					colorNames.forEach(function (colorName, index) {
						var colorHandle = colorHandles[index];
						var imageIndex = imageOptions.indexOf(colorName);

						if (imageIndex < 0) {
							imageIndex = imageOptions.findIndex(function (imageOption) {
								return T4SThemeSP.handle(String(imageOption || "")) === colorHandle;
							});
						}

						var hasMatchingImage = hasVariantImages && imageIndex >= 0;
						var rawImage = hasMatchingImage ? variantImages[imageIndex] : "nt94";
						rawImage = rawImage || "nt94";
						var variantId = imageIndex >= 0 ? variantIds[imageIndex] : "";
						var imageRatio = imageIndex >= 0 ? imageRatios[imageIndex] : "";

						var productImage = rawImage !== "nt94"
							? T4SThemeSP.Images.lazyloadImagePath(rawImage)
							: "none";

						var backgroundData = rawImage !== "nt94" && swatchItemStyle === "2"
							? 'data-bg="' + T4SThemeSP.Images.getNewImageUrl(rawImage, 100) + '"'
							: "";

						var imageName = colorFabricMap[colorName] || colorHandle;
						var swatchImageUrl = window.ogl_config.asset_img_url + imageName + "_50x.png";

						var handleParts = colorHandle.split("-");
						var fallbackColor = handleParts[handleParts.length - 1] || colorHandle;

						html +=
							'<span class="t4s-pr-color__item"' +
							' data-vid="' + (variantId || "") + '"' +
							' data-tooltip="top"' +
							' data-img="' + productImage + '"' +
							' data-ratio="' + (imageRatio || "") + '"' +
							' data-color-handle="' + colorHandle + '">' +
							'<span class="t4s-pr-color__name">' + colorName + "</span>" +
							'<span style="background-image: url(' + swatchImageUrl + '); background-color:' + fallbackColor + '"' +
							' class="t4s-pr-color__value bg_color_' + colorHandle + ' lazyloadt4s" ' +
							backgroundData +
							"></span>" +
							"</span>";
					});

					if (colorNames.length > 2 && swatchMoreText) {
						html +=
							'<span class="t4s-pr-color__item is--colors-more" data-tooltip="top-end">' +
							'<span class="t4s-pr-color__name">' + swatchMoreText + "</span>" +
							'<a href="' + productUrl + '" class="t4s-pr-color__value bg_color_limit4"></a>' +
							"</span>";
					}

					$colorOptions.html(html);
				}

				function initProductCards() {
					replaceCollectionProductLinks();

					e(PRODUCT_OPTIONS_SELECTOR + ":not(." + CLASS_CREATED + ")").each(function () {
						var $product = e(this);
						var productData = t($product.attr("data-product-options"));
						var productUrl = $product.find(PRODUCT_LINK_SELECTOR).attr("href");

						renderHoverImage($product, productData.image2, productData.title || "");
						renderButtons($product, productData, productUrl);
						renderBadges($product, productData);
						renderColorSwatches($product, productUrl);
						recalculateSwatches();

						$product.addClass(CLASS_CREATED);
					});

					refreshSortByColorSelection();

					T4SThemeSP.Tooltip();
					T4SThemeSP.Compare.updateAll();
					T4SThemeSP.Wishlist.updateAll();

					// 如果要观察所有商品，应使用：
					e(PRODUCT_OPTIONS_SELECTOR).each(function () {
						if (this.dataset.impressObserved === '1') return

						this.dataset.impressObserved = '1'
						T4SThemeSP.ProductItemObserver.observe(this);
					});

					e(PRODUCT_OPTIONS_SELECTOR).each(function () {
						var videoBox = this.querySelector('.t4s-product-video-wrapper');

						if (!videoBox || videoBox.dataset.mediaAbObserved === '1') return;

						videoBox.dataset.mediaAbObserved = '1';
						T4SThemeSP.ProductMediaObserver.observe(videoBox);
					});
				}

				function initQuickViewAndQuickShop() {
					function initQuickViewPopup() {
						var $quickView = e(".t4s-product-quick-view");
						var $product = $quickView.find("[data-product-featured]:not(.initProducts__enabled)");

						$product.addClass("initProducts__enabled");
						new T4SThemeSP.Product($product[0]);

						var $media = $quickView.find("[data-main-media]");

						if ($media.hasClass("flickityt4s") && !$media.hasClass("flickityt4s-enabled")) {
							$media[0].flickityt4s = new T4SThemeSP.Carousel($media[0]);
						}

						T4SThemeSP.PopupMFP();
						T4SThemeSP.initGroupsProduct();

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}

						T4SThemeSP.ProductItem.reloadReview();
					}

					function initQuickShopPopup() {
						var $quickShop = e(".t4s-product-quick-shop:not(.initProducts__enabled)");

						$quickShop.addClass("initProducts__enabled");
						new T4SThemeSP.Product($quickShop[0]);

						if (window.Shopify && Shopify.PaymentButton) {
							Shopify.PaymentButton.init();
						}
					}

					if (showQuantity) {
						o.addClass("t4s-pr-item-has-qty");
					}

					a.on("click", "[data-action-quickview], [data-action-quickshop]", function (event) {
						event.preventDefault();

						var $button = e(this);
						if ($button.hasClass(CLASS_LOADING)) return;

						var url = $button.attr("href");
						var isQuickView = $button.is("[data-action-quickview]");

						var sectionId = isQuickView ? "main-qv" : "main-qs";
						var openingClass = isQuickView ? "t4s-opening-qv" : "t4s-opening-qs";
						var productId = $button.data("id");
						// Allow each Quick View entry point to style the modal it opens.
						var modalClass = $button.attr("data-modal-class") || "";

						var cachedHtml = quickShopCache[sectionId + productId];

						T4SThemeSP.isEditCartReplace = "0" == $button.data("edit");
						T4SThemeSP.iDVariantEdit = productId;
						T4SThemeSP.keyVariantEdit = $button.data("key");

						if (cachedHtml) {
							T4SThemeSP.NTpopupInline(
								cachedHtml,
								sectionId,
								isQuickView ? initQuickViewPopup : initQuickShopPopup,
								openingClass,
								modalClass
							);

							a.trigger("modalt4s:opened");
							return;
						}

						if (T4SThemeSP.isEditCartReplace) {
							var $cartItem = $button.closest("[data-cart-item]");
							var $cartWrapper = $button.closest("[data-cart-wrapper]");
							var $loaderBar = $cartItem.find(".t4s-cart-ld__bar");
							var $spinner = $loaderBar.find(".t4s-cart-spinner");

							$cartWrapper.addClass("is--contentUpdate");
							$cartItem.addClass("is--update");
							$loaderBar.removeAttr("hidden");
							$spinner.removeAttr("hidden");

							i.on("cart:updated", function () {
								$cartWrapper.removeClass("is--contentUpdate");
								i.off("cart:updated");
								$cartItem.removeClass("is--update");
								$loaderBar.attr("hidden", "");
								$spinner.attr("hidden", "");
							});
						} else {
							$button.addClass(CLASS_LOADING);
						}
						window.oglLoading(true)

						fetch(addSectionIdToUrl(url, "section_id=" + sectionId))
							.then(function (response) {
								return response.text();
							})
							.then(function (html) {
								$button.removeClass(CLASS_LOADING);
								i.trigger("cart:updated");

								html = IsDesignMode
									? e(html).find("template").html()
									: e(html).html();

								T4SThemeSP.NTpopupInline(
									html,
									sectionId,
									isQuickView ? initQuickViewPopup : initQuickShopPopup,
									openingClass,
									modalClass
								);

								window.oglLoading(false)

								a.trigger("modalt4s:opened");
								quickShopCache[sectionId + productId] = html;
							})
							.catch(function (error) {
								$button.removeClass(CLASS_LOADING);
								i.trigger("cart:updated");
							});
					});
				}

				function addSectionIdToUrl(url, query) {
					return url + (url.indexOf("?") > -1 || url.indexOf("&") > -1 ? "&" : "/?") + query;
				}

				return {
					init: initProductCards,

					initQuickVS: initQuickViewAndQuickShop,

					refreshSortByColorSelection: refreshSortByColorSelection,

					recalculateSwatches: recalculateSwatches,

					clickMoreSwatches: function () {
						if (!swatchMoreText || swatchClickMode === "2") return;

						a.on("click", ".t4s-pr-color__item.is--colors-more>a", function (event) {
							event.preventDefault();

							var $colorList = e(this).closest("." + CLASS_SWATCH_LIMIT);

							if ($colorList.hasClass(CLASS_SWATCH_OPENED)) {
								$colorList.removeClass(CLASS_SWATCH_OPENED);
								e(this).siblings().text(swatchMoreText);
							} else {
								$colorList.addClass(CLASS_SWATCH_OPENED);
								e(this).siblings().text(swatchLessText);
							}
						});
					},

					swatchesClickHover: function () {
						var selector = '.t4s-pr-color__item:not(.is-swatch--current):not([data-img="none"]):not(.is--colors-more)';

						if (T4SThemeSP.isTouch) {
							a.on("click", selector, function () {
								selectSwatch(e(this));
							});
						} else {
							a.hoverIntent({
								selector: selector,
								sensitivity: 6,
								interval: 100,
								timeout: 100,
								over: function () {
									selectSwatch(e(this));
								},
								out: function () { }
							});
						}
					},

					resizeObserver: function () {
						var selector =
							"[data-t4s-resizeobserver].flickityt4s-enabled .t4s-product:not(.t4s_observered), " +
							"[data-t4s-resizeobserver].isotopet4s-enabled .t4s-product:not(.t4s_observered)";

						var $products = e(selector);

						if (!$products.length || !window.ResizeObserver) return;

						var observer = new ResizeObserver(function (entries) {
							entries.forEach(function (entry) {
								var timer;
								var $target = e(entry.target);
								var $wrapper = $target.is("[data-t4s-resizeobserver]")
									? $target
									: $target.closest("[data-t4s-resizeobserver]");

								clearTimeout(timer);

								$wrapper.addClass("is-t4s--doing");

								timer = setTimeout(function () {
									if ($wrapper.hasClass("flickityt4s-enabled")) {
										$wrapper.flickityt4s("resize");
									} else if ($wrapper.hasClass("isotopet4s-enabled")) {
										$wrapper.isotopet4s("layout");
									}

									$wrapper.removeClass("is-t4s--doing");
								}, 250);
							});
						});

						$products.each(function () {
							observer.observe(this);
							e(this).addClass("t4s_observered");
						});
					},

					reloadReview: function () {
						if (reviewApp === "1" && typeof SPR !== "undefined") {
							window.SPR.registerCallbacks();
							window.SPR.initRatingHandler();
							window.SPR.initDomEls();
							window.SPR.loadProducts();
							window.SPR.loadBadges();
							return;
						}

						if (reviewApp === "8" && typeof SMARTIFYAPPS !== "undefined" && SMARTIFYAPPS.rv.installed) {
							SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();
						} else if (reviewApp === "6") {
							a.trigger("reloadReview.t4s");
						}
					},

					loadjsRevew: function () {
						if (reviewApp === "6") {
							$script(settings.script12);
						}
					}
				};
			})(),
			T4SThemeSP.ProductAjax = (function () {
				function createJsonRequestOptions(acceptType = "json") {
					return {
						method: "POST",
						headers: {
							"Content-Type": "application/json",
							Accept: `application/${acceptType}`
						}
					};
				}

				function showAddToCartError(message = !1) {
					if (message && !disableAddToCartError) {
						T4SThemeSP.Notices(message);
					}
				}

				function serializeForm(form) {
					var fields = [];

					Array.prototype.slice.call(form.elements).forEach(function (field) {
						if (
							!field.name ||
							field.disabled ||
							["file", "reset", "submit", "button"].indexOf(field.type) > -1
						) {
							return;
						}

						if ("select-multiple" !== field.type) {
							if (["checkbox", "radio"].indexOf(field.type) > -1 && !field.checked) {
								return;
							}

							fields.push(
								encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value)
							);
							return;
						}

						Array.prototype.slice.call(field.options).forEach(function (option) {
							if (option.selected) {
								fields.push(
									encodeURIComponent(field.name) + "=" + encodeURIComponent(option.value)
								);
							}
						});
					});

					return fields.join("&");
				}

				function renderCartSections(sections) {
					if (sections) {
						T4SThemeSP.Cart.renderContents(sections);
					} else {
						T4SThemeSP.Cart.getToFetch();
					}
				}

				function submitAddToCartForm(button) {
					button.addClass(classes.loading).attr(attrs.disabled, !0);
					button.find(".loading-overlay__spinner").removeAttr("hidden");
					button.find(".t4s-svg-spinner").removeAttr("hidden");

					const requestOptions = {
						method: "POST",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded",
							"X-Requested-With": "XMLHttpRequest"
						}
					};

					var form = button.closest("form")[0];

					requestOptions.body =
						serializeForm(form) +
						"&sections=" +
						sectionsToRender +
						"&sections_url=" +
						encodeURIComponent(window.location.pathname);

					requestOptions.credentials = "same-origin";

					i.on("cart:updated", function () {
						button.removeClass(classes.loading).removeAttr(attrs.disabled);
						button.find(".loading-overlay__spinner").attr("hidden", "");
						button.find(".t4s-svg-spinner").attr("hidden", "");

						i.off("cart:updated");
						a.trigger("modalt4s:closed");
					});

					fetch(`${cartAddUrl}`, requestOptions)
						.then(response => response.json())
						.then(response => {
							if (response.status) {
								showAddToCartError(response.description);
								i.trigger("cart:updated");
								return;
							}

							if (
								T4SThemeSP.isEditCartReplace &&
								response.variant_id != T4SThemeSP.iDVariantEdit
							) {
								const changeRequestOptions = createJsonRequestOptions("javascript");

								changeRequestOptions.headers["X-Requested-With"] = "XMLHttpRequest";
								changeRequestOptions.body = JSON.stringify({
									id: `${T4SThemeSP.keyVariantEdit}`,
									quantity: 0
								});

								fetch(`${cartChangeUrl}`, changeRequestOptions)
									.then(response => response.json())
									.then(response => {
										if (response.status) {
											showAddToCartError(response.description);
											return;
										}

										i.trigger("add:cart:success", [requestOptions]).trigger(
											"add:cart:upsell"
										);
										renderCartSections(response.sections);
									})
									.catch(error => {
										window.report_faro({
											file_name: 'assets/interactable.js',
											func_name: 'submitAddToCartForm',
											desc: 'Failed to replace the cart item',
											error: error
										});
									});

								return;
							}

							i.trigger("add:cart:success", [requestOptions]).trigger(
								"add:cart:upsell"
							);
							renderCartSections(response.sections);
						})
						.catch(() => {
							i.trigger("cart:updated");
						})
						.finally(() => { });
				}

				function changeCartItem(triggerElement, itemId, quantity) {
					var cartItem = triggerElement.closest("[data-cart-item]");
					var cartWrapper = triggerElement.closest("[data-cart-wrapper]");
					var loadingBar = cartItem.find(".t4s-cart-ld__bar");
					var spinner = loadingBar.find(".t4s-cart-spinner");

					cartWrapper.addClass("is--contentUpdate");
					cartItem.addClass("is--update");
					loadingBar.removeAttr("hidden");
					spinner.removeAttr("hidden");

					i.on("cart:updated", function () {
						cartWrapper.removeClass("is--contentUpdate");
						i.off("cart:updated");
						cartItem.removeClass("is--update");
						loadingBar.attr("hidden", "");
						spinner.attr("hidden", "");
					});

					const requestOptions = createJsonRequestOptions("javascript");

					requestOptions.headers["X-Requested-With"] = "XMLHttpRequest";
					requestOptions.body = JSON.stringify({
						id: itemId,
						quantity: quantity,
						sections: sectionsToRender,
						sections_url: window.location.pathname
					});

					fetch(`${cartChangeUrl}`, requestOptions)
						.then(response => response.json())
						.then(response => {
							if (response.status) {
								showAddToCartError(response.description);
								i.trigger("cart:updated", [response]);
								return;
							}

							renderCartSections(response.sections);
						})
						.catch(error => {
							i.trigger("cart:updated");
							window.report_faro({
								file_name: 'assets/interactable.js',
								func_name: 'changeCartItem',
								desc: 'Failed to change the cart item quantity',
								error: error
							});
						});
				}

				function bindQuickAddToCartEvents() {
					a.on("click", "[data-action-atc]", function (event) {
						if (!enableAjaxCart) {
							return;
						}

						event.preventDefault();
						addItemFromActionButton(e(this));
					});
				}

				function addItemFromActionButton(button) {
					button.addClass(classes.loading).attr(attrs.disabled, !0);

					const requestOptions = createJsonRequestOptions("javascript");
					requestOptions.headers["X-Requested-With"] = "XMLHttpRequest";

					var variantId = button.attr("data-variant-id");
					var quantity =
						parseInt(
							button
								.prev("[data-quantity-wrapper]")
								.find("[data-quantity-value]")
								.val()
						) ||
						button.data("qty") ||
						1;

					var items = [];

					items.push({
						id: variantId,
						quantity: quantity
					});

					requestOptions.body = JSON.stringify({
						items: items,
						sections: sectionsToRender,
						sections_url: window.location.pathname
					});

					i.on("cart:updated", function () {
						button.removeClass(classes.loading).removeAttr(attrs.disabled);
						i.off("cart:updated");
					});

					fetch(`${cartAddUrl}`, requestOptions)
						.then(response => response.json())
						.then(response => {
							if (response.status) {
								showAddToCartError(response.description);
								i.trigger("cart:updated");
								return;
							}

							i.trigger("add:cart:success", [requestOptions]).trigger(
								"add:cart:upsell"
							);
							renderCartSections(response.sections);
						})
						.catch(error => {
							i.trigger("cart:updated");
							window.report_faro({
								file_name: 'assets/interactable.js',
								func_name: 'addItemFromActionButton',
								desc: 'Failed to add an item to the cart',
								error: error
							});
						});
				}

				function bindCartItemEvents() {
					e("[data-cart-items]")
						.off("change")
						.on("change", "[data-action-change]", function () {
							var input = e(this);
							var itemId = (input.closest("[data-cart-item]"), input.data("id"));
							var quantity = input.val() || 1;

							input.attr("max");

							if (enableAjaxCart) {
								changeCartItem(input, itemId, quantity);
							}
						})
						.off("click.remove")
						.on("click.remove", "[data-cart-remove]", function (event) {
							if (!enableAjaxCart) {
								return;
							}

							event.preventDefault();

							var removeButton = e(this);
							changeCartItem(removeButton, removeButton.data("id"), 0);
						});
				}

				var classes = {
					loading: "is--loading"
				};

				var attrs = {
					disabled: "aria-disabled"
				};

				var isCartDisabled = "disable" == p.cartType;
				var sectionsToRender =
					"cart" != m
						? isCartDisabled
							? "cart_data"
							: "cart_data,mini_cart"
						: "cart_data,main-cart";

				var enableAjaxCart = p.enableAjaxCart;
				var cartAddUrl = T4Sroutes.cart_add_url + ".js";
				var cartChangeUrl = T4Sroutes.cart_change_url + ".js";
				var disableAddToCartError = p.disATCerror;

				return {
					init: function () {
						i.on("submitAtc:t4s", function (event) {
							event.$container
								.find('[data-type="add-to-cart-form"]')
								.on("click", "[data-atc-form]", function (event) {

									if (!enableAjaxCart) {
										return;
									}

									event.preventDefault();

									if (e(this).attr(attrs.disabled)) {
										T4SThemeSP.Notices(T4SProductStrings.pleaseChooseOptions);
									} else {
										submitAddToCartForm(e(this));
									}
								});
						});

						e('[data-type="add-to-cart-form"]').on(
							"click",
							"[data-atc-form]",
							function (event) {

								if (!enableAjaxCart) {
									return;
								}

								event.preventDefault();

								if (e(this).attr(attrs.disabled)) {
									T4SThemeSP.Notices(T4SProductStrings.pleaseChooseOptions);
									if (e(this).attr('stock-disabled')) {
										setTimeout(() => {
											$('button.cartx-popup-trigger')?.click()
										}, 500)
										const current_sku = e(this).attr('data-current-sku')
										const product_id = e(this).closest('form').attr('data-product-id')
										Shopify.analytics.publish('stock_alert_subscribe', {
											product_id: product_id,
											text: current_sku,
											event_type: "click"
										});
									}
								} else {
									submitAddToCartForm(e(this));
								}
							}
						);

						bindQuickAddToCartEvents();
						bindCartItemEvents();
					},

					change: bindCartItemEvents
				};
			})(),
			T4SThemeSP.T4sQuantityAdjust = function () {
				var t = l.notice_stock_msg
					, n = p.disOnlyStock;
				return String.prototype.getDecimals || (String.prototype.getDecimals = function () {
					var e = ("" + this).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
					return e ? Math.max(0, (e[1] ? e[1].length : 0) - (e[2] ? +e[2] : 0)) : 0
				}
				),
					function () {
						a.on("change", "[data-quantity-value]", function (i) {
							var o = e(this)
								, r = (o.data("id"),
									o.val() || 1)
								, s = o.attr("max") || 9999
								, l = o.attr("min") || 1
								, c = o.closest(".fgr_frm");
							if (c.length > 0 && (subtt_price_group(c),
								a.trigger("currency:update")),
								parseInt(r) > parseInt(s)) {
								if (r = s,
									o.val(r),
									n)
									return;
								return T4SThemeSP.Notices(t.replace("[max]", s)),
									!1
							}
							if (parseInt(r) < parseInt(l))
								return o.val(l),
									!1
						}),
							a.on("click", "[data-quantity-selector]", function (i) {
								i.preventDefault();
								var o = e(this)
									, a = o.closest("[data-quantity-wrapper]").find("[data-quantity-value]")
									, r = parseFloat(a.val())
									, s = parseFloat(a.attr("max"))
									, l = parseFloat(a.attr("min"))
									, c = a.attr("step");
								if (r && "" !== r && "NaN" !== r || (r = 0),
									"" !== s && "NaN" !== s || (s = ""),
									"" !== l && "NaN" !== l || (l = 0),
									"any" !== c && "" !== c && void 0 !== c && "NaN" !== parseFloat(c) || (c = 1),
									o.is("[data-increase-qty]")) {
									if (s && r >= s) {
										if (a.val(s),
											n)
											return;
										return T4SThemeSP.Notices(t.replace("[max]", s)),
											!1
									}
									a.val((r + parseFloat(c)).toFixed(c.getDecimals()))
								} else
									l && r <= l ? a.val(l) : r > 0 && a.val((r - parseFloat(c)).toFixed(c.getDecimals()));
								a.trigger("change")
							})
					}
			}(),
			T4SThemeSP.agreeForm = function () {
				var t = !1
					, n = "[data-agree-checkbox]";
				return function () {
					t || 0 == e(n).length || (t = !0,
						a.on("click", '[data-agree-btn], [name="checkout"], [name="goto_pp"], [name="goto_gc"]', function (t) {
							e(this).closest("form").find(`[type="checkbox"]${n}`).is(":checked") ? e(this).submit() : (t.preventDefault(),
								t.stopPropagation(),
								T4SThemeSP.Notices(l.agree_checkout))
						}),
						a.on("click", n, function (t) {
							e(this).closest("form"),
								e(this).is(":checked") && a.trigger("hide.t4s.notices")
						}))
				}
			}(),
			T4SThemeSP.PhotoSwipe = function () {
				function n(t, n, i, o) {
					if (!(t <= 1)) {
						for (var a = 0; a < t; a++)
							i.append('<div class="pswp_thumb_item" data-index="' + (a + 1) + '"><img loading="lazy" src="' + n[a].src + '" alt="pswp-thumb-img"></div>');
						i.find('.pswp_thumb_item[data-index="' + (o.getCurrentIndex() + 1) + '"]').addClass(s),
							o.listen("beforeChange", function () {
								var e = o.getCurrentIndex() + 1
									, t = i.find('.pswp_thumb_item[data-index="' + e + '"]');
								t.siblings().removeClass(s),
									t.addClass(s)
							}),
							o.listen("afterChange", function () {
								!function (t) {
									let n = e("." + s)[0]
										, i = t
										, o = i[0]
										, a = n.getBoundingClientRect()
										, r = o.getBoundingClientRect();
									a.left + a.width > r.width ? i.animate({
										scrollLeft: n.offsetLeft + a.width - r.width + 10
									}, 200) : n.offsetLeft < o.scrollLeft && i.animate({
										scrollLeft: n.offsetLeft - 10
									}, 200)
								}(i)
							}),
							i.find(".pswp_thumb_item").on("click", function () {
								var t = e(this).data("index");
								o.goTo(t - 1)
							})
					}
				}
				var o = e("#photoswipe_template").html()
					, r = "pswp__thumbnails"
					, s = "pswp_thumb_active"
					, c = !1
					, d = "[data-pswp-btn-triger], [data-t4s-gallery--open]:not(.is-pswp-disable)"
					, u = "click.pswp"
					, p = "data-pswp-images-trigger"
					, m = ".pswp__t4s";
				return {
					gallery: function () {
						e("[data-t4s-gallery].flickityt4s-enabled").on("dragEnd.flickityt4s", function (e, t) {
							c = !0
						}).on("staticClick.flickityt4s", function (e, t, n, i) {
							c = !1
						}),
							i.on(u, d, function (t) {
								t.preventDefault();
								var i = e(this)
									, s = -1;
								if (i.is("[data-pswp-btn-triger]")) {
									var u = i.closest("[data-t4s-group-btns]") || i
										, p = i[0].hasAttribute("data-pr-trigger-pswp")
										, f = u.siblings("[data-t4s-gallery]");
									s = function (t, n, i) {
										return n.hasClass("flickityt4s-enabled") ? n.find(i + ".is-selected").index() : e(t.currentTarget).is(d) ? 0 : e(t.currentTarget).index()
									}(t, f, h = p ? '[data-media-type="image"]:not(.is--media-hide)' : "[data-t4s-gallery--item]"),
										i = f.find("[data-t4s-gallery--open]").eq(s),
										c = !1
								} else
									var h = (p = i.hasClass("t4s-product__media")) ? '[data-media-type="image"]:not(.is--media-hide)' : "[data-t4s-gallery--item]";
								var g = i.parents(h)
									, v = i.closest("[data-t4s-gallery]")
									, y = v.find(p ? '[data-media-type="image"]:not(.is--media-hide) [data-master]' : "[data-pswp-src]");
								if (0 == y.length || c)
									c = !1;
								else {
									var w = v.is("[data-t4s-thumb-true]")
										, T = function (t) {
											var n, i = [];
											return t.each(function () {
												n = e(this),
													i.push({
														src: n.attr("data-pswp-src") || n.attr("data-master"),
														w: n.attr("data-pswp-w") || n.attr("width"),
														h: n.attr("data-pswp-h") || n.attr("height")
													})
											}),
												i
										}(y)
										, S = parseFloat(v.attr("data-maxSpreadZoom"))
										, b = v.attr("data-fullscreenEl")
										, x = v.attr("data-shareEl")
										, _ = v.attr("data-counterEl");
									!function (t) {
										var i = t.items
											, s = i.length
											, c = t.index
											, d = t.galleryItems
											, u = {
												closeEl: !0,
												captionEl: !0,
												fullscreenEl: t.fullscreenEl || !0,
												zoomEl: !0,
												shareEl: t.shareEl || !0,
												counterEl: t.counterEl || !0,
												arrowEl: !0,
												preloaderEl: !0,
												history: !1,
												maxSpreadZoom: t.maxSpreadZoom || 2,
												showHideOpacity: !0,
												bgOpacity: 1,
												index: t.index,
												tapToToggleControls: !0,
												shareButtons: [{
													id: "facebook",
													label: l.pswp_facebook,
													url: "https://www.facebook.com/sharer/sharer.php?u={{url}}"
												}, {
													id: "twitter",
													label: l.pswp_twitter,
													url: "https://twitter.com/intent/tweet?text={{text}}&url={{url}}"
												}, {
													id: "pinterest",
													label: l.pswp_pinterest,
													url: "https://www.pinterest.com/pin/create/button/?url={{url}}&media={{image_url}}&description={{text}}"
												}],
												getThumbBoundsFn: function (e) {
													var n = d.find(t.parents).eq(e);
													t.global && (n = d.find("a[data-index=" + e + "]").parents(t.parents));
													var i = window.pageYOffset || document.documentElement.scrollTop
														, o = n[0].getElementsByTagName("img")[0].getBoundingClientRect();
													return {
														x: o.left,
														y: o.top + i,
														w: o.width
													}
												}
											};
										a.find(m).remove(),
											T4SThemeSP.$appendComponent.after(o),
											isThemeRTL && (c = s - c - 1,
												i = i.reverse());
										var p, f = document.querySelectorAll(m)[0], h = e("." + r), g = new PhotoSwipe(f, PhotoSwipeUI_Default, i, u);
										g.init(),
											h.empty(),
											clearTimeout(p),
											a.trigger("NTpopupInline:offClose"),
											g.listen("close", function () {
												if (p = setTimeout(function () {
													a.trigger("NTpopupInline:onClose")
												}, 500),
													d.hasClass("flickityt4s-enabled")) {
													if (isThemeRTL)
														var e = s - g.getCurrentIndex();
													else
														e = g.getCurrentIndex();
													d.flickityt4s("selectCell", e, !1, !0)
												}
											}),
											t.HasThumb && n(s, i, h, g)
									}({
										index: s = s > -1 ? s : v.find(h).index(g),
										items: T,
										HasThumb: w,
										galleryItems: v,
										parents: h,
										global: !1,
										maxSpreadZoom: S,
										fullscreenEl: b,
										shareEl: x,
										counterEl: _
									})
								}
							})
					},
					image: function () {
						i.on(u, "[data-t4s-image-opend]", function (t) {
							t.preventDefault(),
								function (t) {
									a.find(m).remove(),
										T4SThemeSP.$appendComponent.after(o);
									var n = e(m)
										, i = n[0]
										, r = t.attr("data-pswp-class");
									r && n.addClass(r);
									var s = {
										history: !1,
										maxSpreadZoom: 2,
										showHideOpacity: !0,
										fullscreenEl: !1,
										shareEl: !1,
										counterEl: !1,
										bgOpacity: 1,
										getThumbBoundsFn: function (e) {
											var n = window.pageYOffset || document.documentElement.scrollTop
												, i = t[0].getBoundingClientRect();
											return {
												x: i.left,
												y: i.top + n,
												w: i.width
											}
										}
									}
										, l = []
										, c = t.attr("data-pswp-w")
										, d = t.attr("data-pswp-h")
										, u = t.attr("data-pswp-src");
									l.push({
										src: u,
										w: c,
										h: d,
										title: t.text()
									});
									var p, f = new PhotoSwipe(i, PhotoSwipeUI_Default, l, s);
									f.init(),
										clearTimeout(p),
										a.trigger("NTpopupInline:offClose"),
										f.listen("close", function () {
											p = setTimeout(function () {
												a.trigger("NTpopupInline:onClose")
											}, 500)
										})
								}(e(this))
						})
					},
					images: function () {
						i.on(u, `[${p}]`, function (i) {
							i.preventDefault();
							let s = e(this)
								, l = t(s.attr(p), "[]");
							0 != l.length && function (t, i) {
								if (!t)
									return;
								a.find(m).remove(),
									T4SThemeSP.$appendComponent.after(o);
								let s = t.length
									, l = document.querySelectorAll(m)[0]
									, c = e("." + r)
									, d = t.map((e, t) => ({
										src: e.src,
										w: e.width,
										h: e.height,
										alt: e.alt
									}))
									, u = new PhotoSwipe(l, PhotoSwipeUI_Default, d, {
										history: !1,
										focus: !1,
										showAnimationDuration: 0,
										hideAnimationDuration: 0
									});
								u.init(),
									i.is("data-disable-thumb") || n(s, d, c, u)
							}(l, s)
						})
					}
				}
			}(),
			T4SThemeSP.Video = function () {
				function t() {
					e(".js-youtube").each(function () {
						this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', "*")
					}),
						e(".js-vimeo").each(function () {
							this.contentWindow.postMessage('{"method":"pause"}', "*")
						}),
						e("video:not(.t4s_bg_vid_html5)").each(function () {
							this.pause()
						}),
						e(".product-model").each(function () {
							this.modelViewerUI && this.modelViewerUI.pause()
						})
				}
				var n = "t4s-postervideo-playing";
				return {
					initPoster: function () {
						e("[data-video-poster-btn]").on("click", function (i) {
							i.preventDefault();
							var o = e(this).closest("[data-video-poster]")
								, a = o.find("video, iframe");
							t(),
								function (e, t) {
									if (!e.is("[loaded]")) {
										var n = e.find("[data-video-insert]").length ? e.find("[data-video-insert]") : e
											, i = '<iframe src="src_t4s" class="class_t4s" title="" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
											, o = JSON.parse(t.attr("data-options") || "{}")
											, a = o.type
											, r = o.vid
											, s = o.src
											, l = o.autoplay
											, c = o.loop
											, d = "vimeo";
										"youtube" == a ? i = i.replace("src_t4s", "//www.youtube.com/embed/" + r + "?enablejsapi=1&showinfo=0&controls=1&modestbranding=1&autoplay=" + +l + "&rel=0" + (c ? "&playlist=" + r + "&loop=1" : "")).replace("class_t4s", "js-youtube") : a == d ? i = i.replace("src_t4s", "//player.vimeo.com/video/" + r + "?&portrait=0&byline=0&color=" + o.accent_color + "&autoplay=" + +l + "&loop=" + +c).replace("class_t4s", "js-vimeo") : (i = '<video src="src_t4s" preload="auto" controls data-autoplay data-loop playsinline></video>'.replace("src_t4s", s),
											l && (i = i.replace("data-autoplay", "autoplay")),
											c && (i = i.replace("data-loop", "loop"))),
											n.append(i),
											e.attr("data-type-video-inline", "").attr("loaded", !0)
									}
								}(o, e(this)),
								setTimeout(function () {
									o.addClass(n),
										a.focus()
								}, 50)
						}),
							e("[data-video-poster-close]").on("click", function (i) {
								i.preventDefault(),
									t();
								var o = e(this).closest("[data-video-poster]");
								o.removeAttr("loaded").removeClass(n),
									o.find("video, iframe").remove()
							})
					}
				}
			}();
		var T = function () {
			var requestUrl, loadingClass = "is--loading";

			function LoadMore(container) {
				this.container = container;
				this.$container = e(container);
				this.options = JSON.parse(this.$container.attr("data-ntajax-options"));
				this.main = this.options.id || "";
				this.typeAjax = this.options.type || "LmDefault";
				this.isProduct = this.options.isProduct || !1;
				this.$section = e(`#shopify-section-${this.main}`);
				self.isbtnLoadMore = !0;
				this.setupEventListeners()
			}

			return LoadMore.prototype = Object.assign({}, LoadMore.prototype, {
				setupEventListeners: function () {
					var loadMore = this;

					loadMore.$container.on("click.ntlm", "[data-load-more]", function (event) {
						event.preventDefault();

						const $button = e(this);

						$button.addClass(loadingClass);
						requestUrl = `${$button.attr("href")}&section_id=${loadMore.main}`;

						loadMore.isbtnLoadMore = !e(this).is("[data-is-prev]");
						loadMore.$btnCurrent = e(this);
						loadMore.renderSectionFromFetch(requestUrl)
					})
				},
				renderSectionFromFetch: function (url) {
					var loadMore = this;

					T4SThemeSP.getToFetchSection(null, "text", url).then(responseText => {
						loadMore.$btnCurrent.removeClass(loadingClass);

						if ("NVT_94" != responseText) {
							loadMore[loadMore.typeAjax](responseText);

							if (loadMore.isProduct) {
								T4SThemeSP.reinitProductGridItem()
							}

							a.trigger("t4s:hideTooltip")
						}
					})
				},
				LmDefault: function (html) {
					var $html = e(html),
						contentHtml = $html.find("[data-contentlm-replace]").html(),
						$loadMoreWrap = this.isbtnLoadMore ? $html.find("[data-wrap-lm]") : $html.find("[data-wrap-lm-prev]"),
						$content = this.$section.find("[data-contentlm-replace]");

					if (this.isbtnLoadMore) {
						$content.append(contentHtml)
					} else {
						$content.prepend(contentHtml)
					}

					this.initLoamoreUpdate($loadMoreWrap)
				},
				LmIsotope: function (html) {
					var $html = e(html),
						contentHtml = $html.find("[data-contentlm-replace]").html(),
						$loadMoreWrap = this.isbtnLoadMore ? $html.find("[data-wrap-lm]") : $html.find("[data-wrap-lm-prev]"),
						$content = this.$section.find("[data-contentlm-replace]");

					contentHtml = e(contentHtml);

					if (this.isbtnLoadMore) {
						$content.append(contentHtml).isotopet4s("appended", contentHtml)
					} else {
						$content.prepend(contentHtml).isotopet4s("prepended", contentHtml)
					}

					this.initLoamoreUpdate($loadMoreWrap)
				},
				initLoamoreUpdate: function ($loadMoreWrap) {
					if ($loadMoreWrap.length > 0 && this.isbtnLoadMore) {
						this.$section.find("[data-wrap-lm]").html($loadMoreWrap.html())
					} else if (this.isbtnLoadMore) {
						this.$section.find("[data-wrap-lm]").hide()
					} else if ($loadMoreWrap.length > 0 && !this.isbtnLoadMore) {
						this.$section.find("[data-wrap-lm-prev]").html($loadMoreWrap.html())
					} else {
						this.$section.find("[data-wrap-lm-prev]").hide()
					}
				}
			}),
				LoadMore
		}();
		T4SThemeSP.initLoadMore = function () {
			e("[data-ntajax-options][data-not-main]:not(is--enabled)").each(function () {
				e(this).addClass("is--enabled"),
					this.LoadMore = new T(this)
			})
		}
			,
			T4SThemeSP.reinitProductGridItem = function () {
				this.ProductItem.init(),
					this.ProductItem.reloadReview(),
					this.Tooltip(),
					T4SThemeSP.Countdown(),
					T4SThemeSP.Compare.updateAll(),
					T4SThemeSP.Wishlist.updateAll(),
					a.trigger("currency:update")
			}
			,
			T4SThemeSP.instagram = function () {
				function n(t, n, i, o, a, r, u) {
					1 == c.length && (l = e(s).html() || "",
						c = l.split("[t4split]"));
					var p = ""
						, m = (i = i || !0,
						{
							IMAGE: "image",
							VIDEO: "video",
							CAROUSEL_ALBUM: "carousel_album"
						})
						, f = {
							image: c[0],
							video: c[1],
							carousel_album: c[2]
						};
					e.each(n, function (e, t) {
						if (e >= a)
							return 0;
						var n = t.thumbnail_url || t.media_url
							, i = m[t.media_type];
						p += '<div class="t4s-col-ins' + e + " t4s-col-ins t4s-col-item t4s-ins-type-" + i + '"><a data-no-instant rel="nofollow" class="t4s-d-block t4s-pr t4s-oh" href="' + t.permalink + '" target="' + u + '"><div class="t4s_ratio t4s_bg lazyloadt4s t4s-lz--ins" data-bg="' + n + '" data-sizes="auto"></div><span class="lazyloadt4s-loader"></span><div class="t4s-ins-info"><span class="t4s-ins-icon">' + f[i] + "</span></div></a></div>"
					}),
						t.html(p).parent().addClass(d.loaded),
						t.hasClass("flickityt4s-later") && (t[0].flickityt4s = new T4SThemeSP.Carousel(t[0])),
						isStorageSpSessionAll && i && (sessionStorage.setItem("nt_ins" + o + r, p),
							sessionStorage.setItem("nt_ins" + o, JSON.stringify({
								timestamp: new Date,
								content: n
							})))
				}
				var i = "https://d3ejra0xbg20rg.cloudfront.net/instagram/media?shop=" + Shopify.shop + "&resource=default"
					, o = "ins_19041994"
					, a = "ig_t4s_token"
					, r = "true" === CookiesT4.get(a)
					, s = ".t4s-icons-ins-svg"
					, l = e(s).html() || ""
					, c = l.split("[t4split]")
					, d = {
						loaded: "ins-is--loaded"
					};
				return function () {
					0 != e("[data-inst4s-options]").length && e("[data-inst4s-options]").each(function (s) {
						!function (e) {
							var s, l, c = t(e.attr("data-inst4s-options")), u = null, p = null, m = c.id, f = c.limit, h = c.acc || "spnt_t4", g = c.target;
							if ("spnt_t4" != h) {
								if (h = atob(h),
									isStorageSpSessionAll && (u = sessionStorage.getItem("nt_ins" + h + m),
										null != (p = sessionStorage.getItem("nt_ins" + h)) && "" != p && (s = new Date,
											(l = new Date(p.timestamp)).setMinutes(l.getMinutes() + 30),
											s.getTime() > l.getTime() && (p = null,
												u = null,
												sessionStorage.removeItem("nt_ins" + h + m),
												sessionStorage.removeItem("nt_ins" + h)))),
									null != u && "" != p) {
									if (e.html(u).parent().addClass(d.loaded),
										!e.hasClass("flickityt4s-later"))
										return;
									return e[0].flickityt4s = new T4SThemeSP.Carousel(e[0]),
										!1
								}
								null != p && "" != p ? (p = JSON.parse(p).content,
									n(e, p, !1, h, f, m, g)) : (h != o && (i = "https://graph.instagram.com/me/media?fields=comments_count,like_count,id,media_type,media_url,permalink,thumbnail_url,caption,children&access_token=" + h),
										fetch(i).then(function (e) {
											if (!e.ok)
												throw new Error("not ok");
											return e.json()
										}).then(t => {
											var i = h == o ? t : t.data;
											n(e, i, !0, h, f, m, g),
												r || (CookiesT4.set(a, "true", {
													expires: 7
												}),
													fetch("https://graph.instagram.com/refresh_access_token?grant_type=ig_refresh_token&access_token=" + h))
										}
										).catch(t => {
											e.html(""),
												window.report_faro({
													file_name: 'assets/interactable.js',
													func_name: 'T4SThemeSP.instagram',
													desc: 'Failed to fetch the Instagram feed',
													error: t
												})
										}
										))
							}
						}(e(this))
					})
				}
			}(),
			T4SThemeSP.sideBarInit = function () {
				var t = e("[data-sidebar-id]")
					, o = t.is("[data-sidebar-true]")
					, r = e("[data-sidebar-content]")
					, s = t.is("[data-is-disableDrawer]");
				if (0 != t.length) {
					var l = t.attr("data-sidebar-id")
						, c = window.location.search.slice(1)
						, d = `${window.location.pathname}?section_id=${l}&${c}`;
					fetch(d).then(e => e.text()).then(e => {
						if (o || n.width() < 1024 && !s) {
							var t = (l = e.split("[t4splitlz]"))[2].split("[t4splitlz2]");
							T4SThemeSP.$appendComponent.after(t[0] + l[1] + t[1])
						} else {
							var l;
							t = (l = e.split("[t4splitlz]"))[2].split("[t4splitlz2]"),
								r.html(l[1]),
								T4SThemeSP.$appendComponent.after(t[0] + l[1] + t[1])
						}
						T4SThemeSP.instagram(),
							T4SThemeSP.Countdown(),
							T4SThemeSP.Tooltip(),
							a.trigger("currency:update"),
							i.trigger("sidebar:updated")
					}
					).catch(e => {
						r.html("")
					}
					)
				}
			}
			,
			// 定义一个Shopify抽屉组件（Drawer），使用自执行函数封装
			T4SThemeSP.Drawer = (function () {
				// 常量定义
				const CLASSES = {
					overlayVisible: "is--visible"  // 遮罩层可见时的CSS类名
				};

				const EVENTS = {
					click: "click.drawer",         // 抽屉点击事件命名空间
					keyup: "keyup.drawer"          // 抽屉键盘事件命名空间
				};

				const DATA_ATTRS = {
					options: "data-drawer-options", // 抽屉配置的数据属性
					delay: "data-drawer-delay"      // 抽屉延迟加载的数据属性
				};

				// 组件状态
				let isOpen = false;  // 标记抽屉是否处于打开状态

				// 缓存常用DOM元素
				const $html = $('html');  // html元素

				/**
				 * 打开抽屉函数
				 * @param {Event} event - 触发事件对象
				 * @param {jQuery} trigger - 触发抽屉打开的元素
				 * @param {boolean} forceOpen - 是否强制打开（跳过状态检查）
				 */
				function openDrawer(event, trigger, forceOpen = false) {
					// 如果抽屉未打开才执行
					if (!isOpen) {
						// 如果有事件对象，阻止默认行为
						event && event.preventDefault();

						// 从触发元素获取抽屉配置
						const drawerOptions = trigger.attr(DATA_ATTRS.options);
						const targetID = t(drawerOptions).id
						// 确定要打开的抽屉元素
						const $drawer = forceOpen ? trigger : $(targetID);
						// 触发抽屉打开事件并设置可访问性属性
						$drawer
							.trigger("opendDrawer")      // 触发自定义事件
							.attr("aria-hidden", "false"); // 设置ARIA属性

						const openDrawerEvent = new CustomEvent('data-collection-open-drawer')

						document.dispatchEvent(openDrawerEvent)

						// 更新UI状态 c = e(".t4s-close-overlay")
						c.addClass(CLASSES.overlayVisible); // 添加遮罩可见类
						isOpen = true;                         // 更新状态
						$html.addClass('drawer-open');         // 添加抽屉打开类

						// 禁用页面滚动
						T4SThemeSP.Helpers.disableBodyScroll(true, 'drawer');
					}
				}

				/**
				 * 关闭所有打开的抽屉
				 * @param {Event} event - 触发事件对象
				 */
				function closeDrawers(event) {
					// 只有抽屉打开时才执行关闭操作
					if (isOpen) {
						event && event.preventDefault();

						// 关闭所有标记为打开的抽屉
						$('.t4s-drawer[aria-hidden=false]').attr("aria-hidden", "true");

						// 更新UI状态
						c.removeClass(CLASSES.overlayVisible); // 移除遮罩可见类
						isOpen = false;                            // 更新状态
						$html.removeClass('drawer-open');          // 移除抽屉打开类

						// 重新启用页面滚动
						T4SThemeSP.Helpers.disableBodyScroll(false, 'drawer');

						// 移除事件监听器
						c.off(EVENTS.click);    // 移除遮罩点击事件
						$html.off(EVENTS.click);    // 移除关闭按钮点击事件
						$html.off(EVENTS.keyup);    // 移除键盘事件
					}
				}

				/**
				 * 设置抽屉事件监听器
				 */
				function setupEventListeners() {
					// 点击遮罩层关闭抽屉
					c.on(EVENTS.click, function (event) {
						closeDrawers(event);
					});

					// 点击关闭按钮关闭抽屉
					$html.on(EVENTS.click, "[data-drawer-close]", function (event) {
						closeDrawers(event);
					});

					// 按ESC键关闭抽屉
					$html.on(EVENTS.keyup, function (event) {
						if (event.keyCode === 27) { // 27是ESC键的keyCode
							closeDrawers(event);
						}
					});
				}

				// 公开的API接口
				return {
					/**
					 * 初始化抽屉功能
					 */
					init: function () {
						// 为没有延迟属性的抽屉触发器绑定点击事件
						$(document).on(EVENTS.click, `[${DATA_ATTRS.options}]:not([${DATA_ATTRS.delay}])`, function (event) {
							openDrawer(event, $(this));  // 打开抽屉
							setupEventListeners();       // 设置事件监听
						});


						// 处理侧边栏触发器的特殊逻辑
						const $sidebarTrigger = $("[data-sidebar-trigger]");    // 侧边栏触发器
						const $sidebarButton = $(".t4s-btn-sidebar");           // 侧边栏按钮

						// 如果存在侧边栏相关元素
						if ($sidebarTrigger.length && $sidebarButton.length) {
							$sidebarTrigger.on(EVENTS.click, function (event) {
								event.preventDefault();              // 阻止默认行为
								$sidebarButton.trigger(EVENTS.click); // 触发侧边栏按钮点击
							});
						}
					},

					/**
					 * 通过代码手动打开指定抽屉
					 * @param {jQuery} drawer - 要打开的抽屉元素
					 */
					opend: function (drawer) {
						isOpen = false; // 重置状态，确保可以重新打开
						openDrawer(null, drawer, true);  // 强制打开抽屉
						setupEventListeners();           // 设置事件监听
					},

					/**
					 * 关闭所有打开的抽屉
					 */
					close: closeDrawers,

					/**
					 * 移除指定抽屉的延迟属性
					 * @param {string} drawerId - 要操作的抽屉ID
					 */
					remove: function (drawerId) {
						// 移除匹配抽屉的延迟属性
						$(`[${DATA_ATTRS.options}*="#${drawerId}"]`).removeAttr(DATA_ATTRS.delay);
					}
				};
			})(),
			T4SThemeSP.BackToTop = function () {
				var t, i = e("#t4s-backToTop"), o = parseInt(i.data("scrolltop"));
				return function () {
					n.width() < 768 && i.data("hidden-mobile") || 0 == i.length || (n.scroll(function () {
						t && clearTimeout(t),
							t = setTimeout(function () {
								e(this).scrollTop() > o ? i.addClass("is--show") : i.removeClass("is--show")
							}, 40)
					}),
						i.on("click", function (t) {
							t.preventDefault(),
								e("html, body").animate({
									scrollTop: 0
								}, 800)
						}))
				}
			}(),
			T4SThemeSP.Header = (function () {
				// =========================
				// 常量与初始变量
				// =========================
				const HEADER_SELECTOR = ".t4s-section-header";
				const HEADER_OPTIONS_ATTR = "data-header-options";
				const HOVER_CLASS = "is-action__hover";
				const SUBMENU_POSITION_CLASS = "calc-pos-submenu";
				const CATEGORIES_WRAPPER_SECTION = "#shopify-section-header-categories-menu";
				const CATEGORIES_SECTION = "#shopify-section-header-categories";

				let headerEl = document.querySelector(HEADER_SELECTOR);
				let headerBounds = {};
				let lastScrollTop = 0;
				let preventReveal = false;
				let revealTimeout;

				let headerOptions =
					e(headerEl).find(`[${HEADER_OPTIONS_ATTR}]`).attr(HEADER_OPTIONS_ATTR) || "{}";
				headerOptions = JSON.parse(headerOptions);

				const isSticky = headerOptions.isSticky;
				const hideOnScrollDown = headerOptions.hideScroldown;

				const htmlEl = document.documentElement;
				const menuNav = e("[data-menu-nav]");
				let menuItemsHasChildren = menuNav.find(">li.has--children");
				let headerJq = e(headerEl);

				const categoriesMenuWrapper = e(CATEGORIES_WRAPPER_SECTION);
				let categoriesSection = e(CATEGORIES_SECTION);

				// =========================
				// 1. Sticky Header 相关
				// =========================

				function getAnnouncementBarHeight() {
					return e("#shopify-section-announcement-bar")?.height() || 0;
				}

				function updateAnnouncementBarHeight() {
					const originStyle = e("html").style;
					const cur_height = `${getAnnouncementBarHeight()}px`
					const pre_height = originStyle ? originStyle["--t4s-announcement-bar-height"] : undefined
					if (cur_height == pre_height) {
						return
					}
					e("html")
						.removeAttr("style")
						.css({
							...originStyle,
							"--t4s-announcement-bar-height": cur_height,
						});

				}
				updateAnnouncementBarHeight();
				let resizeTimer;
				window.addEventListener('resize', () => {
					clearTimeout(resizeTimer);

					resizeTimer = setTimeout(() => {
						updateAnnouncementBarHeight();
					}, 200);
				})

				function onPreventHeaderReveal() {
					preventReveal = true;
				}

				function hideHeader() {
					headerEl.dispatchEvent(new Event("T4sHeaderHide"));
					htmlEl.classList.add("is-header--stuck");
					headerEl.classList.add(
						"shopify-section-header-hidden",
						"shopify-section-header-sticky"
					);
				}

				function revealHeader() {
					headerEl.dispatchEvent(new Event("T4sHeaderReveal"));
					htmlEl.classList.add("is-header--stuck");
					headerEl.classList.add("shopify-section-header-sticky", "animate");
					headerEl.classList.remove("shopify-section-header-hidden");
				}

				function resetHeader() {
					htmlEl.classList.remove("is-header--stuck");
					headerEl.classList.remove(
						"shopify-section-header-hidden",
						"shopify-section-header-sticky",
						"animate"
					);
				}

				function onWindowScroll() {
					const currentScrollTop =
						window.pageYOffset || document.documentElement.scrollTop;

					if (currentScrollTop > lastScrollTop && currentScrollTop > headerBounds.bottom) {
						// 向下滚动，并且已经滚过 header
						requestAnimationFrame(hideHeader);
					} else if (
						currentScrollTop < lastScrollTop &&
						currentScrollTop > headerBounds.bottom
					) {
						// 向上滚动，并且已经滚过 header
						if (preventReveal) {
							window.clearTimeout(revealTimeout);
							revealTimeout = setTimeout(() => {
								preventReveal = false;
							}, 366);

							requestAnimationFrame(hideHeader);
						} else {
							requestAnimationFrame(revealHeader);
						}
					} else if (currentScrollTop <= headerBounds.top) {
						// 回到顶部区域
						requestAnimationFrame(resetHeader);
					}

					lastScrollTop = currentScrollTop;
				}

				function initStickyHideOnScrollHeader() {
					if (IsDesignMode) {
						headerEl.removeEventListener("preventHeaderReveal", onPreventHeaderReveal);
						// updateAnnouncementBarHeight();
						window.removeEventListener("scroll", onWindowScroll);

						headerEl = document.querySelector(".t4s-section-header");
						headerBounds = {};
						lastScrollTop = 0;
						preventReveal = false;

						let latestOptions =
							e(headerEl).find(`[${HEADER_OPTIONS_ATTR}]`).attr(HEADER_OPTIONS_ATTR) || "{}";
						latestOptions = JSON.parse(latestOptions);

						// 注意：这里原代码是重新赋值给外部变量逻辑，但用了 const。
						// 为了可读性，这里按“重新读取配置”的意图处理。
					}

					if (isSticky && hideOnScrollDown) {
						onWindowScroll();
						preventReveal = true;

						headerEl.addEventListener("preventHeaderReveal", onPreventHeaderReveal);
						window.addEventListener("scroll", onWindowScroll, false);

						new IntersectionObserver((entries, observer) => {
							headerBounds = entries[0].intersectionRect;
							observer.disconnect();
						}).observe(headerEl);
					}
				}

				// =========================
				// 2. Mega Menu 内容填充
				// =========================

				function injectLazyMenuContent($lazyContainers, htmlSource) {
					const $htmlSource = e(htmlSource);

					$lazyContainers.each(function () {
						let flickityItems;
						const $container = e(this);
						const contentSelector = "#t4s-mega-contents" + $container.data("id");
						const contentHtml = $htmlSource.find(contentSelector).html();

						if (contentHtml) {
							$container.html(contentHtml);

							if ($container.find(".t4s-products .t4s-product").length > 0) {
								T4SThemeSP.reinitProductGridItem();
							}

							setTimeout(function () {
								if ($container.hasClass("isotopet4s")) {
									T4SThemeSP.Isotopet4s.init($container);
								}

								positionSubMenu($container.closest(".has--children"));
								T4SThemeSP.PopupMFP();

								flickityItems = $container.find(".flickityt4s-later");
								if (flickityItems.length !== 0) {
									flickityItems.each(function () {
										this.flickityt4s = new T4SThemeSP.Carousel(this);
									});
								}
							}, 600);
						} else {
							$container.html("");
						}
					});
				}

				// =========================
				// 3. Hover 行为
				// =========================

				function initHoverIntent($items) {
					if ($items) menuItemsHasChildren = $items;

					if (T4SThemeSP.isTouch || r < 1024 || menuItemsHasChildren.length === 0) {
						return;
					}

					menuItemsHasChildren.each(function () {
						const $item = e(this);

						$item.hoverIntent({
							sensitivity: 3,
							interval: 35,
							timeout: 150,
							over: function () {
								$item.addClass(HOVER_CLASS);
							},
							out: function () {
								$item.removeClass(HOVER_CLASS);
							},
						});
					});
				}

				// =========================
				// 4. 点击展开子菜单
				// =========================

				function initClickToToggleMenu($items) {
					const $links = $items ? $items.find(">a") : menuItemsHasChildren.find(">a");

					if (!T4SThemeSP.isHover || r < 1024 || $links.length === 0) {
						return;
					}

					$links.on("click.menu", function (event) {

						const $parent = e(this).parent();

						if ($parent.hasClass(HOVER_CLASS)) {
							$parent.removeClass(HOVER_CLASS);
							e(document).off("click.menuIntent");
						} else {
							$parent.addClass(HOVER_CLASS).siblings().removeClass(HOVER_CLASS);

							e(document).on("click.menuIntent", function (event) {
								const target = event.target;

								if (
									!e(target).is("." + HOVER_CLASS) &&
									!e(target).parents("li").is("." + HOVER_CLASS)
								) {
									menuNav.find("." + HOVER_CLASS).removeClass(HOVER_CLASS);
									e(document).off("click.menuIntent");
								}
							});
						}
					});
				}

				// =========================
				// 5. 子菜单位置计算
				// =========================

				function initSubmenuPositioning($items) {
					if ($items) menuItemsHasChildren = $items;

					if (r < 1024 || menuItemsHasChildren.length === 0) return;

					if (IsDesignMode) {
						headerJq = e(HEADER_SELECTOR);
					}

					menuItemsHasChildren.each(function () {
						positionSubMenu(e(this));
					});

					headerJq.addClass(SUBMENU_POSITION_CLASS);
				}

				function updateHeaderAndCategoryMenuMaxSize() {
					if (IsDesignMode) {
						headerJq = e(HEADER_SELECTOR);
					}

					if (n.width() < 1024) return;

					headerJq.removeAttr("style").css({
						"--t4s-max-width": `${n.width() - 10}px`,
						"--t4s-max-height": `${n.height() - headerJq.offset().top - headerJq.height() - 20}px`,
					});

					const $categoryNav = e("#t4s-nav-categories");
					if ($categoryNav.length !== 0) {
						$categoryNav.removeAttr("style").css({
							"--t4s-max-width": `${n.width() - $categoryNav.offset().left - $categoryNav.width()}px`,
							"--t4s-max-height": `${n.height() - $categoryNav.offset().top - 10}px`,
						});
					}
				}

				function isSubmenuCenteredOnScreen(submenuEl) {
					const $submenu = e(submenuEl);
					$submenu.attr("style", "");

					const submenuWidth = $submenu.outerWidth();
					const submenuOffset = $submenu.offset();

					if (!submenuWidth || !submenuOffset) return false;

					const left = submenuOffset.left;
					const centerStart = (r - submenuWidth) / 2;

					if (
						!isThemeRTL &&
						centerStart <= left &&
						left <= centerStart + submenuWidth &&
						r >= centerStart + submenuWidth
					) {
						$submenu.addClass("is--center-screen");
						return true;
					}

					if (
						isThemeRTL &&
						centerStart <= left + submenuWidth &&
						left <= centerStart &&
						r >= centerStart + submenuWidth
					) {
						$submenu.addClass("is--center-screen");
						return true;
					}

					$submenu.removeClass("is--center-screen");
					return false;
				}

				function positionSubMenu($menuItem) {
					const referenceEl = $menuItem.find(">a")[0];
					const floatingEl = $menuItem.find(">.t4s-sub-menu")[0];
					const placement = $menuItem.data("placement") || "bottom";

					if (
						($menuItem.hasClass("menu-width__full") && placement !== "right-start") ||
						!floatingEl
					) {
						return;
					}

					e(floatingEl).attr("style", "");

					if (!window.ResizeObserver) return;

					FloatingUIT4sDOM.autoUpdate(
						referenceEl,
						floatingEl,
						async function () {
							if (placement === "bottom" && !$menuItem.hasClass("t4s-type__drop")) {
								if (isSubmenuCenteredOnScreen(floatingEl)) {
									return;
								}
							}

							FloatingUIT4sDOM.computePosition(referenceEl, floatingEl, {
								placement: placement,
								middleware: [
									FloatingUIT4sDOM.flip({}),
									FloatingUIT4sDOM.shift({ padding: 5 }),
								],
							}).then(({ x, y, placement }) => {
								Object.assign(floatingEl.style, {
									left: `${x}px`,
									top: placement.indexOf("bottom") > -1 ? "100%" : `${y}px`,
								});
							});
						},
						{
							ancestorResize: true,
						}
					);
				}

				// =========================
				// 6. 分类菜单更新
				// =========================

				function updateCategoriesMenu(html) {
					const $wrapper = categoriesMenuWrapper.find("[data-wrapper-categories]");
					$wrapper.html(html);

					const $categoryItems = $wrapper.find("#t4s-nav-categories>.has--children");

					initHoverIntent($categoryItems);
					initClickToToggleMenu($categoryItems);
					initSubmenuPositioning($categoryItems);

					if ($wrapper.find(".t4s-products .t4s-product").length > 0) {
						T4SThemeSP.reinitProductGridItem();
					}

					const $isotopeLater = $wrapper.find(".isotopet4s-later");
					const $flickityLater = $wrapper.find(".flickityt4s-later");

					if ($isotopeLater.length > 0) {
						$isotopeLater.each(function () {
							T4SThemeSP.Isotopet4s.init(e(this));
						});
					}

					if ($isotopeLater.length > 0) {
						$flickityLater.each(function () {
							this.flickityt4s = new T4SThemeSP.Carousel(this);
						});
					}
				}

				// =========================
				// 7. 对外暴露的方法
				// =========================

				return {
					stickyInit: function () {
						if (!isSticky || (isSticky && hideOnScrollDown)) {
							// 原逻辑：hideOnScrollDown 开启时，交给另一套滚动逻辑
						} else {
							new IntersectionObserver(
								function (entries) {
									if (entries[0].intersectionRatio === 0) {
										htmlEl.classList.add("is-header--stuck");
									} else if (entries[0].intersectionRatio === 1) {
										htmlEl.classList.remove("is-header--stuck");
									}
								},
								{ threshold: [0, 1] }
							).observe(document.querySelector("#t4s-hsticky__sentinel"));
						}

						initStickyHideOnScrollHeader();

						n.on("resize", function () {
							o.css({
								"--topbar-height": e("#t4s-top-bar-main").height() ?? 0 + "px",
								"--header-height": e(".t4s-section-header").height() + "px",
							});
						});
					},

					init: function ($menuItems) {
						// 1) 加载 Mega Menu lazy 内容
						(function initMegaMenuLazyLoad() {
							const $lazyMegaMenus = e(".t4s-type__mega .t4s-lazy_menu");
							let cacheExpireTime =
								(isStorageSpSession && sessionStorage.getItem("timeMegaT4s")) || 0;

							cacheExpireTime = parseInt(cacheExpireTime);

							if ($lazyMegaMenus.length === 0 || r < 1024) return;

							if (!IsDesignMode && cacheExpireTime > 0 && cacheExpireTime >= Date.now()) {
								injectLazyMenuContent($lazyMegaMenus, sessionStorage.getItem("dataMegaT4s"));
							} else {
								const $megaSection = e(".t4s-section-mega__menu");
								const sectionId =
									$megaSection.length > 0
										? $megaSection.attr("id").replace("shopify-section-", "")
										: "mega-menu,mega-menu2";

								T4SThemeSP.getToFetchSection(`?sections=${sectionId}`, "json").then(
									(response) => {
										if (response === "NVT_94" || response.status) {
											if (response.status) {
												window.report_faro({
													file_name: 'assets/interactable.js',
													func_name: 'initMegaMenuLazyLoad',
													desc: 'Failed to fetch the mega menu section',
													error: response.description
												});
											}
										} else {
											let html = "";
											for (const key in response) {
												html += response[key].split("[nt_mega_split1]")[1];
											}

											const wrappedHtml = "<div>" + html + "</div>";
											injectLazyMenuContent($lazyMegaMenus, wrappedHtml);

											if (isStorageSpSession) {
												cacheExpireTime = Date.now() + 18e5;
												sessionStorage.setItem("timeMegaT4s", cacheExpireTime);
												sessionStorage.setItem("dataMegaT4s", wrappedHtml);
											}
										}
									}
								);
							}
						})();

						// 2) 加载 DropDown lazy 内容
						(function initDropMenuLazyLoad() {
							const $lazyDropMenus = e(".t4s-type__drop .t4s-lazy_menu");
							let cacheExpireTime =
								(isStorageSpSession && sessionStorage.getItem("timeDropT4s")) || 0;

							cacheExpireTime = parseInt(cacheExpireTime);

							if ($lazyDropMenus.length === 0 || r < 1024 || IsDesignMode) return;

							if (cacheExpireTime > 0 && cacheExpireTime >= Date.now()) {
								const cachedParts = sessionStorage
									.getItem("dataDropT4s")
									.split("[nt_drop_split2]");

								$lazyDropMenus.each(function (index) {
									e(this).html(cachedParts[index]);
									positionSubMenu(e(this).closest(".has--children"));
								});
							} else {
								let handles = [];
								$lazyDropMenus.each(function () {
									handles.push(e(this).data("handle"));
								});

								handles = "/" + handles.join("+");

								T4SThemeSP.getToFetchSection(
									null,
									"text",
									`${window.T4Sroutes.all_url}${handles}/?section_id=dropdown-menu`
								).then((responseText) => {
									if (responseText !== "NVT_94") {
										const htmlPart = responseText.split("[nt_drop_split1]")[1];
										const splitHtml = htmlPart.split("[nt_drop_split2]");

										$lazyDropMenus.each(function (index) {
											e(this).html(splitHtml[index]);
											positionSubMenu(e(this).closest(".has--children"));
										});

										if (isStorageSpSession) {
											cacheExpireTime = Date.now() + 18e5;
											sessionStorage.setItem("timeDropT4s", cacheExpireTime);
											sessionStorage.setItem("dataDropT4s", "<div>" + htmlPart + "</div>");
										}
									}
								});
							}
						})();

						// 3) 菜单交互初始化
						initHoverIntent($menuItems);
						initClickToToggleMenu($menuItems);
						updateHeaderAndCategoryMenuMaxSize();
						initSubmenuPositioning($menuItems);

						// 4) 分类菜单内容初始化
						(function initCategoriesMenu() {
							if (categoriesMenuWrapper.find("[data-wrapper-categories]").length === 0) return;

							if (IsDesignMode || categoriesSection.length !== 0) {
								if (IsDesignMode) {
									categoriesMenuWrapper = e(CATEGORIES_WRAPPER_SECTION);
									categoriesSection = e(CATEGORIES_SECTION);
									updateCategoriesMenu(categoriesSection.html());
								}
							} else {
								let cacheExpireTime =
									(isStorageSpSession && sessionStorage.getItem("timeCatT4s")) || 0;

								cacheExpireTime = parseInt(cacheExpireTime);

								if (cacheExpireTime > 0 && cacheExpireTime >= Date.now()) {
									updateCategoriesMenu(sessionStorage.getItem("dataCatT4s"));
								} else {
									T4SThemeSP.getToFetchSection(
										null,
										"text",
										f + "/?section_id=header-categories"
									).then((responseText) => {
										if (responseText !== "NVT_94") {
											const html = new DOMParser()
												.parseFromString(responseText, "text/html")
												.querySelector("div").innerHTML;

											updateCategoriesMenu(html);

											if (isStorageSpSession) {
												cacheExpireTime = Date.now() + 18e5;
												sessionStorage.setItem("timeCatT4s", cacheExpireTime);
												sessionStorage.setItem("dataCatT4s", html);
											}
										}
									});
								}
							}
						})();

						setTimeout(function () {
							n.on("resize.menu", updateHeaderAndCategoryMenuMaxSize);
						}, 2000);
					},

					updateCat: updateCategoriesMenu,
				};
			})();

		T4SThemeSP.MobileNav = function () {
			function t(e) {
				e.hasClass(o.opend) ? e.removeClass(o.opend).children("ul").slideUp(200) : e.addClass(o.opend).children("ul").slideDown(200)
			}
			function i(e = 4) {
				IsDesignMode || d || m.$mobileNav.hasClass("t4s-d-lg-none") && r > 1024 || setTimeout(function () {
					T4SThemeSP.getToFetchSection(null, "text", T4Sroutes.search_url + "/?view=mn").then(e => {
						"NVT_94" != e && (d = !0,
							m.$mobileNav.html(e),
							n.off(a),
							m.$mobileNav.off(s),
							isStorageSpSession && (u = Date.now() + p,
								sessionStorage.setItem(l, u),
								sessionStorage.setItem(c, e)))
					}
					)
				}, e)
			}
			var o = {
				tabNavActive: "is--active",
				opend: "is--opend"
			}
				, a = "resize.navmb"
				, s = "opendDrawer"
				, l = "timeMenuT4s"
				, c = "dataMenuT4s"
				, d = !1
				, u = isStorageSpSession && sessionStorage.getItem(l) || 0
				, p = (u = parseInt(u),
					18e5)
				, m = {};
			return function (add_event = true) {
				let login_status_changed = false
				// 当前登录态
				const cur_logined = window.customer !== null ? '1' : '0'
				const local_html_str = sessionStorage.getItem(c) || ""
				const local_login_status = e(local_html_str)?.find("#item_mb_acc")?.attr("data-login-status")
				// mobile nav展示的登录态
				if (local_login_status !== undefined && local_login_status !== cur_logined) {
					// isMenuLoaded重置
					d = false
					login_status_changed = true
				}
				m = {
					$mobileNav: e("#t4s-menu-drawer")
				},
					isStorageSpSession && !login_status_changed && u > 0 && u >= Date.now() ? m.$mobileNav.html(sessionStorage.getItem(c)) : (n.on(a, T4SThemeSP.debounce(300, function () {
						i(0)
					})),
						i(500),
						IsDesignMode || m.$mobileNav.on(s, function () {
							i(0)
						}))
				// 不用重置, 登录态未改变, 过期时间未到,不用重新绑定事件
				if (!add_event) {
					return
				}
				m.$mobileNav.on("click", "[data-tab-mb-nav]>[data-tab-mb-item]", function () {
					var t = e(this);
					t.hasClass(o.tabNavActive) || (t.addClass(o.tabNavActive).siblings().removeClass(o.tabNavActive),
						e("[data-tab-mb-content]." + o.tabNavActive).removeClass(o.tabNavActive),
						e(t.data("id")).addClass(o.tabNavActive))
				}),
					m.$mobileNav.on("click", ".t4s-menu-item-has-children.t4s-only_icon_false > a", function (n) {
						const $link = e(this)
						const $parent = $link.parent()
						const link = $link.attr("href")

						// 父元素存在 data-children-menu 且链接有效时，直接跳转
						if ($parent.is("[data-children-menu]") && link && link !== "#") {
							return
						}

						// 其他情况展开/收起子菜单
						n.preventDefault()
						n.stopPropagation()
						t($parent)
					}),

					m.$mobileNav.on("click", ".t4s-menu-item-has-children > a > .t4s-mb-nav__icon", function (n) {
						n.preventDefault(),
							n.stopPropagation(),
							t(e(this).parent().parent())
					})
			}
		}(),
			T4SThemeSP.loadingBar = function () {
			},
			T4SThemeSP.currencyForm = function () {
				var classNames = {
					selected: "is--selected",
					opened: "is--opend"
				};

				var selectors = {};

				function bindCurrencyLocaleEvents() {
					var $clickedItem;
					var wrapperSelector;
					var selectorInputKey;
					var newIso;
					var oldIso;

					$("body").on(
						"click",
						"[data-locale-wrap] [data-locale-item], [data-currency-wrap] [data-currency-item]",
						function (event) {
							event.preventDefault();

							sessionStorage.removeItem('timeMenuT4s');

							$clickedItem = $(this);

							// currency_type = 2 时，不处理 currency item
							if (T4SThemeSP.currency_type === "2" && $clickedItem.is("[data-currency-item]")) {
								return;
							}

							// 已经选中的项不重复提交
							if ($clickedItem.hasClass(classNames.selected)) {
								return;
							}

							// 判断当前点击的是语言还是货币
							if ($clickedItem.is("[data-locale-item]")) {
								wrapperSelector = "[data-locale-wrap]";
								selectorInputKey = "$localeSelector";
							} else {
								wrapperSelector = "[data-currency-wrap]";
								selectorInputKey = "$currencySelector";
							}

							newIso = $clickedItem.attr("data-iso");
							oldIso = $(wrapperSelector + " ." + classNames.selected)
								.first()
								.attr("data-iso");

							// 更新当前展示文案和国旗 class
							$(wrapperSelector + " [data-current]")
								.text($clickedItem.text())
								.removeClass("flagst4-" + oldIso)
								.addClass("flagst4-" + newIso);

							// 更新选中状态
							$(wrapperSelector + " [data-iso=" + newIso + "]")
								.addClass(classNames.selected)
								.siblings()
								.removeClass(classNames.selected);

							// 写入隐藏 input，然后提交 Shopify currency / locale form
							selectors[selectorInputKey].val(newIso);
							selectors.$formCurrencyLocale.submit();

							// 显示 loading
							T4SThemeSP.loadingBar();
						}
					);
				}

				return function initCurrencyForm() {
					selectors = {
						$formCurrencyLocale: $("#CurrencyLangSelector"),
						$localeSelector: $("#LocaleSelector"),
						$currencySelector: $("#CurrencySelector")
					};

					if (selectors.$formCurrencyLocale.length !== 0) {
						bindCurrencyLocaleEvents();
					}
				};
			}(),
			T4SThemeSP.productRecommendations = function () {
				function t(t) {
					t[0] ? t.hide() : n.$recommendationsWrap.hasClass("t4s-pr-single_tab-content") ? (n.$recommendationsWrap.find(".t4s-loading--bg").hide(),
						n.$recommendationsWrap.find("[data-emty-product]").show()) : (T4SThemeSP.isRelatedEmty = !0,
							T4SThemeSP.isRencentEmty ? e(".t4s-tp-rencent-related").hide() : n.$recommendationsWrap.hide())
				}
				var n = {};
				return function (i) {
					n = {
						$recommendationsWrap: e("#pr_recommendations")
					},
						0 != (i = i || n.$recommendationsWrap).length && function (n) {
							var i = n.data("type")
								, o = n.data("sid")
								, a = n.data("baseurl")
								, r = n.closest(".id_product-recommendations")
								, s = f + a + "&section_id=" + o;
							"3" == i && (s = a + "?section_id=" + o + "&product_id=" + n.data("id") + "&limit=" + n.data("limit")),
								T4SThemeSP.getToFetchSection(null, "text", s).then(i => {
									if ("NVT_94" != i) {
										var o = IsDesignMode ? e(e(i)[2]).html() : e(i).html();
										try {
											o.trim()
										} catch (t) {
											o = e(i).html()
										}
										if ("" !== o.trim()) {
											if (n.html(o),
												n.find(".t4s-product").length > 0 && T4SThemeSP.reinitProductGridItem(),
												n.find(".flickityt4s").length > 0) {
												var a = n.find(".flickityt4s")[0];
												a.flickityt4s = new T4SThemeSP.Carousel(a)
											}
										} else
											t(r)
									} else
										t(r)
								}
								)
						}(i)
				}
			}(),
			T4SThemeSP.recentlyViewed = function () {
				function t(t, i = !0) {
					t[0] ? i ? t.hide() : t.slideUp() : n.$recentlyWrap.hasClass("t4s-pr-single_tab-content") ? (n.$recentlyWrap.find(".t4s-loading--bg").hide(),
						n.$recentlyWrap.find("[data-emty-product]").show()) : (T4SThemeSP.isRencentEmty = !0,
							T4SThemeSP.isRelatedEmty ? e(".t4s-tp-rencent-related").hide() : n.$recentlyWrap.hide())
				}
				var n = {};
				return function (i) {
					n = {
						$recentlyWrap: e("#recently_wrap")
					},
						i = i || n.$recentlyWrap,
						isStorageSpdLocalAll && 0 != i.length && function (n) {
							var i = localStorage.getItem("nt_recent")
								, o = "product" == m ? n.data("id") : "19041994"
								, a = n.data("sid")
								, r = n.data("unpr")
								, s = n.data("limit")
								, l = n.closest(".id_recently_viewed");
							if (null != i) {
								var c = (p = i.split(",")).indexOf(o);
								if (c > -1 ? (p = p.splice(0, s + 1)).splice(c, 1) : p = p.splice(0, s),
									0 == p.length)
									return t(l, !1),
										!1;
								var d = p.toString().replace(/,/g, " OR ")
									, u = encodeURI(d);
								T4SThemeSP.getToFetchSection(null, "text", f + "/?section_id=" + a + "&type=product&options[unavailable_products]=" + r + "&q=" + u).then(i => {
									if ("NVT_94" != i) {
										var o = IsDesignMode ? e(e(i)[2]).html() : e(i).html();
										try {
											o.trim()
										} catch (t) {
											o = e(i).html()
										}
										if ("" !== o.trim()) {
											if (n.html(o),
												n.find(".t4s-product").length > 0 && T4SThemeSP.reinitProductGridItem(),
												n.find(".flickityt4s").length > 0) {
												var a = n.find(".flickityt4s")[0];
												a.flickityt4s = new T4SThemeSP.Carousel(a)
											}
										} else
											t(l)
									} else
										t(l)
								}
								)
							} else {
								t(l);
								var p = new Array
							}
							p.indexOf(o) < 0 && "19041994" != o && (p.length > s && (p = p.splice(0, s)),
								p.unshift(o),
								localStorage.setItem("nt_recent", p.toString()))
						}(i)
				}
			}(),
			T4SThemeSP.Cart = function () {
				function n() {
					T4SThemeSP.Drawer.remove("t4s-mini_cart"),
						e("[data-cart-count]").html(e("#t4s-mini_cart").data("ccount")),
						T4SThemeSP.Tooltip(),
						a.trigger("currency:update"),
						k || (T4SThemeSP.ProductAjax.change(),
							T4SThemeSP.agreeForm(),
							function () {
								if ("cart" != m) {
									var t = e("[data-cart-wrapper]");
									e("[data-cart-tools]").on("click", "[data-cart-tool_action]", function (n) {
										n.preventDefault();
										var i = e(this);
										e(".t4s-mini_cart-tool__content.is--" + i.data("id")).addClass("is--opend"),
											t.addClass("is--contentUpdate"),
											e("[data-cart-tool_close]").on("click", function (n) {
												n.preventDefault(),
													e(".t4s-mini_cart-tool__content.is--" + i.data("id")).removeClass("is--opend"),
													t.removeClass("is--contentUpdate"),
													e("[data-cart-tool_close]").off("click")
											}),
											a.off("keyup.drawer").on("keyup.toolCart", function (n) {
												27 === n.keyCode && (e(".t4s-mini_cart-tool__content.is--" + i.data("id")).removeClass("is--opend"),
													t.removeClass("is--contentUpdate"),
													a.off("keyup.toolCart").on("keyup.drawer", function (e) {
														27 === e.keyCode && T4SThemeSP.Drawer.close(e)
													}))
											})
									})
								}
							}(),
							c(),
							d(),
							u(),
							function () {
								let t = e("[data-tab-cart-wrap]");
								if (!t[0])
									return;
								let n = e("[data-cart-tab-title]")
									, i = e("[data-cart-tab-content]");
								t.on("click", "[data-tab-cart-item]", function (t) {
									t.preventDefault();
									let o = e(this);
									n.text(o.data("title")),
										o.addClass(I.active).siblings("." + I.active).removeClass(I.active),
										i.attr("aria-hidden", !0).eq(o.index()).attr("aria-hidden", !1)
								})
							}(),
							h(),
							v(),
							function () {
								if (0 == e("#t4s-tab-visited").length || !isStorageSpdLocalAll)
									return;
								let t = localStorage.getItem("nt_recent");
								if (null == t)
									return;
								let n = t.split(",").toString().replace(/,/g, " OR ")
									, i = encodeURI(n)
									, o = e(".t4s-tab-visited-empty")
									, r = e(".t4s-tab-visited-skeleton");
								o.hide(),
									r.show(),
									T4SThemeSP.getToFetchSection(null, "text", f + "/?section_id=mini_cart_visited&type=product&options[unavailable_products]=show&q=" + i).then(t => {
										r.hide(),
											"NVT_94" != t && (r.after(e(t).html()),
												a.trigger("currency:update"),
												T4SThemeSP.Tooltip())
									}
									)
							}(),
							i.on("update:mini_cart:wishlist", y),
							i.trigger("update:mini_cart:wishlist"))
				}
				function r(e = !1) {
					return T4SThemeSP.getToFetchSection("?sections=" + D, "json").then(t => {
						"NVT_94" != t && s(t, e)
					}
					)
				}
				function s(t, n = !0) {
					var r = t.cart_data
						, s = t.mini_cart || t["main-cart"]
						, l = e(s).find("[data-cart-wrapper]")
						, c = e(w)
						, d = e(T)
						, u = e(S)
						, p = e(b)
						, f = e(x)
						, subtotalEle = e(subtotal);
					c.html(l.find(w).html()),
						d.html(l.find(T).html()),
						subtotalEle.html(l.find(subtotal).html()),
						u.replaceWith(l.find(S).wrap()),
						p.attr("style", l.find(b).attr("style")),
						f.html(l.find(x).html()),
						r = (r = r.split("[t4s_split1]")[1]).split("[t4s_split2]"),
						e("[data-cart-count]").html(r[0]),
						e("[data-cart-tt-price]").html(r[1]),
						"1" == r[2] ? (e(".t4s-mini_cart-tool__content.is--gift.is--opend [data-cart-tool_close]").trigger("click"),
							e("[data-toogle-gift]").hide()) : e("[data-toogle-gift]").show(),
						0 == r[0] ? o.addClass("t4s-cart-count-0") : (o.removeClass("t4s-cart-count-0"),
							M && (v(),
								M = !1)),
						T4SThemeSP.Tooltip(),
						a.trigger("currency:update"),
						"cart" == m || k || n && T4SThemeSP.Drawer.opend(e("#t4s-mini_cart")),
						i.trigger("cart:updated"),
						h()
				}
				function l(t) {
					var n, i = new Headers({
						"Content-Type": "application/json"
					}), o = ("string" != typeof (n = t) && "undefined" == (n += "") && (n = ""),
						e.trim(n)), a = {
							method: "POST",
							headers: i,
							body: JSON.stringify({
								note: o
							})
						};
					fetch(window.T4Sroutes.cart_url + "/update.js", a).then(function (e) {
						return e.json()
					}).then(function (t) {
						o.length > 0 ? (e('[data-id="note"].is--editNote, .t4s-txt_edit_note').removeClass(I.none),
							e('[data-id="note"].is--addNote, .t4s-txt_add_note').addClass(I.none)) : (e('[data-id="note"].is--editNote, .t4s-txt_edit_note').addClass(I.none),
								e('[data-id="note"].is--addNote, .t4s-txt_add_note').removeClass(I.none))
					}).catch(function (e) {
					})
				}
				function c() {
					e('textarea[name="note"]').on("change", function () {
						l(e(this).val())
					})
				}
				function d() {
					if (isStorageSpdLocal) {
						var t = e("#CartDiscountcode")
							, n = e("#CartDiscountcode, [data-cart-discount]")
							, i = localStorage.getItem("CartDiscountcode");
						n.val(i),
							e('[data-action="save-discountcode"]').click(function (e) {
								localStorage.setItem("CartDiscountcode", t.val()),
									n.val(t.val())
							})
					}
				}
				function u() {
					var t, n = e("[data-estimate-shipping-wrap]");
					n[0] && (n[0].langRates = JSON.parse(n.find("template[data-lang-rates]").html() || "{}"),
						t = n.data("id"),
						Shopify && new Shopify.CountryProvinceSelector(`ShippingCountry_${t}`, `ShippingProvince_${t}`, {
							hideElement: `ShippingProvinceContainer_${t}`
						}),
						n.on("click", '[data-action="estimate-shipping"]', function (t) {
							t.preventDefault(),
								t.stopPropagation();
							var n = this
								, i = e(n)
								, o = i.find("[data-response-rates]")
								, r = {}
								, s = e(t.currentTarget);
							s.addClass(I.loading),
								document.dispatchEvent(new CustomEvent("theme:loading:start")),
								r.country = i.find('[name="country"]').val() || "",
								r.province = i.find('[name="province"]').val() || "",
								r.zip = i.find('[name="zip"]').val() || "",
								fetch(window.T4Sroutes.cart_url + "/shipping_rates.json?" + e.param({
									shipping_address: r
								}), {
									credentials: "same-origin",
									method: "GET"
								}).then(function (t) {
									document.dispatchEvent(new CustomEvent("theme:loading:end")),
										s.removeClass(I.loading),
										t.json().then(function (i) {
											!function (t, n, i, o, r) {
												t ? function (t, n, i, o) {
													var r = ""
														, s = ""
														, l = "";
													if (n.zip && (r += n.zip + ", "),
														n.province && (r += n.province + ", "),
														r += n.country,
														t.length > 1) {
														var c = T4SThemeSP.Currency.formatMoney(t[0].price);
														s = o.multiple_rates.replace("[number_of_rates]", t.length).replace("[address]", r).replace("[rate]", c)
													} else
														s = 1 === t.length ? o.one_rate.replace("[address]", r) : o.no_rates;
													l = "";
													e.each(t, function (e, t) {
														var n = T4SThemeSP.Currency.formatMoney(t.price)
															, i = o.rate_value.replace("[rate_title]", t.name).replace("[rate]", n);
														l += "<li>" + i + "</li>"
													}),
														i.html('<div class="t4s-mess__rates is--rates-success">' + s + '</div><div class="t4s-results__rates"><ul>' + l.toString().replace(/<\/li>,<li>/g, "</li><li>") + "</ul></div>").fadeIn(),
														a.trigger("currency:update")
												}(n.shipping_rates, i, o, r) : function (e, t, n) {
													var i = "";
													Object.keys(e).forEach(function (t) {
														i += "<li>".concat(t, " ").concat(e[t], "</li>")
													}),
														"country is not supported." === i && (i = `<li>${n.no_rates}</li>`),
														t.html(`<p>${n.errors}</p><ul class="t4s-mess__rates is--rates-error">${i}</ul>`).fadeIn()
												}(n, o, r)
											}(t.ok, i, r, o, n.langRates)
										})
								})
						}
							.bind(n[0])))
				}
				function h() {
					if (!g)
						return;
					let t = e("[data-cart-ship-done]").length;
					t > 0 && C ? (T4SThemeSP.CanvasConfetti(),
						C = !1,
						P = !1) : e("[data-cart-calc-shipping]").length > 0 && P ? (T4SThemeSP.CanvasConfetti(),
							P = !1) : 0 == t && (P = !1,
								C = !0)
				}
				function v() {
					let n = e(`[${_}]`);
					if (0 == n.length)
						return;
					let i = t(n.attr(_));
					if (i.product_id = e("[data-cart-items] [data-cart-item]:first").data("pid") || 19041994,
						A == i.product_id)
						return;
					A = i.product_id;
					let o = `${i.baseurl}?section_id=${i.section_id}&product_id=${i.product_id}&limit=${i.limit}`;
					T4SThemeSP.getToFetchSection(null, "text", o).then(t => {
						if ("NVT_94" == t)
							return void n.hide();
						n.html(e(t).html());
						let i = n.find(".flickityt4s")[0];
						i && (i.flickityt4s = new T4SThemeSP.Carousel(i),
							a.trigger("currency:update"),
							T4SThemeSP.Tooltip())
					}
					)
				}
				function y() {
					let t = e("#t4s-tab-wishlist")
						, n = T4SThemeSP.linkWishlist || "";
					if (0 == t.length || n.indexOf("id:") < 0)
						return;
					let i = e(".t4s-tab-wishlist-empty")
						, o = e(".t4s-tab-wishlist-skeleton")
						, r = n.replace("view=wishlist", "section_id=mini_cart_wishlist");
					i.hide(),
						o.show(),
						T4SThemeSP.getToFetchSection(null, "text", r).then(t => {
							o.hide(),
								"NVT_94" != t && (o.siblings(".t4s-widget__pr").remove(),
									o.after(e(t).html()),
									a.trigger("currency:update"),
									T4SThemeSP.Tooltip())
						}
						)
				}
				var w = "[data-cart-items]"
					, T = "[data-cart-prices]"
					, S = "[data-cart-ship-text]"
					, b = "[data-cart-ship-bar]"
					, x = "[data-cart-discounts]"
					, _ = "data-cart-upsell-options"
					, C = !0
					, P = !0
					, k = "disable" == p.cartType
					, I = {
						loading: "is--loading",
						none: "t4s-d-none",
						active: "is--active"
					}
					, D = "cart" != m ? k ? "cart_data" : "cart_data,mini_cart" : "cart_data,main-cart"
					, A = 19041994
					, M = !1
					, subtotal = "[data-cart-subtotal]";
				return {
					renderContents: s,
					getToFetch: r,
					init: function () {
						!function () {
							if ("cart" == m)
								return c(),
									d(),
									u(),
									T4SThemeSP.agreeForm(),
									h(),
									void v();
							IsDesignMode ? n() : k || T4SThemeSP.getToFetchSection("?section_id=mini_cart").then(t => {
								"NVT_94" != t && (e("#t4s-mini_cart").parent().remove(),
									T4SThemeSP.$appendComponent.after(e(t).html()),
									n()),
									e("#t4s-mini_cart").trigger("cart:inited")
							}
							)
						}(),
							document.addEventListener("cart:refresh", function (e) {
								r(!1)
							}),
							document.addEventListener("cart:refresh:opend", function (e) {
								r(!0)
							}),
							i.on("add:cart:upsell", function (e) {
								M = !0
							})
					}
				}
			}(),

			/**
	* 初始化登录侧边栏功能
	* 包含动态加载、缓存管理和登录/注册切换功能
	*/
			T4SThemeSP.Login = (function () {
				// 常量定义
				const LOGIN_SIDEBAR_DATA_ATTR = "data-login-sidebar";
				const CACHE_EXPIRY_TIME = 24 * 60 * 60 * 1000; // 24小时缓存时间
				const ERROR_CODE = "NVT_94"; // 可能的错误代码

				/**
				 * 初始化登录侧边栏事件监听
				 * 处理登录/注册选项卡切换
				 */
				function initLoginSidebarEvents() {
					const $loginSidebar = $("#t4s-login-sidebar");

					// 先移除可能存在的旧抽屉
					T4SThemeSP.Drawer.remove("t4s-login-sidebar");

					// 绑定选项卡切换事件
					$loginSidebar.on("click", `[${LOGIN_SIDEBAR_DATA_ATTR}]`, function (event) {
						event.preventDefault();

						// 获取点击的选项卡类型 (login/register)
						const tabType = $(this).attr(LOGIN_SIDEBAR_DATA_ATTR);

						// 切换内容区域显示
						$(`#t4s-login-sidebar .t4s-content-login-sidebar.is--${tabType}`)
							.attr("aria-hidden", "false")
							.siblings()
							.attr("aria-hidden", "true");

						// 切换标题区域显示
						$(`#t4s-login-sidebar .t4s-drawer__header .is--${tabType}`)
							.attr("aria-hidden", "false")
							.siblings()
							.attr("aria-hidden", "true");
					});
				}

				/**
				 * 主登录功能入口
				 */
				return function initLoginFunctionality() {
					// 设计模式下直接初始化事件
					if (IsDesignMode) {
						initLoginSidebarEvents();
						return;
					}

					// 检查是否有有效的缓存
					const cachedTime = isStorageSpSession ?
						parseInt(sessionStorage.getItem("timeLoginT4s") || 0) : 0;
					const cachedData = sessionStorage.getItem("dataLoginT4s");
					const cacheVaild = cachedData && cachedData.includes('ogl-member2.0')
					if (cachedTime > 0 && cachedTime >= Date.now() && cacheVaild) {
						// 使用缓存数据
						// const cachedData = sessionStorage.getItem("dataLoginT4s");
						T4SThemeSP.$appendComponent.after(cachedData);
						T4SThemeSP.Drawer.remove("t4s-login-sidebar");
						initLoginSidebarEvents();
						document.dispatchEvent(new CustomEvent('login-sidebar-inited'))
					} else {
						// 从服务器获取登录侧边栏内容
						T4SThemeSP.getToFetchSection("?section_id=login-sidebar")
							.then(sectionData => {
								// 检查是否有效数据
								if (sectionData !== ERROR_CODE) {
									// 插入新内容
									T4SThemeSP.$appendComponent.after(sectionData);
									T4SThemeSP.Drawer.remove("t4s-login-sidebar");
									initLoginSidebarEvents();

									// 缓存数据
									if (isStorageSpSession) {
										const expiryTime = Date.now() + CACHE_EXPIRY_TIME;
										sessionStorage.setItem("timeLoginT4s", expiryTime);
										sessionStorage.setItem("dataLoginT4s", sectionData);
									}
								}
								document.dispatchEvent(new CustomEvent('login-sidebar-inited'))
							})
							.catch(error => {
								window.report_faro({
									file_name: 'assets/interactable.js',
									func_name: 'initLoginFunctionality',
									desc: 'Failed to load the login sidebar',
									error: error
								});
								// 这里可以添加错误处理逻辑，如显示默认登录表单
							});
					}
				};
			})(),
			T4SThemeSP.Compare = function () {
				function t(e, t, n) {
					return n.indexOf(e) === t
				}
				function n() {
					var e = localStorage.getItem(w);
					if (null != e) {
						s = e.split(",");
						var t = e.replace(/,/g, " OR ")
							, n = encodeURI(t);
						k = P + n
					}
				}
				function i() {
					if (isStorageSpdLocalAll && !c) {
						var t = localStorage.getItem(w);
						if (null != t) {
							var n = t.replace(/id:/g, "");
							s = n.split(","),
								C = s.length,
								s.forEach(function (e, t) {
									o(e.replace("id:", ""))
								}),
								e(g).html(C)
						}
					}
				}
				function o(t) {
					e(".t4s-tooltip.is--show .tooltip-inner").html(x);
					var n = e(m + '[data-id="' + t + '"]:not(.' + S + ")");
					n.addClass(S).removeClass(T).find(".t4s-text-pr").text(x),
						n.find(".t4s-svg-pr-icon").html(D)
				}
				function r(t, n = !1) {
					A && T4SThemeSP.getToFetchSection(null, "text", t.replace("view=compare", "section_id=compare-popup")).then(t => {
						"NVT_94" != t && (n && l && l.remove(),
							T4SThemeSP.$appendComponent.after(t),
							l = e(".t4s_section__compare-popup"),
							n && setTimeout(function () {
								l.addClass(b)
							}, 20))
					}
					)
				}
				var s, l, c = !p.enable_compare, d = 6, u = "[data-link-compare]", m = "[data-action-compare]", h = "[data-remove-compare]", g = "[data-count-compare]", v = "[data-clear-compare]", y = "[data-close-compare]", w = "t4s_cp", T = "is--pe-none", S = "is--added", b = "is--activate", x = T4SProductStrings.added_text_cp, _ = T4SProductStrings.compare, C = 0, P = f + "/?view=compare&type=product&options[unavailable_products]=last&q=", k = "", I = p.cp_icon, D = p.cp_icon_added, A = p.enableCompePopup;
				return {
					init: function () {
						isStorageSpdLocalAll && !c && (history.replaceState && "boolean" == typeof isPageCompare && window.history.replaceState({}, document.title, f + "/?view=compare"),
							n(),
							"boolean" != typeof isPageCompare || "boolean" != typeof isEmtyCompare || "" == s.toString() || IsDesignMode || (window.location.href = k),
							a.on("click", m + "." + S, function (e) {
								e.preventDefault(),
									A ? l.addClass(b) : window.location.href = k
							}),
							a.on("click", u, function (e) {
								e.preventDefault(),
									window.location.href = k
							}),
							a.on("click", v, function (t) {
								t.preventDefault(),
									l.removeClass(b);
								let i = s.length;
								for (let t = 0; t < i; t++) {
									let n = s[t].replace("id:", "");
									e(m + '[data-id="' + n + '"]').removeClass(S).find(".t4s-text-pr").text(_),
										e(m + '[data-id="' + n + '"]').find(".t4s-svg-pr-icon").html(I)
								}
								s = [],
									localStorage.setItem(w, s.toString()),
									C = 0,
									e(g).html(C),
									n()
							}),
							a.on("click", y, function (e) {
								e.preventDefault(),
									l.removeClass(b)
							}),
							null != localStorage.getItem(w) && "" != s.toString() && r(k),
							a.on("click", m + ":not(." + S + ")", function (a) {
								a.preventDefault();
								var s = e(this)
									, l = s.data("id") || ""
									, c = "id:" + l
									, u = localStorage.getItem(w)
									, p = !1;
								if ("" != l) {
									if (s.addClass(T),
										null != u && u.length > 0)
										(f = u.split(",")).unshift(c);
									else {
										var f = new Array;
										f.unshift(c)
									}
									if ((f = f.filter(t)).length > d && (f = f.splice(0, d),
										p = !0),
										localStorage.setItem(w, f.toString()),
										C = f.length,
										p) {
										var h = e(m + S);
										h.removeClass(S).find(".t4s-text-pr").text(_),
											h.find(".t4s-svg-pr-icon").html(I),
											i()
									} else
										o(l);
									e(g).html(C),
										n(),
										r(k, !0),
										"boolean" == typeof isPageCompare && (window.location.href = k)
								}
							}),
							a.on("click", h, function (t) {
								t.preventDefault();
								var i = e(this)
									, o = i.data("id")
									, a = "id:" + o
									, r = localStorage.getItem(w);
								i.addClass(T);
								var c = (s = r.split(",")).indexOf(a);
								c > -1 ? (s = s.splice(0, d + 1)).splice(c, 1) : s = s.splice(0, d),
									localStorage.setItem(w, s.toString()),
									i.removeClass(T),
									e(".t4s_compare_id_" + o).remove(),
									e(m + '[data-id="' + o + '"]').removeClass(S).find(".t4s-text-pr").text(_),
									e(m + '[data-id="' + o + '"]').find(".t4s-svg-pr-icon").html(I),
									C = s.length,
									e(g).html(C),
									n(),
									"boolean" == typeof isPageCompare && "" == s.toString() && (e(".t4s_compare_table").fadeTo(300, 0),
										window.location.href = k),
									0 == C && A && l.removeClass(b)
							}))
					},
					updateAll: i
				}
			}(),
			T4SThemeSP.Wishlist = function () {
				function uniqueItems(item, index, list) {
					return list.indexOf(item) === index
				}
				function updateWishlistLinkFromStorage() {
					var storedWishlist = localStorage.getItem(storageKey) || "";
					ids = storedWishlist ? storedWishlist.split(",") : [];

					if (storedWishlist) {
						var wishlistQuery = storedWishlist.replace(/,/g, " OR ");
						var encodedWishlistQuery = encodeURI(wishlistQuery);
						wishlistUrl = wishlistBaseUrl + encodedWishlistQuery;
						T4SThemeSP.linkWishlist = wishlistUrl;
						i.trigger("update:mini_cart:wishlist");
					}
				}
				function updateWishlistLinkFromRemote() {
					if (0 != (ids = remoteWishlistIds).length) {
						var wishlistQuery = "id:" + ids.join(" OR id:")
							, encodedWishlistQuery = encodeURI(wishlistQuery);
						wishlistUrl = wishlistBaseUrl + encodedWishlistQuery,
							T4SThemeSP.linkWishlist = wishlistUrl,
							i.trigger("update:mini_cart:wishlist")
					}
				}
				function markWishlistButtonAsAdded(productId) {
					e(".t4s-tooltip.is--show .tooltip-inner").html(addedButtonText);
					var wishlistButtons = e(addActionSelector + '[data-id="' + productId + '"]:not(.' + addedClass + ")");
					wishlistButtons.addClass(addedClass).removeClass(disabledClass).find(".t4s-text-pr").text(addedButtonText),
						wishlistButtons.find(".t4s-svg-pr-icon").html(addedIcon)
				}
				// 收藏留邮弹窗
				function maybeOpenWishlistPopup(button) {
					if (button.attr("data-no-popup")) {
						return
					}
					var product_id = button.attr("data-id") || "";
					document.dispatchEvent(new CustomEvent("ogl-subscribe:active", {
						detail: {
							product_id,
							subscribe_type: 1
						}
					}))
				}
				function removeProductCard(productId, button) {
					var wishlistProducts = e(".t4s-products-wishlist .t4s-products");
					wishlistProducts.hasClass("isotopet4s-enabled") ? wishlistProducts.isotopet4s("remove", button.closest(".t4s-product")[0]).isotopet4s("layout") : wishlistProducts.length > 0 && button.closest(".t4s-product").remove(),
						a.trigger("t4s:hideTooltip"),
						e(addActionSelector + '[data-id="' + productId + '"]').removeClass(addedClass).find(".t4s-text-pr").text(addToWishlistText),
						e(addActionSelector + '[data-id="' + productId + '"]').find(".t4s-svg-pr-icon").html(addIcon)
				}
				function addLocalWishlistItem(button) {
					var productId = button.data("id") || ""
						, wishlistItem = "id:" + productId
						, storedWishlist = localStorage.getItem(storageKey)
						, exceededLimit = !1;
					if ("" != productId) {
						if (button.addClass(disabledClass),
							null != storedWishlist && storedWishlist.length > 0)
							(wishlistItems = storedWishlist.split(",")).unshift(wishlistItem);
						else {
							var wishlistItems = new Array;
							wishlistItems.unshift(wishlistItem)
						}
						if ((wishlistItems = wishlistItems.filter(uniqueItems)).length > wishlistLimit && (wishlistItems = wishlistItems.splice(0, wishlistLimit),
							exceededLimit = !0),
							localStorage.setItem(storageKey, wishlistItems.toString()),
							wishlistCount = wishlistItems.length,
							exceededLimit) {
							var addedWishlistButtons = e(addActionSelector + "." + addedClass);
							addedWishlistButtons.removeClass(addedClass).find(".t4s-text-pr").text(addToWishlistText),
								addedWishlistButtons.find(".t4s-svg-pr-icon").html(addIcon),
								updateAll()
						} else
							markWishlistButtonAsAdded(productId);
						e(countSelector).html(wishlistCount),
							updateWishlistLinkFromStorage(),
							"boolean" == typeof isPageWishlist && (window.location.href = wishlistUrl)
					}
				}
				function addRemoteWishlistItem(button) {
					var productId = button.attr("data-id") || "";
					"" != productId && (button.addClass(loadingClass + " " + disabledClass),
						fetch(remoteUrl, {
							method: "POST",
							headers: {
								"Content-Type": "application/x-www-form-urlencoded",
								"X-Requested-With": "XMLHttpRequest"
							},
							body: `id=${productId}&handle=ntt4&action=add&email=${customerEmail}&customer_id=${customerId}`
						}).then(e => e.json()).then((response, status) => {
							"success" == response.status || "success" == status ? (remoteWishlistIds = response.data.ids,
								Array.isArray(remoteWishlistIds) || (remoteWishlistIds = remoteWishlistIds.split(",")),
								markWishlistButtonAsAdded(productId),
								wishlistCount = remoteWishlistIds.length,
								e(countSelector).html(wishlistCount),
								updateWishlistLinkFromRemote(),
								"boolean" == typeof isPageWishlist && (window.location.href = wishlistUrl)) : window.report_faro({
									file_name: 'assets/interactable.js',
									func_name: 'addRemoteWishlistItem',
									desc: 'Failed to add the remote wishlist item',
									error: response.message
								})
						}
						).catch(e => {
							404 == e.status ? alert("This feature is not available because there is no  Nitro Wishlist app installed. Please install Nitro Wishlist app first when using Wishlist in Shop.") : void 0
						}
						).finally(() => {
							button.removeClass(loadingClass + " " + disabledClass)
						}
						))
				}
				function bindAddEvents() {
					a.on("click", addActionSelector + ":not(." + addedClass + ")", function (t) {
						t.preventDefault(),
							maybeOpenWishlistPopup(e(this)),
							localMode ? addLocalWishlistItem(e(this)) : addRemoteWishlistItem(e(this))
					})
				}
				function removeLocalWishlistItem(button) {
					var productId = button.data("id")
						, wishlistItem = "id:" + productId
						, storedWishlist = localStorage.getItem(storageKey);
					button.addClass(disabledClass);
					var wishlistIndex = (ids = storedWishlist.split(",")).indexOf(wishlistItem);
					wishlistIndex > -1 ? (ids = ids.splice(0, wishlistLimit + 1)).splice(wishlistIndex, 1) : ids = ids.splice(0, wishlistLimit),
						localStorage.setItem(storageKey, ids.toString()),
						button.removeClass(disabledClass),
						removeProductCard(productId, button),
						wishlistCount = ids.length,
						e(countSelector).html(wishlistCount),
						updateWishlistLinkFromStorage(),
						"boolean" == typeof isPageWishlist && "" == ids.toString() && (e(".t4s-products-wishlist").fadeTo(300, 0),
							window.location.href = wishlistUrl)
				}
				function removeRemoteWishlistItem(button) {
					var productId = button.attr("data-id") || "";
					button.addClass(loadingClass + " " + disabledClass),
						fetch(remoteUrl, {
							method: "POST",
							headers: {
								"Content-Type": "application/x-www-form-urlencoded",
								"X-Requested-With": "XMLHttpRequest"
							},
							body: `id=${productId}&handle=ntt4&action=remove&email=${customerEmail}&customer_id=${customerId}`
						}).then(e => e.json()).then((response, status) => {
							if ("success" == response.status || "success" == status) {
								ids = response.data.ids,
									remoteWishlistIds = ids,
									removeProductCard(productId, button),
									wishlistCount = remoteWishlistIds.length,
									e(countSelector).html(wishlistCount),
									updateWishlistLinkFromRemote(),
									"boolean" == typeof isPageWishlist && "" == ids.toString() && (e(".t4s-products-wishlist").fadeTo(300, 0),
										window.location.href = wishlistBaseUrl)
							} else
								window.report_faro({
									file_name: 'assets/interactable.js',
									func_name: 'removeRemoteWishlistItem',
									desc: 'Failed to remove the remote wishlist item',
									error: response.message
								})
						}
						).catch(e => {
						}
						).finally(() => {
							button.removeClass(loadingClass + " " + disabledClass)
						}
						)
				}
				function updateAll() {
					if (!(!isStorageSpdLocalAll && localMode || wishlistDisabled)) {
						if (localMode) {
							var storedWishlist = localStorage.getItem(storageKey);
							if (null == storedWishlist)
								return;
							var normalizedWishlist = storedWishlist.replace(/id:/g, "");
							ids = normalizedWishlist.split(","),
								wishlistCount = "" == storedWishlist ? 0 : ids.length
						} else {
							if ("" == (ids = remoteWishlistIds).toString())
								return;
							wishlistCount = ids.length
						}
						if (ids.forEach(function (productId) {
							markWishlistButtonAsAdded(productId.replace("id:", ""))
						}),
							"boolean" == typeof isPageWishlist) {
							var wishlistPageButtons = e(".t4s-products-wishlist " + addActionSelector);
							wishlistPageButtons.removeClass(addedClass).removeAttr(addActionAttr, "").attr(removeActionAttr, "").find(".t4s-text-pr").html(removeWishlistText),
								wishlistPageButtons.find(".t4s-svg-pr-icon").html(removeIcon)
						}
						e(countSelector).html(wishlistCount)
					}
				}
				var ids
					, wishlistMode = p.wishlist_mode
					, shouldRemoveWhenAdded = "2" == p.wis_atc_added
					, localMode = "1" == wishlistMode
					, remoteMode = "2" == wishlistMode
					, wishlistDisabled = !(localMode || remoteMode)
					, wishlistLimit = 50
					, linkSelector = "[data-link-wishlist]"
					, addActionAttr = "data-action-wishlist"
					, addActionSelector = "[data-action-wishlist]"
					, removeActionAttr = "data-remove-wishlist"
					, removeActionSelector = "[data-remove-wishlist]"
					, countSelector = "[data-count-wishlist]"
					, storageKey = "t4s_wis"
					, disabledClass = "is--pe-none"
					, addedClass = "is--added"
					, browseWishlistText = T4SProductStrings.browse_wishlist
					, removeWishlistText = T4SProductStrings.remove_wishlist
					, addToWishlistText = T4SProductStrings.add_to_wishlist
					, addedButtonText = shouldRemoveWhenAdded ? removeWishlistText : browseWishlistText
					, wishlistCount = 0
					, wishlistBaseUrl = f + "/?view=wishlist&type=product&options[unavailable_products]=last&q="
					, wishlistUrl = ""
					, addIcon = p.wis_icon
					, removeIcon = p.wis_icon_remove
					, addedIcon = p.wis_icon_added
					, loadingClass = "is--loading"
					, remoteUrl = "https://nitro-wishlist.teathemes.net?shop=" + Shopify.shop
					, remoteWishlistIds = "";
				if (remoteMode) {
					var wishlistCustomer = e("#wis_t4s_list")
						, customerId = wishlistCustomer.data("cusid")
						, customerEmail = wishlistCustomer.data("email")
						, wishlistMarkup = wishlistCustomer.html() || "";
					remoteWishlistIds = wishlistMarkup.length > 0 ? wishlistMarkup.split(" ") : []
				}
				return {
					init: function () {
						!isStorageSpdLocalAll && localMode || wishlistDisabled || (history.replaceState && "boolean" == typeof isPageWishlist && window.history.replaceState({}, document.title, f + "/?view=wishlist"),
							localMode ? updateWishlistLinkFromStorage() : updateWishlistLinkFromRemote(),
							"boolean" != typeof isPageWishlist || "boolean" != typeof isEmtyWishlist || "" == ids.toString() || IsDesignMode || (window.location.href = wishlistUrl),
							a.on("click", addActionSelector + "." + addedClass, function (t) {
								t.preventDefault(),
									shouldRemoveWhenAdded ? localMode ? removeLocalWishlistItem(e(this)) : removeRemoteWishlistItem(e(this)) : window.location.href = wishlistUrl
							}),
							a.on("click", linkSelector, function (e) {
								0 != wishlistUrl.length && (e.preventDefault(),
									window.location.href = wishlistUrl)
							}),
							bindAddEvents(),
							a.on("click", removeActionSelector, function (t) {
								t.preventDefault(),
									localMode ? removeLocalWishlistItem(e(this)) : removeRemoteWishlistItem(e(this))
							}))
					},
					updateAll: updateAll
				}
			}(),
			T4SThemeSP.PopupPro = function () {
				function o() {
					e.magnificPopupT4s.open({
						items: {
							src: x.popup
						},
						type: "inline",
						closeOnBgClick: !1,
						closeBtnInside: !1,
						showCloseBtn: !1,
						enableEscapeKey: !1,
						removalDelay: 500,
						tClose: y,
						callbacks: {
							beforeOpen: function () {
								this.st.mainClass = "mfp-move-horizontal t4s-age_pp_wrapper"
							},
							open: function () {
								x.$popup.find(".t4s-age_verify_allowed").on(x.click, function () {
									if (x.date_of_birth) {
										var t = parseInt(e("#ageyear").val())
											, n = parseInt(e("#agemonth").val())
											, i = parseInt(e("#ageday").val())
											, o = new Date(t + x.age_limit, n, i);
										(new Date).getTime() - o.getTime() < 0 ? (x.$popup.addClass("t4s-animated t4s-shake"),
											window.setTimeout(function () {
												x.$popup.removeClass("t4s-animated t4s-shake")
											}, 1e3)) : (CookiesT4.set(x.CookiesName, "confirmed", {
												expires: parseInt(x.day_next),
												path: "/"
											}),
												e.magnificPopupT4s.close())
									} else
										CookiesT4.set(x.CookiesName, "confirmed", {
											expires: parseInt(x.day_next),
											path: "/"
										}),
											e.magnificPopupT4s.close()
								}),
									x.$popup.find(".t4s-age_verify_forbidden").on(x.click, function () {
										x.$popup.addClass("active_forbidden")
									})
							},
							beforeClose: function () { },
							close: function () {
								x.$popup.find(".t4s-age_verify_allowed, .t4s-age_verify_forbidden").off(x.click)
							}
						}
					})
				}
				function r() {
					e.magnificPopupT4s.open({
						items: {
							src: _.popup
						},
						type: "inline",
						removalDelay: 500,
						tClose: y,
						callbacks: {
							beforeOpen: function () {
								this.st.mainClass = "mfp-move-horizontal t4s-exit_pp_wrapper"
							},
							open: function () {
								if (e(".t4s-exit_pp_wrapper .t4s-product").length > 0 && T4SThemeSP.reinitProductGridItem(),
									e(".t4s-exit_pp_wrapper .flickityt4s").length > 0) {
									var t = e(".t4s-exit_pp_wrapper .flickityt4s")[0];
									t.flickityt4s = new T4SThemeSP.Carousel(t)
								}
								a.trigger("t4s:hideTooltip"),
									a.trigger("currency:update")
							},
							beforeClose: function () { },
							close: function () {
								i.off(_.mouseleave),
									CookiesT4.set(_.CookiesName, "shown", {
										expires: _.day_next,
										path: "/"
									})
							}
						}
					})
				}
				function s() {
					e.magnificPopupT4s.open({
						items: {
							src: C.popup
						},
						type: "inline",
						removalDelay: 500,
						tClose: y,
						callbacks: {
							beforeOpen: function () {
								this.st.mainClass = "mfp-move-horizontal t4s-newsletter_pp_wrapper"
							},
							open: function () {
								a.on("mail.subscribe.success", function (e) {
									CookiesT4.set(C.CookiesName, "shown", {
										expires: C.day_next,
										path: "/"
									})
								}),
									"1" != h && "2" != h || e(".t4s-newsletter_pp_wrapper .t4s-newsletter__form").submit(function (e) {
										CookiesT4.set(C.CookiesName, "shown", {
											expires: C.day_next,
											path: "/"
										})
									})
							},
							beforeClose: function () {
								e("[data-checked-newsletter]:checked").length > 0 && CookiesT4.set(C.CookiesName, "shown", {
									expires: C.day_next,
									path: "/"
								})
							},
							close: function () { }
						}
					})
				}
				function c() {
					P.$popup.removeClass("on--hide").addClass("on--show"),
						P.$popup.on(P.click, ".t4s-pp_cookies__accept-btn", function (e) {
							e.preventDefault(),
								window.Shopify.customerPrivacy.setTrackingConsent(!0, d),
								document.addEventListener("trackingConsentAccepted", function () {
									CookiesT4.set(P.CookiesName, "accepted", {
										expires: P.day_next,
										path: "/"
									})
								})
						}),
						P.$popup.on(P.click, ".t4s-pp_cookies__decline-btn", function (e) {
							e.preventDefault(),
								window.Shopify.customerPrivacy.setTrackingConsent(!1, d)
						})
				}
				function d() {
					P.$popup.addClass("on--hide").removeClass("on--show")
				}
				function u() {
					P.$popup = e(P.popup),
						0 != P.$popup.length && (P.stts = P.$popup.data("stt"),
							P.day_next = P.stts.day_next || 60,
							P.pp_version = P.stts.pp_version || 1994,
							P.CookiesName = `${w}_cookies_${P.pp_version}`,
							"accepted" == CookiesT4.get(P.CookiesName) || P.$popup.hasClass(b) || (P.$popup.addClass(b),
								window.Shopify.loadFeatures([{
									name: "consent-tracking-api",
									version: "0.1"
								}], function (t) {
									if (t)
										throw t;
									!function () {
										const t = window.Shopify.customerPrivacy.userCanBeTracked()
											, n = window.Shopify.customerPrivacy.getTrackingConsent();
										(!t && "no_interaction" === n || IsDesignMode) && (IsDesignMode ? P.$popup.on(T, function () {
											P.$popup = e(P.popup),
												c()
										}).on(S, function () {
											d()
										}) : c())
									}()
								})))
				}
				function m(e, t) {
					return Math.floor(Math.random() * (t - e + 1)) + e
				}
				function f(e) {
					var t = k.imageArray[e]
						, n = T4SThemeSP.Images.getNewImageUrl(t, 65)
						, i = T4SThemeSP.Images.getNewImageUrl(t, 130);
					k.$temp.find("[data-img-sale]").attr("src", n).attr("srcset", `${n} 1x, ${i} 2x`),
						k.$temp.find("[data-title-sale]").text(k.titleArray[e]),
						k.$temp.find("[data-href-sale]").attr("href", k.urlArray[e]),
						k.$temp.find("[data-action-quickview]").attr("data-id", k.idArray[e]),
						k.$temp.find("[data-location-sale]").text(k.locationArray[m(k.min, k.max2)]),
						k.$temp.find("[data-ago-sale]").text(k.timeArray[m(k.min, k.max3)])
				}
				function g() {
					a.trigger("t4s:hideTooltip"),
						k.$temp && k.$temp.removeClass(k.classUp).addClass(k.classDown).off("mouseenter mouseleave")
				}
				function v() {
					g(),
						k.starTimeout = setTimeout(function () {
							k.$temp && k.$temp.remove(),
								T4SThemeSP.$appendComponent.after(k.temp),
								T4SThemeSP.Tooltip(),
								k.$temp = e(".t4s-popup__sales"),
								"1" == k.ppType ? (f(k.index),
									++k.index,
									k.index > k.max && (k.index = 0)) : f(m(k.min, k.max)),
								k.time.START = (new Date).getTime(),
								k.time.END = k.time.START + k.stayTime,
								k.stayTimeout = setTimeout(function () {
									clearTimeout(k.stayTimeout),
										v()
								}, k.stayTime),
								k.$progressbarSpan = e(".t4s-pp-slpr-progressbar>span"),
								k.pauseOnHover && k.$temp.on("mouseenter", function (e) {
									k.resetOnHover ? k.$progressbarSpan.css("animation-name", "none") : k.time.REMAINING = k.time.END - (new Date).getTime(),
										clearTimeout(k.stayTimeout)
								}).on("mouseleave", function (e) {
									k.resetOnHover ? (k.time.REMAINING = k.stayTime,
										k.$progressbarSpan.css("animation-name", "t4s-ani-w")) : k.time.END = (new Date).getTime() + k.time.REMAINING,
										k.stayTimeout = setTimeout(function () {
											v()
										}, k.time.REMAINING)
								}),
								k.$temp.find(k.close).on("click", function (e) {
									e.preventDefault(),
										g(),
										a.trigger("t4s:hideTooltip"),
										k.$temp.off("mouseenter mouseleave"),
										clearTimeout(k.stayTimeout),
										clearTimeout(k.starTimeout)
								})
						}, k.starTime)
				}
				var y = l.mfp_close
					, w = (l.mfp_loading,
						p.theme)
					, T = "open.popup"
					, S = "close.popup"
					, b = "is--loaded"
					, x = {
						click: "click.age",
						popup: "#t4s-popup__age",
						CookiesName: `${w}_age_verify`
					}
					, _ = {
						mouseleave: "mouseleave.exit",
						click: "click.exit",
						popup: "#t4s-popup__exit",
						CookiesName: `${w}_exit`
					}
					, C = {
						scroll: "scroll.newsletter",
						click: "click.newsletter",
						popup: "#t4s-popup__newsletter",
						CookiesName: `${w}_newsletter`
					}
					, P = {
						popup: "#t4s-popup__cookies-law",
						click: "click.cookies"
					}
					, k = {
						popup: "#t4s-popup__sales-tmp",
						close: "[data-close-sale]"
					};
				return function () {
					u(),
						function () {
							C.$popup = e(C.popup);
							var t = `${w}_shown_pages`
								, o = CookiesT4.get(t);
							if (o || (o = 0),
								0 == C.$popup.length)
								return o++,
									void CookiesT4.set(t, o, {
										expires: 194,
										path: "/"
									});
							if (C.stts = C.$popup.data("stt"),
								C.pp_version = C.stts.pp_version,
								C.CookiesName = C.CookiesName + C.pp_version,
								location.search.indexOf("newsletter") > -1 && "#t4s-form-popups" == location.hash && ("1" == h || "2" == h) && CookiesT4.set(C.CookiesName, "shown", {
									expires: C.day_next,
									path: "/"
								}),
								!(!IsDesignMode && "shown" == CookiesT4.get(C.CookiesName) || !C.stts.isMobile && n.width() < 768 || C.$popup.hasClass(b))) {
								var a = "1" == C.pp_version ? "2" : "1"
									, r = `${w}_newsletter${a}`;
								if ("shown" == CookiesT4.get(r) && CookiesT4.remove(r),
									C.$popup.addClass(b),
									C.day_next = C.stts.day_next,
									C.scroll_delay = C.stts.scroll_delay,
									C.after = C.stts.after,
									IsDesignMode)
									C.$popup.on(T, function () {
										e.magnificPopupT4s.instance.isOpen ? (e.magnificPopupT4s.close(),
											setTimeout(function () {
												C.$popup.off(T).off(S),
													C.$popup = e(C.popup),
													s(),
													C.$popup.on(T, function () {
														s()
													}).on(S, function () {
														e.magnificPopupT4s.close()
													})
											}, e.magnificPopupT4s.instance.st.removalDelay + 10)) : s()
									}).on(S, function () {
										e.magnificPopupT4s.close()
									});
								else {
									var l = C.stts.number_pages;
									if (o < l)
										return o++,
											CookiesT4.set(t, o, {
												expires: 194,
												path: "/"
											}),
											!1;
									CookiesT4.set(t, l, {
										expires: 194,
										path: "/"
									}),
										"scroll" == C.after ? n.on(C.scroll, function () {
											i.scrollTop() < C.scroll_delay || (s(),
												n.off(C.scroll))
										}) : setTimeout(function () {
											s()
										}, C.stts.time_delay),
										e("[data-triger-newsletter]").on("click", function (e) {
											e.preventDefault(),
												s()
										})
								}
							}
						}(),
						_.$popup = e(_.popup),
						0 != _.$popup.length && (!IsDesignMode && "shown" == CookiesT4.get(_.CookiesName) || _.$popup.hasClass(b) || (_.stts = _.$popup.data("stt"),
							_.day_next = _.stts.day_next,
							_.$popup.addClass(b),
							IsDesignMode ? _.$popup.on(T, function () {
								e.magnificPopupT4s.instance.isOpen ? (e.magnificPopupT4s.close(),
									setTimeout(function () {
										_.$popup.off(T).off(S),
											_.$popup = e(_.popup),
											r(),
											_.$popup.on(T, function () {
												r()
											}).on(S, function () {
												e.magnificPopupT4s.close()
											})
									}, e.magnificPopupT4s.instance.st.removalDelay + 10)) : r()
							}).on(S, function () {
								e.magnificPopupT4s.close()
							}) : i.on(_.mouseleave, function (t) {
								t.clientY < 60 && 0 == e(".mfp-content").length && r()
							}))),
						x.$popup = e(x.popup),
						0 != x.$popup.length && (!IsDesignMode && "confirmed" == CookiesT4.get(x.CookiesName) || x.$popup.hasClass(b) || (x.stts = x.$popup.data("stt"),
							x.age_limit = x.stts.age_limit,
							x.date_of_birth = x.stts.date_of_birth,
							x.day_next = x.stts.day_next,
							x.$popup.addClass(b),
							IsDesignMode ? x.$popup.on(T, function () {
								e.magnificPopupT4s.instance.isOpen ? (e.magnificPopupT4s.close(),
									setTimeout(function () {
										x.$popup.off(T).off(S),
											x.$popup = e(x.popup),
											o(),
											x.$popup.on(T, function () {
												o()
											}).on(S, function () {
												e.magnificPopupT4s.close()
											})
									}, e.magnificPopupT4s.instance.st.removalDelay + 10)) : o()
							}).on(S, function () {
								e.magnificPopupT4s.close()
							}) : o())),
						function () {
							if (k.$popup = e(k.popup),
								0 == k.$popup.length)
								return;
							let i = e("#t4s-popup__sales-JSON");
							k.stts = t(i.html()),
								i.remove(),
								!k.stts.isMobile && n.width() < 768 || k.$popup.hasClass(b) || (k.$popup.addClass(b),
									k.temp = k.$popup.html(),
									k.starTime = k.stts.starTime * k.stts.starTimeUnit,
									k.stayTime = k.stts.stayTime * k.stts.stayTimeUnit,
									k.index = 0,
									k.limit = k.stts.limit,
									k.max = k.stts.max,
									k.min = 0,
									k.classUp = k.stts.classUp,
									k.classDown = k.stts.classDown[k.classUp],
									k.ppType = k.stts.ppType,
									k.pauseOnHover = k.stts.pauseOnHover,
									k.resetOnHover = k.stts.resetOnHover,
									k.idArray = k.stts.idArray,
									k.titleArray = k.stts.titleArray,
									k.urlArray = k.stts.urlArray,
									k.locationArray = k.stts.locationArray,
									k.timeArray = k.stts.timeArray,
									k.imageArray = k.stts.imageArray,
									k.max = k.urlArray.length - 1,
									k.max2 = k.locationArray.length - 1,
									k.max3 = k.timeArray.length - 1,
									k.starTimeout,
									k.stayTimeout,
									k.time = {},
									IsDesignMode ? (T4SThemeSP.$appendComponent.after(k.temp),
										k.$temp = e(".t4s-popup__sales"),
										k.$temp.hide(),
										T4SThemeSP.Tooltip(),
										e(k.close).on("click", function (e) {
											e.preventDefault(),
												g()
										}),
										k.$popup.on(T, function () {
											k.$temp.show(),
												k.$temp.addClass(k.classUp).removeClass(k.classDown)
										}).on(S, function () {
											g()
										})) : (k.$popup.remove(),
											v()))
						}()
				}
			}(),
			T4SThemeSP.PopupFetch = function () {
				let e = T4Srequest.path
					, t = ("/" != e ? e : "") + "/?section_id=popups";
				T4SThemeSP.getToFetchSection(null, "text", t).then(e => {
					"NVT_94" != e && (T4SThemeSP.$appendComponent.after(e),
						T4SThemeSP.PopupPro(),
						T4SThemeSP.PlatFormMail())
				}
				)
			}
			,
			T4SThemeSP.PlatFormMail = function () {
				var t = {
					loading: "is--loading",
					enabled: "is--enabled",
					errorCheckbox: "is--error-checkbox",
					errorEmail: "is--error-email"
				}
					, n = {
						klaviyo: "[data-t4s-klaviyo-submit]"
					}
					, i = {
						click: "click.mail",
						keyup: "keyup.mail"
					}
					, o = "[data-agreeMail-checkbox]";
				return function () {
					"4" == h && e(`[data-t4s-mailChimp-ajax]:not(.${t.enabled})`).addClass(t.enabled).submit(function (n) {
						n.preventDefault();
						var i = e(this)
							, o = i.find("[data-new-response-form]")
							, r = i.find("[data-t4s-mailChimp-submit]")
							, s = o.find("[data-new-response-success]")
							, l = o.find("[data-new-response-error]");
						r.addClass(t.loading),
							e.ajax({
								type: "GET",
								url: i.attr("action"),
								data: i.serialize(),
								cache: !1,
								dataType: "jsonp",
								jsonp: "c",
								contentType: "application/json; charset=utf-8",
								error: function (e) {
									r.removeClass(t.loading);
									try {
										var n = e.replace("0 - ", "").replace("1 - ", "").replace("2 - ", "");
										l.html(n).slideDown(100)
									} catch (e) { }
								},
								success: function (e) {
									r.removeClass(t.loading);
									try {
										var n = e.msg.replace("0 - ", "").replace("1 - ", "").replace("2 - ", "");
										"success" != e.result ? (s.slideUp(100),
											l.html(n).slideDown(100)) : (a.trigger("mail.subscribe.success"),
												l.slideUp(100),
												s.slideDown(100))
									} catch (e) { }
								}
							})
					}),
						"3" == h && $script("//www.klaviyo.com/media/js/public/klaviyo_subscribe.js", function () {
							e.each(e(`[data-t4s-klaviyo-ajax]:not(.${t.enabled})`), function () {
								var i = e(this)
									, o = i.attr("data-brand") || "Kalles Klaviyo";
								KlaviyoSubscribe.attachToForms("#" + i.attr("id"), {
									custom_success_message: !0,
									extra_properties: {
										$source: "Newsletter Popup",
										Brand: o
									},
									success: function (e) {
										a.trigger("mail.subscribe.success"),
											e.find(n.klaviyo).removeClass(t.loading)
									}
								}),
									i.addClass(t.enabled).submit(function (i) {
										e(this).find(n.klaviyo).addClass(t.loading)
									})
							}),
								a.on("klaviyo.subscribe.success", function (e) {
									a.trigger("mail.subscribe.success")
								}),
								a.on("klaviyo.subscribe.success klaviyo.subscribe.error", function (i) {
									e(i.target).find(n.klaviyo).removeClass(t.loading)
								})
						}),
						0 != e(o).length && (e("[data-agreeMail-btn]").off(i.click).on(i.click, function (n) {
							var i = e(this).closest("form");
							i.find(`[type="checkbox"]${o}`).is(":checked") || (n.preventDefault(),
								n.stopPropagation(),
								i.addClass(t.errorCheckbox),
								i.find('[type="email"]').val().length < 1 && i.addClass(t.errorEmail))
						}),
							e(o).off(i.click).on(i.click, function (n) {
								e(this).is(":checked") && e(this).closest("form").removeClass(t.errorCheckbox)
							}),
							e('[data-form-mail-agree] [type="email"]').off(i.keyup).on(i.keyup, function (n) {
								var i = e(this).closest("form");
								e(this).val().length < 1 ? i.addClass(t.errorEmail) : i.removeClass(t.errorEmail)
							})),
						"?contact%5Btags%5D=newsletter&form_type=customer" == location.search && e("[data-new-response-form]").html(`<div class="t4s-newsletter__error">${l.error_exist}</div>`).slideDown(100)
				}
			}(),
			T4SThemeSP.GroupsProduct = function () {
				function t(t) {
					this.$form = e(t),
						this.$totalPrice = this.$form.find(n),
						this.ArrayPrice = [],
						this.ArrayComparePrice = [];
					let o = this;
					this.$form.find(i).each(function (e) {
						o._updateItemPrice(this, e)
					}),
						o._updateTotalPrice(),
						o._eventListeners()
				}
				var n = "[data-groups-total-price]"
					, i = "[data-groups-pr-item]"
					, o = "change.groups"
					, r = "is--checked";
				return t.prototype = Object.assign({}, t.prototype, {
					_eventListeners: function () {
						let t = this;
						this.$form.on(o, "select[data-groups-pr-sl]", function () {
							t._updateItem(this)
						}),
							this.$form.on(o, "[data-groups-pr-ck]", function () {
								let n = e(this).closest(i)
									, o = n.index()
									, a = t.$form.find(`[data-groups-img="${o}"]`)
									, s = n.find('[name*="items[]"]');
								this.checked ? (n.addClass(r),
									t._updateItemPrice(n, o),
									a.fadeIn(300),
									s.prop("disabled", !1)) : (n.removeClass(r),
										t.ArrayPrice[o] = 0,
										t.ArrayComparePrice[o] = 0,
										a.fadeOut(300),
										s.prop("disabled", !0)),
									t._updateTotalPrice()
							}),
							this.$form.on(o, "[data-groups-qty-value]", function () {
								let n = e(this).closest(i)
									, o = n.index();
								t._updateItemPrice(n[0], o),
									t._updateTotalPrice()
							})
					},
					_updateItemPrice: function (t, n) {
						let i = e(t)
							, o = i.find("[data-groups-pr-sl]")
							, a = parseInt(i.find("[data-groups-qty-value]").val())
							, r = parseInt(o.attr("data-price"))
							, s = parseInt(o.attr("data-cpprice"));
						r *= a,
							s *= a,
							this.ArrayPrice[n] = r,
							this.ArrayComparePrice[n] = s > r ? s : r
					},
					_updateItem: function (t) {
						let n = e(t)
							, o = n.find(":selected")
							, a = n.closest(i)
							, r = a.index()
							, s = o.data("img")
							, l = o.data("max")
							, c = a.find("[data-groups-qty-value]")
							, d = c.val()
							, u = this.$form.find(`[data-groups-img="${r}"] img`)
							, p = parseInt(o.data("price"))
							, m = parseInt(o.data("cpprice"))
							, f = a.find("[data-groups-item-price]");
						c.attr("max", l),
							u.attr("data-orginal") != s && u.attr({
								"data-src": s,
								"data-orginal": s
							}).removeClass("lazyloadt4sed").addClass("lazyloadt4s"),
							m = m > p ? m : p,
							p *= d,
							m *= d,
							this.ArrayPrice[r] == p && this.ArrayComparePrice[r] == m || (n.attr({
								"data-price": p,
								"data-cpprice": m
							}),
								this.ArrayPrice[r] = p,
								this.ArrayComparePrice[r] = m,
								m > p ? f.html("<ins>" + T4SThemeSP.Currency.formatMoney(p) + "</ins> <del>" + T4SThemeSP.Currency.formatMoney(m) + "</del>") : f.html(T4SThemeSP.Currency.formatMoney(p)),
								this._updateTotalPrice())
					},
					_updateTotalPrice: function () {
						let e = this.ArrayPrice.reduce((e, t) => e + t, 0)
							, t = this.ArrayComparePrice.reduce((e, t) => e + t, 0);
						t > e ? this.$totalPrice.html("<ins>" + T4SThemeSP.Currency.formatMoney(e) + "</ins> <del>" + T4SThemeSP.Currency.formatMoney(t) + "</del>") : this.$totalPrice.html(T4SThemeSP.Currency.formatMoney(e)),
							a.trigger("currency:update")
					}
				}),
					t
			}(),
			T4SThemeSP.initGroupsProduct = function () {
				0 != e("[data-groups-pr-form]:not(.is--enabled)").length && e("[data-groups-pr-form]:not(.is--enabled)").each(function (t) {
					e(this).addClass("is--enabled"),
						new T4SThemeSP.GroupsProduct(this)
				})
			}
			,
			T4SThemeSP.goToID = function () {
				var t, n, i = "[data-go-id]", o = (e("html,body"),
					0);
				return function () {
					0 != (t = e(i)).length && t.click(function (t) {
						t.preventDefault(),
							t.stopPropagation();
						let i = e(this)
							, a = i.data("go-id") || i.attr("href")
							, r = e(a)
							, s = i.data("offset") || 100;
						0 != r.length && (r.is(":hidden") && (e(`[data-t4s-tab-item][href="${a}"]:visible`).trigger("click"),
							o = 100),
							clearTimeout(n),
							n = setTimeout(function () {
								window.scrollTo({
									behavior: "smooth",
									top: r.offset().top - s
								})
							}, o))
					})
				}
			}(),
			T4SThemeSP.CanvasConfetti = function () {
				function e(e) {
					var t, n;
					this.x = Math.random() * c,
						this.y = Math.random() * d - d,
						this.r = (t = 10,
							n = 30,
							Math.floor(Math.random() * (n - t + 1) + t)),
						this.d = Math.random() * m + 10,
						this.color = e,
						this.tilt = Math.floor(10 * Math.random()) - 10,
						this.tiltAngleIncremental = .07 * Math.random() + .05,
						this.tiltAngle = 0,
						this.draw = function () {
							return l.beginPath(),
								l.lineWidth = this.r / 2,
								l.strokeStyle = this.color,
								l.moveTo(this.x + this.tilt + this.r / 4, this.y),
								l.lineTo(this.x + this.tilt, this.y + this.tilt + this.r / 4),
								l.stroke()
						}
				}
				function t(e, t) {
					(e.x > c + 20 || e.x < -20 || e.y > d) && g && (t % 5 > 0 || t % 2 == 0 ? o(e, Math.random() * c, -10, Math.floor(10 * Math.random()) - 10) : Math.sin(h) > 0 ? o(e, -5, Math.random() * d, Math.floor(10 * Math.random()) - 10) : o(e, c + 5, Math.random() * d, Math.floor(10 * Math.random()) - 10))
				}
				function i(e, t) {
					e.tiltAngle += e.tiltAngleIncremental,
						e.y += (Math.cos(h + e.d) + 3 + e.r / 2) / 2,
						e.x += Math.sin(h),
						e.tilt = 15 * Math.sin(e.tiltAngle - t / 3)
				}
				function o(e, t, n, i) {
					e.x = t,
						e.y = n,
						e.tilt = i
				}
				function a() {
					clearTimeout(u),
						clearTimeout(p)
				}
				function r() {
					v = !0,
						null != l && (l.clearRect(0, 0, c, d),
							s.style.display = "none")
				}
				var s, l, c, d, u, p, m = window.innerWidth < 988 ? 75 : 150, f = [], h = 0, g = !0, v = !0, y = !1, w = {
					colorOptions: ["DodgerBlue", "OliveDrab", "Gold", "pink", "SlateBlue", "lightblue", "Violet", "PaleGreen", "SteelBlue", "SandyBrown", "Chocolate", "Crimson"],
					colorIndex: 0,
					colorIncrementer: 0,
					colorThreshold: 10,
					getColor: function () {
						return this.colorIncrementer >= 10 && (this.colorIncrementer = 0,
							this.colorIndex++,
							this.colorIndex >= this.colorOptions.length && (this.colorIndex = 0)),
							this.colorIncrementer++,
							this.colorOptions[this.colorIndex]
					}
				};
				return window.requestAnimFrameT4 = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e) {
					return window.setTimeout(e, 1e3 / 60)
				}
					,
					function () {
						if (y)
							return a(),
								r(),
								u = setTimeout(function () {
									g = !0,
										v = !1,
										function () {
											s.style.display = "block",
												f = [],
												v = !1;
											for (var n = 0; n < m; n++) {
												var o = w.getColor();
												f.push(new e(o))
											}
											c = window.innerWidth,
												d = window.innerHeight,
												s.width = c,
												s.height = d,
												function e() {
													return v ? null : (p = requestAnimFrameT4(e),
														function () {
															l.clearRect(0, 0, c, d);
															for (var e = [], n = 0; n < m; n++)
																o = n,
																	e.push(f[o].draw());
															var o;
															return function () {
																var e, n = 0;
																h += .01;
																for (var o = 0; o < m; o++) {
																	if (e = f[o],
																		v)
																		return;
																	!g && e.y < -15 ? e.y = d + 100 : (i(e, o),
																		e.y <= d && n++,
																		t(e, o))
																}
																0 === n && r()
															}(),
																e
														}())
												}()
										}()
								}, 100),
								void setTimeout(function () {
									g = !1,
										a()
								}, 3500);
						T4SThemeSP.$appendComponent.after('<canvas id="confettiCanvas" style="position:fixed;top:0;left:0;display:none;z-index:9999;pointer-events: none;"></canvas>'),
							s = document.getElementById("confettiCanvas"),
							l = s.getContext("2d"),
							c = window.innerWidth,
							d = window.innerHeight,
							s.width = c,
							s.height = d,
							n.resize(function () {
								c = window.innerWidth,
									d = window.innerHeight,
									s.width = c,
									s.height = d
							}),
							y = !0
					}
			}()
	}(jQuery_T4NT),


	jQuery_T4NT(document).ready(function () {
		T4SThemeSP.Drawer.init(),
			T4SThemeSP.Header.stickyInit(),
			T4SThemeSP.MobileNav(),
			T4SThemeSP.Cart.init(),
			T4SThemeSP.agreeForm(),
			T4SThemeSP.Login(),
			T4SThemeSP.Compare.init(),
			T4SThemeSP.Wishlist.init(),
			T4SThemeSP.recentlyViewed(),
			T4SThemeSP.productRecommendations(),
			T4SThemeSP.ProductItem.init(),
			T4SThemeSP.ProductItem.loadjsRevew(),
			T4SThemeSP.Tooltip(),
			T4SThemeSP.ProductItem.clickMoreSwatches(),
			T4SThemeSP.ProductItem.swatchesClickHover(),
			T4SThemeSP.ProductItem.resizeObserver(),
			T4SThemeSP.ProductItem.initQuickVS(),
			T4SThemeSP.RenderRefresh(),
			T4SThemeSP.ProductAjax.init(),
			T4SThemeSP.T4sQuantityAdjust(),
			T4SThemeSP.PhotoSwipe.gallery(),
			T4SThemeSP.PhotoSwipe.images(),
			T4SThemeSP.PhotoSwipe.image(),
			T4SThemeSP.Video.initPoster(),
			T4SThemeSP.initLoadMore(),
			jQuery_T4NT(".t4s-section-main [data-ntajax-container]").length > 0 && $script(T4Sconfigs.script7, "t4s:facets"),
			T4SThemeSP.instagram(),
			T4SThemeSP.sideBarInit(),
			T4SThemeSP.LookBook(),
			T4SThemeSP.initGroupsProduct(),
			IsDesignMode ? T4SThemeSP.PopupPro() : setTimeout(function () {
				T4SThemeSP.PopupFetch()
			}, 1500),
			setTimeout(function () {
				T4SThemeSP.PlatFormMail(),
					T4SThemeSP.goToID()
			}, 500),
			T4SThemeSP.isHover && jQuery_T4NT("[data-zoom-options]").length > 0 && $script(T4Sconfigs.script5, "t4s:zoom"),
			T4SThemeSP.BackToTop(),
			T4SThemeSP.Header.init(),
			T4SThemeSP.currencyForm(),
			"2" == T4Sconfigs.currency_type && $script(T4Sconfigs.script12a),
			"none" != T4Sconfigs.script11 && $script(T4Sconfigs.script11, "t4s:customjs"),
			document.dispatchEvent(new CustomEvent("T4SThemeSP:ready"));
	}),
	jQuery_T4NT(window).resize(function () {
		T4SThemeSP.ProductItem.recalculateSwatches(!0)
	});

// Synchronize a Custom section product grid with the nearest visible column on the same row.
(function initCustomSectionProductGridHeight() {
	const instanceKey = 't4sCustomSectionProductGridHeight';

	if (window[instanceKey]) {
		window[instanceKey].initialize(document);
		return;
	}

	const gridSelector = '[data-custom-product-grid].t4s-custom-product-grid--height-column';
	const grids = new Set();
	const states = new WeakMap();
	let frameId;

	const createResizeObserver = (callback) => {
		if ('ResizeObserver' in window) return new ResizeObserver(callback);
		return { observe() { }, disconnect() { } };
	};

	const isVisible = (element) => {
		return element && element.getClientRects().length > 0 && window.getComputedStyle(element).display !== 'none';
	};

	const getColumnContent = (column) => {
		return column?.querySelector(':scope > .t4s-col-inner > .t4s-w-100');
	};

	const findAdjacentColumnContent = (grid) => {
		const currentColumn = grid.closest('.t4s-custom-col');
		const row = currentColumn?.parentElement;

		if (!currentColumn || !row) return null;

		const columns = Array.from(row.children).filter((element) => {
			return element.classList.contains('t4s-custom-col') && isVisible(element);
		});
		const currentIndex = columns.indexOf(currentColumn);
		const currentTop = currentColumn.getBoundingClientRect().top;

		return columns
			.filter((column) => {
				if (column === currentColumn || column.querySelector(gridSelector)) return false;
				return Math.abs(column.getBoundingClientRect().top - currentTop) <= 2;
			})
			.sort((columnA, columnB) => {
				return Math.abs(columns.indexOf(columnA) - currentIndex) - Math.abs(columns.indexOf(columnB) - currentIndex);
			})
			.map(getColumnContent)
			.find((content) => isVisible(content)) || null;
	};

	const updateGrid = (grid) => {
		if (!grid.isConnected) {
			states.get(grid)?.observer?.disconnect();
			grids.delete(grid);
			return;
		}

		const source = findAdjacentColumnContent(grid);
		let state = states.get(grid);

		if (!state) {
			state = { source: null, observer: createResizeObserver(() => scheduleUpdate(grid)) };
			states.set(grid, state);
		}

		if (state.source !== source) {
			state.observer.disconnect();
			state.source = source;
			if (source) state.observer.observe(source);
		}

		const sourceHeight = source ? Math.round(source.getBoundingClientRect().height) : 0;

		if (sourceHeight > 0) {
			grid.style.setProperty('--product-grid-column-height', `${sourceHeight}px`);
		} else {
			grid.style.removeProperty('--product-grid-column-height');
		}
	};

	const scheduleUpdate = (grid) => {
		if (grid) grids.add(grid);
		window.cancelAnimationFrame(frameId);
		frameId = window.requestAnimationFrame(() => {
			grids.forEach(updateGrid);
		});
	};

	const initialize = (root = document) => {
		root.querySelectorAll(gridSelector).forEach((grid) => {
			grids.add(grid);
		});
		scheduleUpdate();
	};

	window[instanceKey] = { initialize, scheduleUpdate };

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
	} else {
		initialize();
	}

	window.addEventListener('resize', () => scheduleUpdate(), { passive: true });
	document.addEventListener('shopify:section:load', (event) => initialize(event.target));
	document.addEventListener('shopify:block:select', (event) => {
		const section = event.target instanceof Element ? event.target.closest('.shopify-section') : null;
		initialize(section || document);
	});
})();
